/* tslint:disable */
//  This file was automatically generated and should not be edited.

export type ClearCacheInput = {
  autoApplyId?: string | null,
  jobSeekerId?: string | null,
};

export type CreateJobInput = {
  id: string,
  companyId: string,
  roleType: WorkType,
  jobTitle: string,
  department: string,
  experience: ExperienceLevel,
  companyName: string,
  description: string,
  aboutUs: string,
  status: JobStatus,
  remotePolicy?: JobPolicy | null,
  timezonePolicy?: TimezonePolicy | null,
  paymentPlan?: PaymentPlan | null,
  digitalNomadFriendly?: boolean | null,
  timezoneRanges?: Array< TimezoneRangeInput | null > | null,
  officeFrequency?: OfficeFrequencyInput | null,
  officeLocations?: Array< CityLocationInput | null > | null,
  willSponsor?: boolean | null,
  communications?: CommunicationInfoInput | null,
  tags?: Array< JobTag | null > | null,
  wageIsHourly?: boolean | null,
  startSalaryRangeThousands?: number | null,
  endSalaryRangeThousands?: number | null,
  jobLogo?: string | null,
  scraped?: boolean | null,
  scrapedUrl?: string | null,
  scrapedSource?: string | null,
  remoteFirst?: boolean | null,
  flexibleHours?: boolean | null,
  missionDriven?: boolean | null,
  workFromAnywhere?: boolean | null,
  elite?: boolean | null,
  featured?: boolean | null,
  datePosted?: string | null,
  dateModified?: string | null,
};

export enum WorkType {
  FULLTIME = "FULLTIME",
  PARTTIME = "PARTTIME",
  CONTRACT = "CONTRACT",
}


export enum ExperienceLevel {
  INTERN = "INTERN",
  JUNIOR = "JUNIOR",
  MIDLEVEL = "MIDLEVEL",
  SENIOR = "SENIOR",
  EXECUTIVE = "EXECUTIVE",
}


export enum JobStatus {
  DRAFTPOLICY = "DRAFTPOLICY",
  DRAFTSETTINGS = "DRAFTSETTINGS",
  DRAFTCOMPLETE = "DRAFTCOMPLETE",
  LIVE = "LIVE",
  PAUSED = "PAUSED",
  CLOSED = "CLOSED",
}


export enum JobPolicy {
  FULLREMOTE = "FULLREMOTE",
  HYBRIDREMOTE = "HYBRIDREMOTE",
  REMOTEOPTIONAL = "REMOTEOPTIONAL",
  ONSITE = "ONSITE",
}


export enum TimezonePolicy {
  ALL = "ALL",
  SPECIFIC = "SPECIFIC",
}


export enum PaymentPlan {
  BASIC = "BASIC",
  STANDARD = "STANDARD",
  PREMIUM = "PREMIUM",
}


export type TimezoneRangeInput = {
  start?: number | null,
  end?: number | null,
};

export type OfficeFrequencyInput = {
  daysPerMonth?: number | null,
  daysPerWeek?: number | null,
};

export type CityLocationInput = {
  formatted_address: string,
  coordinate: LocationInput,
};

export type LocationInput = {
  lat: number,
  lon: number,
};

export type CommunicationInfoInput = {
  emails?: Array< string > | null,
  phone?: string | null,
};

export enum JobTag {
  SDR = "SDR",
  ACCOUNTEXECUTIVE = "ACCOUNTEXECUTIVE",
  ACCOUNTMANAGER = "ACCOUNTMANAGER",
}


export enum ApplicationStatus {
  NEEDS_REVIEW = "NEEDS_REVIEW",
  FAILED = "FAILED",
  PENDING = "PENDING",
  ENQUEUED = "ENQUEUED",
  ACCEPTED = "ACCEPTED",
  DECLINED = "DECLINED",
}


export enum Policy {
  FULLREMOTE = "FULLREMOTE",
  HYBRIDREMOTE = "HYBRIDREMOTE",
  REMOTEOPTIONAL = "REMOTEOPTIONAL",
  MIXEDPOLICIES = "MIXEDPOLICIES",
}


export enum NotificationSetting {
  NONE = "NONE",
  PHONE = "PHONE",
  EMAIL = "EMAIL",
  PHONEANDEMAIL = "PHONEANDEMAIL",
}


export enum AutoApplySub {
  BASIC = "BASIC",
  PROFESSIONAL = "PROFESSIONAL",
  PREMIUM = "PREMIUM",
  ULTIMATE = "ULTIMATE",
  ELITE = "ELITE",
}


export enum ApplicationQuestionType {
  INPUT = "INPUT",
  TEXTAREA = "TEXTAREA",
  RADIO = "RADIO",
  CHECKBOX = "CHECKBOX",
  SELECT = "SELECT",
  SELECT_ASYNC = "SELECT_ASYNC",
  FILE = "FILE",
}


export type UpdateJobInput = {
  id: string,
  companyId?: string | null,
  roleType?: WorkType | null,
  jobTitle?: string | null,
  department?: string | null,
  experience?: ExperienceLevel | null,
  companyName?: string | null,
  description?: string | null,
  aboutUs?: string | null,
  status?: JobStatus | null,
  remotePolicy?: JobPolicy | null,
  timezonePolicy?: TimezonePolicy | null,
  paymentPlan?: PaymentPlan | null,
  digitalNomadFriendly?: boolean | null,
  jobLogo?: string | null,
  tags?: Array< JobTag | null > | null,
  timezoneRanges?: Array< TimezoneRangeInput | null > | null,
  officeFrequency?: OfficeFrequencyInput | null,
  officeLocations?: Array< CityLocationInput | null > | null,
  willSponsor?: boolean | null,
  communications?: CommunicationInfoInput | null,
  featured?: boolean | null,
  featuredRank?: number | null,
  wageIsHourly?: boolean | null,
  startSalaryRangeThousands?: number | null,
  endSalaryRangeThousands?: number | null,
  remoteFirst?: boolean | null,
  flexibleHours?: boolean | null,
  missionDriven?: boolean | null,
  workFromAnywhere?: boolean | null,
  elite?: boolean | null,
  stripeId?: string | null,
  deleted?: boolean | null,
};

export type CompleteOnboardingInput = {
  userId: string,
};

export enum Stage {
  PRESEED = "PRESEED",
  SEED = "SEED",
  SERIESA = "SERIESA",
  SERIESB = "SERIESB",
  SERIESC = "SERIESC",
  SERIESD = "SERIESD",
  SERIESE = "SERIESE",
  PUBLIC = "PUBLIC",
}


export enum NotificationType {
  WELCOME = "WELCOME",
  AUTO_APPLY = "AUTO_APPLY",
  FREE_TRIAL = "FREE_TRIAL",
  FREE_TRIAL_EXPIRED = "FREE_TRIAL_EXPIRED",
  CONFIRM_INFORMATION = "CONFIRM_INFORMATION",
  INFORMATION_CONFIRMED = "INFORMATION_CONFIRMED",
  COMPLETE_PROFILE = "COMPLETE_PROFILE",
  CREATE_FIRST_JOB = "CREATE_FIRST_JOB",
  YOU_APPLIED = "YOU_APPLIED",
  APPLICATION_REVIEWED = "APPLICATION_REVIEWED",
  APPLICATION_ACCEPTED = "APPLICATION_ACCEPTED",
  APPLICATION_REJECTED = "APPLICATION_REJECTED",
  PEOPLE_APPLIED_TO_JOB = "PEOPLE_APPLIED_TO_JOB",
  JOB_PUBLISHED = "JOB_PUBLISHED",
  AUTOAPPLY_ISACTIVE = "AUTOAPPLY_ISACTIVE",
  AUTOAPPLY_CANCELLED = "AUTOAPPLY_CANCELLED",
  AUTOAPPLY_PAYMENTFAILED = "AUTOAPPLY_PAYMENTFAILED",
  AUTOAPPLY_RENEWED = "AUTOAPPLY_RENEWED",
  AUTOAPPLY_PAUSED = "AUTOAPPLY_PAUSED",
  AUTOAPPLY_RESUMED = "AUTOAPPLY_RESUMED",
  AUTOAPPLY_UPGRADED = "AUTOAPPLY_UPGRADED",
  AUTOAPPLY_APPLIED = "AUTOAPPLY_APPLIED",
}


// input NoteInput {
// id: ID!
// name: String!
// completed: Boolean!
// }
// input UpdateNoteInput {
// id: ID!
// name: String
// completed: Boolean
// }
export enum howDidYouFindUs {
  GOOGLE = "GOOGLE",
  FACEBOOK = "FACEBOOK",
  INSTAGRAM = "INSTAGRAM",
  LINKEDIN = "LINKEDIN",
  TIKTOK = "TIKTOK",
  TWITTER = "TWITTER",
  REDDIT = "REDDIT",
  FRIEND = "FRIEND",
  OTHER = "OTHER",
}


export enum EmploymentStatus {
  EMPLOYED = "EMPLOYED",
  UNEMPLOYED = "UNEMPLOYED",
  STUDENT = "STUDENT",
}


export enum JobSearchStage {
  GETTING_STARTED = "GETTING_STARTED",
  ACTIVELY_SEARCHING = "ACTIVELY_SEARCHING",
  PASSIVELY_SEARCHING = "PASSIVELY_SEARCHING",
}


export type EmployerProfileInput = {
  userId: string,
  industries?: Array< string | null > | null,
  remotePolicy?: Policy | null,
  name?: string | null,
  hasHeadquarters?: boolean | null,
  hqAddress?: CityLocationInput | null,
  bio?: string | null,
  emailAddress?: string | null,
  phoneNumber?: string | null,
  image?: string | null,
};

export type JobSeekerInput = {
  id: string,
  userId?: string | null,
  city?: CityLocationInput | null,
  newGradOrStudent?: boolean | null,
  linkedin?: string | null,
  website?: string | null,
  currentCompany?: string | null,
  currentTitle?: string | null,
  profileComplete?: boolean | null,
  fullTime?: boolean | null,
  partTime?: boolean | null,
  contractor?: boolean | null,
  fullRemote?: boolean | null,
  hybridRemote?: boolean | null,
  remoteOptional?: boolean | null,
  desiredRole?: string | null,
  salaryRequirement?: SalaryInput | null,
  authorization?: WorkAuthorizationInput | null,
  preferencesComplete?: boolean | null,
  workHistory?: Array< WorkHistoryInput | null > | null,
  educationHistory?: Array< EducationHistoryInput | null > | null,
  firstName?: string | null,
  recommendedJobsEmail?: boolean | null,
  newsletterEmail?: boolean | null,
  lastName?: string | null,
  notificationSettings?: NotificationSettingsInput | null,
  visibleToEmployers?: boolean | null,
  emailAddress?: string | null,
  phone?: string | null,
  profilePic?: string | null,
  experienceLevel?: ExperienceLevel | null,
  resume?: ResumeInput | null,
  autoResumes?: Array< ResumeInput | null > | null,
  dateCreated?: string | null,
  dateModified?: string | null,
  deleted?: boolean | null,
};

export type SalaryInput = {
  currencyCode?: string | null,
  value?: number | null,
};

export type WorkAuthorizationInput = {
  usAuthorized?: boolean | null,
  requireSponsorshipUS?: boolean | null,
};

export type WorkHistoryInput = {
  company: string,
  title: string,
  startDate: string,
  endDate?: string | null,
  currentJob: boolean,
  description?: string | null,
};

export type EducationHistoryInput = {
  institution: string,
  certification: string,
  concentration?: string | null,
  dateStarted: string,
  dateCompleted?: string | null,
  inProgress?: boolean | null,
  description?: string | null,
};

export type NotificationSettingsInput = {
  reviewsProfile?: NotificationSetting | null,
};

export type ResumeInput = {
  id: string,
  name: string,
  fileType: string,
  size: string,
  url: string,
  resumeJSON?: string | null,
  dateCreated: string,
  jobSeekerId?: string | null,
  dateUploaded: string,
  deleted?: boolean | null,
};

export type ApplyInput = {
  id: string,
  jobId: string,
  jobSeekerId: string,
};

export type UpdateApplicationInput = {
  id: string,
  applicationStatus?: ApplicationStatus | null,
};

export type FlaggedContentInput = {
  id: string,
  flaggedContentType: FlaggedContentType,
  contentID: string,
  description?: string | null,
};

export enum FlaggedContentType {
  JOBSEEKER = "JOBSEEKER",
  JOBPOSTING = "JOBPOSTING",
  COMPANY = "COMPANY",
}


export enum FlaggedContentActionTaken {
  NO_ACTION = "NO_ACTION",
  DISABLED_CONTENT = "DISABLED_CONTENT",
  ACCOUNT_SUSPENDED = "ACCOUNT_SUSPENDED",
}


export type CreateAutoApplyInput = {
  id?: string | null,
  jobSeekerId?: string | null,
  autoGenerateCoverLetter?: boolean | null,
  autoGenerateCoverLetterTone?: string | null,
  autoGenerateCoverLetterGreeting?: string | null,
  autoGenerateCoverLetterSignOff?: string | null,
  autoGenerateCoverLetterInstructions?: string | null,
  openToRelocation?: boolean | null,
  languagesSpoken?: Array< string | null > | null,
  age?: number | null,
  references?: Array< ReferenceInput | null > | null,
  genderIdentity?: string | null,
  blockedCompanyList?: Array< string | null > | null,
  coverLetter?: string | null,
  resumeText?: string | null,
  aiGenerateCoverLetter?: boolean | null,
  coverLetterTone?: string | null,
  draft?: boolean | null,
  remote?: boolean | null,
  hybrid?: boolean | null,
  onsite?: boolean | null,
  email?: string | null,
  jobTitles?: Array< string | null > | null,
  excludeCompanyNames?: Array< string | null > | null,
  negativeJobTitles?: Array< string | null > | null,
  industries?: Array< string | null > | null,
  education?: EducationHistoryInput | null,
  educationHistory?: Array< EducationHistoryInput | null > | null,
  experienceLevels?: Array< ExperienceLevel | null > | null,
  salaryMin?: number | null,
  salaryMax?: number | null,
  salaryRange?: string | null,
  plan?: AutoApplySub | null,
  applicationCount?: number | null,
  customPreference?: string | null,
  location?: CityLocationInput | null,
  autoLocations?: Array< AutoLocationInput | null > | null,
  country?: string | null,
  region?: string | null,
  area?: string | null,
  paymentFailed?: boolean | null,
  resumeUrl?: string | null,
  resumeName?: string | null,
  cancelled?: boolean | null,
  searchTags?: Array< string | null > | null,
  prompt?: string | null,
  firstName?: string | null,
  lastName?: string | null,
  phone?: string | null,
  address?: string | null,
  currentCompany?: string | null,
  linkedinProfile?: string | null,
  githubProfile?: string | null,
  website?: string | null,
  pronouns?: string | null,
  gender?: string | null,
  race?: string | null,
  appCountToday?: number | null,
  appCountDateUpdated?: string | null,
  maxPerDay?: number | null,
  maxPerCo?: number | null,
  veteran?: boolean | null,
  disabled?: boolean | null,
  hispanic?: boolean | null,
  countryAuthorization?: Array< CountryAuthorizationInput | null > | null,
  secretClearance?: boolean | null,
  trial?: boolean | null,
  searchCustomInstructions?: string | null,
};

export type ReferenceInput = {
  name?: string | null,
  email?: string | null,
  phone?: string | null,
  relationship?: string | null,
};

export type AutoLocationInput = {
  location?: CityLocationInput | null,
  country?: string | null,
  region?: string | null,
  area?: string | null,
};

export type CountryAuthorizationInput = {
  countryAuthorization?: string | null,
  authorizationType?: string | null,
  requiresSponsorship?: boolean | null,
};

export type UpdateAutoApplyInput = {
  id?: string | null,
  jobTitles?: Array< string | null > | null,
  industries?: Array< string | null > | null,
  autoGenerateCoverLetter?: boolean | null,
  autoGenerateCoverLetterTone?: string | null,
  autoGenerateCoverLetterGreeting?: string | null,
  autoGenerateCoverLetterSignOff?: string | null,
  autoGenerateCoverLetterInstructions?: string | null,
  customResumeOptions?: ResumeCustomizationOptionsInput | null,
  openToRelocation?: boolean | null,
  languagesSpoken?: Array< string | null > | null,
  age?: number | null,
  references?: Array< ReferenceInput | null > | null,
  genderIdentity?: string | null,
  blockedCompanyList?: Array< string | null > | null,
  coverLetter?: string | null,
  resumeText?: string | null,
  aiGenerateCoverLetter?: boolean | null,
  coverLetterTone?: string | null,
  draft?: boolean | null,
  remote?: boolean | null,
  hybrid?: boolean | null,
  onsite?: boolean | null,
  email?: string | null,
  negativeJobTitles?: Array< string | null > | null,
  excludeCompanyNames?: Array< string | null > | null,
  education?: EducationHistoryInput | null,
  educationHistory?: Array< EducationHistoryInput | null > | null,
  experienceLevels?: Array< ExperienceLevel | null > | null,
  autoLocations?: Array< AutoLocationInput | null > | null,
  location?: CityLocationInput | null,
  country?: string | null,
  region?: string | null,
  area?: string | null,
  salaryMin?: number | null,
  salaryMax?: number | null,
  salaryRange?: string | null,
  expiresAt?: string | null,
  customPreference?: string | null,
  plan?: AutoApplySub | null,
  applicationCount?: number | null,
  resumeUrl?: string | null,
  resumeName?: string | null,
  dateCreated?: string | null,
  cancelled?: boolean | null,
  searchTags?: Array< string | null > | null,
  prompt?: string | null,
  firstName?: string | null,
  lastName?: string | null,
  phone?: string | null,
  address?: string | null,
  currentCompany?: string | null,
  linkedinProfile?: string | null,
  githubProfile?: string | null,
  website?: string | null,
  paused?: boolean | null,
  gender?: string | null,
  pronouns?: string | null,
  appCountToday?: number | null,
  appCountDateUpdated?: string | null,
  maxPerDay?: number | null,
  maxPerCo?: number | null,
  race?: string | null,
  veteran?: boolean | null,
  disabled?: boolean | null,
  hispanic?: boolean | null,
  countryAuthorization?: Array< CountryAuthorizationInput | null > | null,
  secretClearance?: boolean | null,
  trial?: boolean | null,
  searchCustomInstructions?: string | null,
};

export type ResumeCustomizationOptionsInput = {
  shouldCustomize?: boolean | null,
  customInstructions?: string | null,
};

export type ExecutionCursorInput = {
  id: string,
  dateCreated?: string | null,
};

export type SearchInput = {
  text: string,
  fulltime?: string | null,
  parttime?: string | null,
  contract?: string | null,
  fullremote?: string | null,
  hybridremote?: string | null,
  remoteoptional?: string | null,
  onsite?: string | null,
  datePosted?: string | null,
  intern?: string | null,
  junior?: string | null,
  midlevel?: string | null,
  senior?: string | null,
  executive?: string | null,
  lat?: number | null,
  lon?: number | null,
  offset?: number | null,
  salaryMin?: number | null,
  remoteFirst?: boolean | null,
  flexibleHours?: boolean | null,
  missionDriven?: boolean | null,
  workFromAnywhere?: boolean | null,
  country?: string | null,
  region?: string | null,
  area?: string | null,
};

export type SearchJobsByTermInput = {
  text: string,
  salaryMin?: number | null,
  remoteFirst?: boolean | null,
  flexibleHours?: boolean | null,
  missionDriven?: boolean | null,
  workFromAnywhere?: boolean | null,
  fulltime?: string | null,
  parttime?: string | null,
  contract?: string | null,
  fullremote?: string | null,
  hybridremote?: string | null,
  remoteoptional?: string | null,
  onsite?: string | null,
  datePosted?: string | null,
  intern?: string | null,
  junior?: string | null,
  midlevel?: string | null,
  senior?: string | null,
  executive?: string | null,
  offset?: number | null,
};

export type SearchJobsByLocationInput = {
  lat: number,
  lon: number,
  country?: string | null,
  region?: string | null,
  area?: string | null,
  salaryMin?: number | null,
  remoteFirst?: boolean | null,
  flexibleHours?: boolean | null,
  missionDriven?: boolean | null,
  workFromAnywhere?: boolean | null,
  fulltime?: string | null,
  parttime?: string | null,
  contract?: string | null,
  fullremote?: string | null,
  hybridremote?: string | null,
  remoteoptional?: string | null,
  onsite?: string | null,
  datePosted?: string | null,
  intern?: string | null,
  junior?: string | null,
  midlevel?: string | null,
  senior?: string | null,
  executive?: string | null,
  offset?: number | null,
};

export type AutoSearchInput = {
  text: string,
  fulltime?: string | null,
  parttime?: string | null,
  contract?: string | null,
  fullremote?: string | null,
  hybridremote?: string | null,
  remoteoptional?: string | null,
  onsite?: string | null,
  datePosted?: string | null,
  intern?: string | null,
  junior?: string | null,
  midlevel?: string | null,
  senior?: string | null,
  executive?: string | null,
  lat?: number | null,
  lon?: number | null,
  offset?: number | null,
  salaryMin?: number | null,
  salaryMax?: number | null,
  remoteFirst?: boolean | null,
  flexibleHours?: boolean | null,
  missionDriven?: boolean | null,
  workFromAnywhere?: boolean | null,
  boostedTags?: string | null,
  country?: string | null,
  region?: string | null,
  area?: string | null,
  idsToOmit?: string | null,
};

export type FeaturedSearchInput = {
  term: string,
};

export type JobsByCompanySearch = {
  text: string,
  offset?: number | null,
};

export type ApplicationCursorInput = {
  id: string,
  jobSeekerId: string,
  dateApplied?: string | null,
};

export type ApplicationJobIdCursorInput = {
  id: string,
  jobId: string,
};

export type NotificationCursorInput = {
  id: string,
  userId: string,
  dateCreated?: string | null,
};

export type JobCursorInput = {
  id: string,
  companyId?: string | null,
};

export type CompanyCursorInput = {
  id: string,
  companyName?: string | null,
};

export type JobSeekerCursorInput = {
  id: string,
  userId?: string | null,
};

export type AutoCursorInput = {
  id: string,
  dateCreated?: string | null,
};

export type ClearCacheForJobSeekerMutationVariables = {
  input?: ClearCacheInput | null,
};

export type ClearCacheForJobSeekerMutation = {
  clearCacheForJobSeeker: boolean | null,
};

export type CreateJobMutationVariables = {
  job: CreateJobInput,
};

export type CreateJobMutation = {
  createJob:  {
    __typename: "Job",
    aboutUs: string,
    applications:  Array< {
      __typename: "Application",
      id: string,
      jobId: string,
      jobSeekerId: string,
      applicationStatus: ApplicationStatus | null,
      coverLetter: string | null,
      job:  {
        __typename: "Job",
        aboutUs: string,
        applications:  Array< {
          __typename: "Application",
          id: string,
          jobId: string,
          jobSeekerId: string,
          applicationStatus: ApplicationStatus | null,
          coverLetter: string | null,
          proof: string | null,
          isAuto: boolean | null,
          formScreenshot: string | null,
          confirmationScreenshot: string | null,
          generatedResumeUrl: string | null,
          dateApplied: string | null,
          dateAppliedIndex: string | null,
          dateUpdated: string | null,
        } | null > | null,
        applicationQuestions:  {
          __typename: "ApplicationQuestions",
          id: string,
          jobId: string,
        } | null,
        companyId: string,
        communications:  {
          __typename: "CommunicationInfo",
          emails: Array< string | null > | null,
          phone: string | null,
        } | null,
        companyProfile:  {
          __typename: "EmployerProfile",
          industries: Array< string | null > | null,
          remotePolicy: Policy | null,
          name: string | null,
          bio: string | null,
          hasHeadquarters: boolean | null,
          emailAddress: string | null,
          phoneNumber: string | null,
          image: string | null,
        } | null,
        companyWebsite: string | null,
        companyName: string,
        dateCreated: string | null,
        dateModified: string | null,
        datePosted: string | null,
        deleted: boolean | null,
        department: string,
        description: string,
        digitalNomadFriendly: boolean | null,
        elite: boolean | null,
        endSalaryRangeThousands: number | null,
        experience: ExperienceLevel,
        featured: boolean | null,
        featuredRank: number | null,
        flexibleHours: boolean | null,
        id: string,
        jobLogo: string | null,
        jobTitle: string,
        officeFrequency:  {
          __typename: "OfficeFrequency",
          daysPerMonth: number | null,
          daysPerWeek: number | null,
        } | null,
        officeLocations:  Array< {
          __typename: "CityLocation",
          formatted_address: string,
        } | null > | null,
        paymentHistory:  Array< {
          __typename: "PaymentRecord",
          stripeId: string,
          productId: string,
          paymentPlan: PaymentPlan,
          dateCreated: string,
          dateEnded: string | null,
        } | null > | null,
        paymentPlan: PaymentPlan | null,
        remoteFirst: boolean | null,
        remotePolicy: JobPolicy | null,
        roleType: WorkType,
        scraped: boolean | null,
        scrapedSource: string | null,
        scrapedUrl: string | null,
        startSalaryRangeThousands: number | null,
        status: JobStatus | null,
        stripeId: string | null,
        tags: Array< JobTag | null > | null,
        timezonePolicy: TimezonePolicy | null,
        timezoneRanges:  Array< {
          __typename: "TimezoneRange",
          start: number | null,
          end: number | null,
        } | null > | null,
        wageIsHourly: boolean | null,
        willSponsor: boolean | null,
        workFromAnywhere: boolean | null,
      } | null,
      applicant:  {
        __typename: "JobSeeker",
        id: string,
        userId: string | null,
        firstName: string | null,
        lastName: string | null,
        city:  {
          __typename: "CityLocation",
          formatted_address: string,
        } | null,
        newGradOrStudent: boolean | null,
        linkedin: string | null,
        website: string | null,
        currentCompany: string | null,
        currentTitle: string | null,
        fullTime: boolean | null,
        partTime: boolean | null,
        contractor: boolean | null,
        fullRemote: boolean | null,
        hybridRemote: boolean | null,
        remoteOptional: boolean | null,
        desiredRole: string | null,
        salaryRequirement:  {
          __typename: "Salary",
          currencyCode: string | null,
          value: number | null,
        } | null,
        authorization:  {
          __typename: "WorkAuthorization",
          usAuthorized: boolean | null,
          requireSponsorshipUS: boolean | null,
        } | null,
        recommendedJobsEmail: boolean | null,
        newsletterEmail: boolean | null,
        notificationSettings:  {
          __typename: "NotificationSettings",
          reviewsProfile: NotificationSetting | null,
        } | null,
        visibleToEmployers: boolean | null,
        emailAddress: string | null,
        phone: string | null,
        phoneVerified: boolean | null,
        profilePic: string | null,
        experienceLevel: ExperienceLevel | null,
        workHistory:  Array< {
          __typename: "WorkHistory",
          company: string,
          title: string,
          startDate: string,
          endDate: string | null,
          currentJob: boolean,
          description: string | null,
        } | null > | null,
        educationHistory:  Array< {
          __typename: "EducationHistory",
          institution: string,
          certification: string,
          concentration: string | null,
          dateStarted: string,
          dateCompleted: string | null,
          inProgress: boolean | null,
          description: string | null,
        } | null > | null,
        applications:  Array< {
          __typename: "Application",
          id: string,
          jobId: string,
          jobSeekerId: string,
          applicationStatus: ApplicationStatus | null,
          coverLetter: string | null,
          proof: string | null,
          isAuto: boolean | null,
          formScreenshot: string | null,
          confirmationScreenshot: string | null,
          generatedResumeUrl: string | null,
          dateApplied: string | null,
          dateAppliedIndex: string | null,
          dateUpdated: string | null,
        } | null > | null,
        resume:  {
          __typename: "Resume",
          id: string,
          name: string,
          fileType: string,
          size: string,
          url: string,
          resumeJSON: string | null,
          jobSeekerId: string | null,
          dateUploaded: string,
          dateCreated: string,
          deleted: boolean | null,
        } | null,
        autoResumes:  Array< {
          __typename: "Resume",
          id: string,
          name: string,
          fileType: string,
          size: string,
          url: string,
          resumeJSON: string | null,
          jobSeekerId: string | null,
          dateUploaded: string,
          dateCreated: string,
          deleted: boolean | null,
        } | null > | null,
        preferencesComplete: boolean | null,
        profileComplete: boolean | null,
        autoApply:  Array< {
          __typename: "AutoApply",
          id: string | null,
          jobSeekerId: string | null,
          subId: string | null,
          userId: string | null,
          autoGenerateCoverLetter: boolean | null,
          autoGenerateCoverLetterTone: string | null,
          autoGenerateCoverLetterGreeting: string | null,
          autoGenerateCoverLetterSignOff: string | null,
          autoGenerateCoverLetterInstructions: string | null,
          openToRelocation: boolean | null,
          languagesSpoken: Array< string | null > | null,
          age: number | null,
          genderIdentity: string | null,
          blockedCompanyList: Array< string | null > | null,
          resumeText: string | null,
          coverLetter: string | null,
          aiGenerateCoverLetter: boolean | null,
          coverLetterTone: string | null,
          draft: boolean | null,
          email: string | null,
          isActive: string | null,
          firstName: string | null,
          lastName: string | null,
          remote: boolean | null,
          hybrid: boolean | null,
          onsite: boolean | null,
          jobTitles: Array< string | null > | null,
          negativeJobTitles: Array< string | null > | null,
          industries: Array< string | null > | null,
          experienceLevels: Array< ExperienceLevel | null > | null,
          excludeCompanyNames: Array< string | null > | null,
          expiresAt: string | null,
          subscribedOn: string | null,
          plan: AutoApplySub | null,
          applicationCount: number | null,
          paymentFailed: boolean | null,
          country: string | null,
          region: string | null,
          area: string | null,
          customPreference: Array< string | null > | null,
          appliedUrls: Array< string | null > | null,
          salaryMin: number | null,
          salaryMax: number | null,
          salaryRange: string | null,
          searchTags: Array< string | null > | null,
          prompt: string | null,
          phone: string | null,
          address: string | null,
          currentCompany: string | null,
          linkedinProfile: string | null,
          githubProfile: string | null,
          website: string | null,
          gender: string | null,
          pronouns: string | null,
          hispanic: boolean | null,
          race: string | null,
          paused: boolean | null,
          disabled: boolean | null,
          veteran: boolean | null,
          secretClearance: boolean | null,
          appCountToday: number | null,
          appCountDateUpdated: string | null,
          maxPerDay: number | null,
          maxPerCo: number | null,
          hourToRun: number | null,
          minuteToRun: number | null,
          resumeUrl: string | null,
          resumeName: string | null,
          trial: boolean | null,
          trialExpired: boolean | null,
          gsiConstant: string | null,
          dateCreated: string | null,
          cancelled: boolean | null,
          searchCustomInstructions: string | null,
        } | null > | null,
        dateCreated: string | null,
        dateModified: string | null,
        deleted: boolean | null,
      } | null,
      proof: string | null,
      isAuto: boolean | null,
      formScreenshot: string | null,
      confirmationScreenshot: string | null,
      generatedResumeUrl: string | null,
      applicationAnswers:  {
        __typename: "ApplicationAnswers",
        id: string,
        applicationId: string,
        jobSeekerId: string,
        jobId: string,
        responses:  Array< {
          __typename: "ApplicationAnswer",
          id: string,
          question: string | null,
          answer: string | null,
          type: ApplicationQuestionType | null,
        } | null > | null,
        dateCreated: string | null,
        dateModified: string | null,
      } | null,
      resumeS3Params:  {
        __typename: "ResumeS3Params",
        bucket: string | null,
        key: string | null,
      } | null,
      dateApplied: string | null,
      dateAppliedIndex: string | null,
      dateUpdated: string | null,
    } | null > | null,
    applicationQuestions:  {
      __typename: "ApplicationQuestions",
      id: string,
      jobId: string,
      questions:  Array< {
        __typename: "ApplicationQuestion",
        question: string,
        type: ApplicationQuestionType,
        selector: string,
        options: Array< string | null > | null,
      } | null > | null,
    } | null,
    companyId: string,
    communications:  {
      __typename: "CommunicationInfo",
      emails: Array< string | null > | null,
      phone: string | null,
    } | null,
    companyProfile:  {
      __typename: "EmployerProfile",
      industries: Array< string | null > | null,
      remotePolicy: Policy | null,
      name: string | null,
      bio: string | null,
      hasHeadquarters: boolean | null,
      hqAddress:  {
        __typename: "CityLocation",
        formatted_address: string,
        coordinate:  {
          __typename: "Location",
          lat: number,
          lon: number,
        },
      } | null,
      emailAddress: string | null,
      phoneNumber: string | null,
      image: string | null,
    } | null,
    companyWebsite: string | null,
    companyName: string,
    dateCreated: string | null,
    dateModified: string | null,
    datePosted: string | null,
    deleted: boolean | null,
    department: string,
    description: string,
    digitalNomadFriendly: boolean | null,
    elite: boolean | null,
    endSalaryRangeThousands: number | null,
    experience: ExperienceLevel,
    featured: boolean | null,
    featuredRank: number | null,
    flexibleHours: boolean | null,
    id: string,
    jobLogo: string | null,
    jobTitle: string,
    officeFrequency:  {
      __typename: "OfficeFrequency",
      daysPerMonth: number | null,
      daysPerWeek: number | null,
    } | null,
    officeLocations:  Array< {
      __typename: "CityLocation",
      formatted_address: string,
      coordinate:  {
        __typename: "Location",
        lat: number,
        lon: number,
      },
    } | null > | null,
    paymentHistory:  Array< {
      __typename: "PaymentRecord",
      stripeId: string,
      productId: string,
      paymentPlan: PaymentPlan,
      dateCreated: string,
      dateEnded: string | null,
    } | null > | null,
    paymentPlan: PaymentPlan | null,
    remoteFirst: boolean | null,
    remotePolicy: JobPolicy | null,
    roleType: WorkType,
    scraped: boolean | null,
    scrapedSource: string | null,
    scrapedUrl: string | null,
    startSalaryRangeThousands: number | null,
    status: JobStatus | null,
    stripeId: string | null,
    tags: Array< JobTag | null > | null,
    timezonePolicy: TimezonePolicy | null,
    timezoneRanges:  Array< {
      __typename: "TimezoneRange",
      start: number | null,
      end: number | null,
    } | null > | null,
    wageIsHourly: boolean | null,
    willSponsor: boolean | null,
    workFromAnywhere: boolean | null,
  } | null,
};

export type UpdateJobMutationVariables = {
  job: UpdateJobInput,
};

export type UpdateJobMutation = {
  updateJob:  {
    __typename: "Job",
    aboutUs: string,
    applications:  Array< {
      __typename: "Application",
      id: string,
      jobId: string,
      jobSeekerId: string,
      applicationStatus: ApplicationStatus | null,
      coverLetter: string | null,
      job:  {
        __typename: "Job",
        aboutUs: string,
        applications:  Array< {
          __typename: "Application",
          id: string,
          jobId: string,
          jobSeekerId: string,
          applicationStatus: ApplicationStatus | null,
          coverLetter: string | null,
          proof: string | null,
          isAuto: boolean | null,
          formScreenshot: string | null,
          confirmationScreenshot: string | null,
          generatedResumeUrl: string | null,
          dateApplied: string | null,
          dateAppliedIndex: string | null,
          dateUpdated: string | null,
        } | null > | null,
        applicationQuestions:  {
          __typename: "ApplicationQuestions",
          id: string,
          jobId: string,
        } | null,
        companyId: string,
        communications:  {
          __typename: "CommunicationInfo",
          emails: Array< string | null > | null,
          phone: string | null,
        } | null,
        companyProfile:  {
          __typename: "EmployerProfile",
          industries: Array< string | null > | null,
          remotePolicy: Policy | null,
          name: string | null,
          bio: string | null,
          hasHeadquarters: boolean | null,
          emailAddress: string | null,
          phoneNumber: string | null,
          image: string | null,
        } | null,
        companyWebsite: string | null,
        companyName: string,
        dateCreated: string | null,
        dateModified: string | null,
        datePosted: string | null,
        deleted: boolean | null,
        department: string,
        description: string,
        digitalNomadFriendly: boolean | null,
        elite: boolean | null,
        endSalaryRangeThousands: number | null,
        experience: ExperienceLevel,
        featured: boolean | null,
        featuredRank: number | null,
        flexibleHours: boolean | null,
        id: string,
        jobLogo: string | null,
        jobTitle: string,
        officeFrequency:  {
          __typename: "OfficeFrequency",
          daysPerMonth: number | null,
          daysPerWeek: number | null,
        } | null,
        officeLocations:  Array< {
          __typename: "CityLocation",
          formatted_address: string,
        } | null > | null,
        paymentHistory:  Array< {
          __typename: "PaymentRecord",
          stripeId: string,
          productId: string,
          paymentPlan: PaymentPlan,
          dateCreated: string,
          dateEnded: string | null,
        } | null > | null,
        paymentPlan: PaymentPlan | null,
        remoteFirst: boolean | null,
        remotePolicy: JobPolicy | null,
        roleType: WorkType,
        scraped: boolean | null,
        scrapedSource: string | null,
        scrapedUrl: string | null,
        startSalaryRangeThousands: number | null,
        status: JobStatus | null,
        stripeId: string | null,
        tags: Array< JobTag | null > | null,
        timezonePolicy: TimezonePolicy | null,
        timezoneRanges:  Array< {
          __typename: "TimezoneRange",
          start: number | null,
          end: number | null,
        } | null > | null,
        wageIsHourly: boolean | null,
        willSponsor: boolean | null,
        workFromAnywhere: boolean | null,
      } | null,
      applicant:  {
        __typename: "JobSeeker",
        id: string,
        userId: string | null,
        firstName: string | null,
        lastName: string | null,
        city:  {
          __typename: "CityLocation",
          formatted_address: string,
        } | null,
        newGradOrStudent: boolean | null,
        linkedin: string | null,
        website: string | null,
        currentCompany: string | null,
        currentTitle: string | null,
        fullTime: boolean | null,
        partTime: boolean | null,
        contractor: boolean | null,
        fullRemote: boolean | null,
        hybridRemote: boolean | null,
        remoteOptional: boolean | null,
        desiredRole: string | null,
        salaryRequirement:  {
          __typename: "Salary",
          currencyCode: string | null,
          value: number | null,
        } | null,
        authorization:  {
          __typename: "WorkAuthorization",
          usAuthorized: boolean | null,
          requireSponsorshipUS: boolean | null,
        } | null,
        recommendedJobsEmail: boolean | null,
        newsletterEmail: boolean | null,
        notificationSettings:  {
          __typename: "NotificationSettings",
          reviewsProfile: NotificationSetting | null,
        } | null,
        visibleToEmployers: boolean | null,
        emailAddress: string | null,
        phone: string | null,
        phoneVerified: boolean | null,
        profilePic: string | null,
        experienceLevel: ExperienceLevel | null,
        workHistory:  Array< {
          __typename: "WorkHistory",
          company: string,
          title: string,
          startDate: string,
          endDate: string | null,
          currentJob: boolean,
          description: string | null,
        } | null > | null,
        educationHistory:  Array< {
          __typename: "EducationHistory",
          institution: string,
          certification: string,
          concentration: string | null,
          dateStarted: string,
          dateCompleted: string | null,
          inProgress: boolean | null,
          description: string | null,
        } | null > | null,
        applications:  Array< {
          __typename: "Application",
          id: string,
          jobId: string,
          jobSeekerId: string,
          applicationStatus: ApplicationStatus | null,
          coverLetter: string | null,
          proof: string | null,
          isAuto: boolean | null,
          formScreenshot: string | null,
          confirmationScreenshot: string | null,
          generatedResumeUrl: string | null,
          dateApplied: string | null,
          dateAppliedIndex: string | null,
          dateUpdated: string | null,
        } | null > | null,
        resume:  {
          __typename: "Resume",
          id: string,
          name: string,
          fileType: string,
          size: string,
          url: string,
          resumeJSON: string | null,
          jobSeekerId: string | null,
          dateUploaded: string,
          dateCreated: string,
          deleted: boolean | null,
        } | null,
        autoResumes:  Array< {
          __typename: "Resume",
          id: string,
          name: string,
          fileType: string,
          size: string,
          url: string,
          resumeJSON: string | null,
          jobSeekerId: string | null,
          dateUploaded: string,
          dateCreated: string,
          deleted: boolean | null,
        } | null > | null,
        preferencesComplete: boolean | null,
        profileComplete: boolean | null,
        autoApply:  Array< {
          __typename: "AutoApply",
          id: string | null,
          jobSeekerId: string | null,
          subId: string | null,
          userId: string | null,
          autoGenerateCoverLetter: boolean | null,
          autoGenerateCoverLetterTone: string | null,
          autoGenerateCoverLetterGreeting: string | null,
          autoGenerateCoverLetterSignOff: string | null,
          autoGenerateCoverLetterInstructions: string | null,
          openToRelocation: boolean | null,
          languagesSpoken: Array< string | null > | null,
          age: number | null,
          genderIdentity: string | null,
          blockedCompanyList: Array< string | null > | null,
          resumeText: string | null,
          coverLetter: string | null,
          aiGenerateCoverLetter: boolean | null,
          coverLetterTone: string | null,
          draft: boolean | null,
          email: string | null,
          isActive: string | null,
          firstName: string | null,
          lastName: string | null,
          remote: boolean | null,
          hybrid: boolean | null,
          onsite: boolean | null,
          jobTitles: Array< string | null > | null,
          negativeJobTitles: Array< string | null > | null,
          industries: Array< string | null > | null,
          experienceLevels: Array< ExperienceLevel | null > | null,
          excludeCompanyNames: Array< string | null > | null,
          expiresAt: string | null,
          subscribedOn: string | null,
          plan: AutoApplySub | null,
          applicationCount: number | null,
          paymentFailed: boolean | null,
          country: string | null,
          region: string | null,
          area: string | null,
          customPreference: Array< string | null > | null,
          appliedUrls: Array< string | null > | null,
          salaryMin: number | null,
          salaryMax: number | null,
          salaryRange: string | null,
          searchTags: Array< string | null > | null,
          prompt: string | null,
          phone: string | null,
          address: string | null,
          currentCompany: string | null,
          linkedinProfile: string | null,
          githubProfile: string | null,
          website: string | null,
          gender: string | null,
          pronouns: string | null,
          hispanic: boolean | null,
          race: string | null,
          paused: boolean | null,
          disabled: boolean | null,
          veteran: boolean | null,
          secretClearance: boolean | null,
          appCountToday: number | null,
          appCountDateUpdated: string | null,
          maxPerDay: number | null,
          maxPerCo: number | null,
          hourToRun: number | null,
          minuteToRun: number | null,
          resumeUrl: string | null,
          resumeName: string | null,
          trial: boolean | null,
          trialExpired: boolean | null,
          gsiConstant: string | null,
          dateCreated: string | null,
          cancelled: boolean | null,
          searchCustomInstructions: string | null,
        } | null > | null,
        dateCreated: string | null,
        dateModified: string | null,
        deleted: boolean | null,
      } | null,
      proof: string | null,
      isAuto: boolean | null,
      formScreenshot: string | null,
      confirmationScreenshot: string | null,
      generatedResumeUrl: string | null,
      applicationAnswers:  {
        __typename: "ApplicationAnswers",
        id: string,
        applicationId: string,
        jobSeekerId: string,
        jobId: string,
        responses:  Array< {
          __typename: "ApplicationAnswer",
          id: string,
          question: string | null,
          answer: string | null,
          type: ApplicationQuestionType | null,
        } | null > | null,
        dateCreated: string | null,
        dateModified: string | null,
      } | null,
      resumeS3Params:  {
        __typename: "ResumeS3Params",
        bucket: string | null,
        key: string | null,
      } | null,
      dateApplied: string | null,
      dateAppliedIndex: string | null,
      dateUpdated: string | null,
    } | null > | null,
    applicationQuestions:  {
      __typename: "ApplicationQuestions",
      id: string,
      jobId: string,
      questions:  Array< {
        __typename: "ApplicationQuestion",
        question: string,
        type: ApplicationQuestionType,
        selector: string,
        options: Array< string | null > | null,
      } | null > | null,
    } | null,
    companyId: string,
    communications:  {
      __typename: "CommunicationInfo",
      emails: Array< string | null > | null,
      phone: string | null,
    } | null,
    companyProfile:  {
      __typename: "EmployerProfile",
      industries: Array< string | null > | null,
      remotePolicy: Policy | null,
      name: string | null,
      bio: string | null,
      hasHeadquarters: boolean | null,
      hqAddress:  {
        __typename: "CityLocation",
        formatted_address: string,
        coordinate:  {
          __typename: "Location",
          lat: number,
          lon: number,
        },
      } | null,
      emailAddress: string | null,
      phoneNumber: string | null,
      image: string | null,
    } | null,
    companyWebsite: string | null,
    companyName: string,
    dateCreated: string | null,
    dateModified: string | null,
    datePosted: string | null,
    deleted: boolean | null,
    department: string,
    description: string,
    digitalNomadFriendly: boolean | null,
    elite: boolean | null,
    endSalaryRangeThousands: number | null,
    experience: ExperienceLevel,
    featured: boolean | null,
    featuredRank: number | null,
    flexibleHours: boolean | null,
    id: string,
    jobLogo: string | null,
    jobTitle: string,
    officeFrequency:  {
      __typename: "OfficeFrequency",
      daysPerMonth: number | null,
      daysPerWeek: number | null,
    } | null,
    officeLocations:  Array< {
      __typename: "CityLocation",
      formatted_address: string,
      coordinate:  {
        __typename: "Location",
        lat: number,
        lon: number,
      },
    } | null > | null,
    paymentHistory:  Array< {
      __typename: "PaymentRecord",
      stripeId: string,
      productId: string,
      paymentPlan: PaymentPlan,
      dateCreated: string,
      dateEnded: string | null,
    } | null > | null,
    paymentPlan: PaymentPlan | null,
    remoteFirst: boolean | null,
    remotePolicy: JobPolicy | null,
    roleType: WorkType,
    scraped: boolean | null,
    scrapedSource: string | null,
    scrapedUrl: string | null,
    startSalaryRangeThousands: number | null,
    status: JobStatus | null,
    stripeId: string | null,
    tags: Array< JobTag | null > | null,
    timezonePolicy: TimezonePolicy | null,
    timezoneRanges:  Array< {
      __typename: "TimezoneRange",
      start: number | null,
      end: number | null,
    } | null > | null,
    wageIsHourly: boolean | null,
    willSponsor: boolean | null,
    workFromAnywhere: boolean | null,
  } | null,
};

export type SetOnboardingCompleteMutationVariables = {
  onboardingInput?: CompleteOnboardingInput | null,
};

export type SetOnboardingCompleteMutation = {
  setOnboardingComplete:  {
    __typename: "User",
    id: string,
    email: string | null,
    emailVerified: boolean | null,
    phoneVerified: boolean | null,
    companyId: string | null,
    group: string | null,
    onboardingCompleted: boolean | null,
    firstName: string | null,
    lastName: string | null,
    age: number | null,
    company:  {
      __typename: "Company",
      id: string,
      dateCreated: string,
      dateModified: string,
      ownerId: string,
      ownerEmail: string,
      profile:  {
        __typename: "EmployerProfile",
        industries: Array< string | null > | null,
        remotePolicy: Policy | null,
        name: string | null,
        bio: string | null,
        hasHeadquarters: boolean | null,
        hqAddress:  {
          __typename: "CityLocation",
          formatted_address: string,
        } | null,
        emailAddress: string | null,
        phoneNumber: string | null,
        image: string | null,
      } | null,
      publicProfile:  {
        __typename: "CompanyProfile",
        id: string,
        builtId: string | null,
        companyAlias: string | null,
        readableName: string | null,
        description: string,
        headCount: string | null,
        website: string | null,
        careerPage: string | null,
        stage: Stage | null,
        isPublic: boolean | null,
        headquarters: string | null,
        valueMillions: number | null,
        isUnicorn: boolean | null,
        isRemoteFirst: boolean | null,
        isHybrid: boolean | null,
        isMixed: boolean | null,
        workFromAnywhere: boolean | null,
        hasFlexibleHours: boolean | null,
        isMissionDriven: boolean | null,
        linkedinUrl: string | null,
        crunchbaseUrl: string | null,
        glassdoorUrl: string | null,
      } | null,
      jobPostings:  Array< {
        __typename: "Job",
        aboutUs: string,
        applications:  Array< {
          __typename: "Application",
          id: string,
          jobId: string,
          jobSeekerId: string,
          applicationStatus: ApplicationStatus | null,
          coverLetter: string | null,
          proof: string | null,
          isAuto: boolean | null,
          formScreenshot: string | null,
          confirmationScreenshot: string | null,
          generatedResumeUrl: string | null,
          dateApplied: string | null,
          dateAppliedIndex: string | null,
          dateUpdated: string | null,
        } | null > | null,
        applicationQuestions:  {
          __typename: "ApplicationQuestions",
          id: string,
          jobId: string,
        } | null,
        companyId: string,
        communications:  {
          __typename: "CommunicationInfo",
          emails: Array< string | null > | null,
          phone: string | null,
        } | null,
        companyProfile:  {
          __typename: "EmployerProfile",
          industries: Array< string | null > | null,
          remotePolicy: Policy | null,
          name: string | null,
          bio: string | null,
          hasHeadquarters: boolean | null,
          emailAddress: string | null,
          phoneNumber: string | null,
          image: string | null,
        } | null,
        companyWebsite: string | null,
        companyName: string,
        dateCreated: string | null,
        dateModified: string | null,
        datePosted: string | null,
        deleted: boolean | null,
        department: string,
        description: string,
        digitalNomadFriendly: boolean | null,
        elite: boolean | null,
        endSalaryRangeThousands: number | null,
        experience: ExperienceLevel,
        featured: boolean | null,
        featuredRank: number | null,
        flexibleHours: boolean | null,
        id: string,
        jobLogo: string | null,
        jobTitle: string,
        officeFrequency:  {
          __typename: "OfficeFrequency",
          daysPerMonth: number | null,
          daysPerWeek: number | null,
        } | null,
        officeLocations:  Array< {
          __typename: "CityLocation",
          formatted_address: string,
        } | null > | null,
        paymentHistory:  Array< {
          __typename: "PaymentRecord",
          stripeId: string,
          productId: string,
          paymentPlan: PaymentPlan,
          dateCreated: string,
          dateEnded: string | null,
        } | null > | null,
        paymentPlan: PaymentPlan | null,
        remoteFirst: boolean | null,
        remotePolicy: JobPolicy | null,
        roleType: WorkType,
        scraped: boolean | null,
        scrapedSource: string | null,
        scrapedUrl: string | null,
        startSalaryRangeThousands: number | null,
        status: JobStatus | null,
        stripeId: string | null,
        tags: Array< JobTag | null > | null,
        timezonePolicy: TimezonePolicy | null,
        timezoneRanges:  Array< {
          __typename: "TimezoneRange",
          start: number | null,
          end: number | null,
        } | null > | null,
        wageIsHourly: boolean | null,
        willSponsor: boolean | null,
        workFromAnywhere: boolean | null,
      } | null > | null,
      signupPromo: string | null,
      website: string | null,
      deleted: boolean | null,
    } | null,
    jobSeeker:  {
      __typename: "JobSeeker",
      id: string,
      userId: string | null,
      firstName: string | null,
      lastName: string | null,
      city:  {
        __typename: "CityLocation",
        formatted_address: string,
        coordinate:  {
          __typename: "Location",
          lat: number,
          lon: number,
        },
      } | null,
      newGradOrStudent: boolean | null,
      linkedin: string | null,
      website: string | null,
      currentCompany: string | null,
      currentTitle: string | null,
      fullTime: boolean | null,
      partTime: boolean | null,
      contractor: boolean | null,
      fullRemote: boolean | null,
      hybridRemote: boolean | null,
      remoteOptional: boolean | null,
      desiredRole: string | null,
      salaryRequirement:  {
        __typename: "Salary",
        currencyCode: string | null,
        value: number | null,
      } | null,
      authorization:  {
        __typename: "WorkAuthorization",
        usAuthorized: boolean | null,
        requireSponsorshipUS: boolean | null,
      } | null,
      recommendedJobsEmail: boolean | null,
      newsletterEmail: boolean | null,
      notificationSettings:  {
        __typename: "NotificationSettings",
        reviewsProfile: NotificationSetting | null,
      } | null,
      visibleToEmployers: boolean | null,
      emailAddress: string | null,
      phone: string | null,
      phoneVerified: boolean | null,
      profilePic: string | null,
      experienceLevel: ExperienceLevel | null,
      workHistory:  Array< {
        __typename: "WorkHistory",
        company: string,
        title: string,
        startDate: string,
        endDate: string | null,
        currentJob: boolean,
        description: string | null,
      } | null > | null,
      educationHistory:  Array< {
        __typename: "EducationHistory",
        institution: string,
        certification: string,
        concentration: string | null,
        dateStarted: string,
        dateCompleted: string | null,
        inProgress: boolean | null,
        description: string | null,
      } | null > | null,
      applications:  Array< {
        __typename: "Application",
        id: string,
        jobId: string,
        jobSeekerId: string,
        applicationStatus: ApplicationStatus | null,
        coverLetter: string | null,
        job:  {
          __typename: "Job",
          aboutUs: string,
          companyId: string,
          companyWebsite: string | null,
          companyName: string,
          dateCreated: string | null,
          dateModified: string | null,
          datePosted: string | null,
          deleted: boolean | null,
          department: string,
          description: string,
          digitalNomadFriendly: boolean | null,
          elite: boolean | null,
          endSalaryRangeThousands: number | null,
          experience: ExperienceLevel,
          featured: boolean | null,
          featuredRank: number | null,
          flexibleHours: boolean | null,
          id: string,
          jobLogo: string | null,
          jobTitle: string,
          paymentPlan: PaymentPlan | null,
          remoteFirst: boolean | null,
          remotePolicy: JobPolicy | null,
          roleType: WorkType,
          scraped: boolean | null,
          scrapedSource: string | null,
          scrapedUrl: string | null,
          startSalaryRangeThousands: number | null,
          status: JobStatus | null,
          stripeId: string | null,
          tags: Array< JobTag | null > | null,
          timezonePolicy: TimezonePolicy | null,
          wageIsHourly: boolean | null,
          willSponsor: boolean | null,
          workFromAnywhere: boolean | null,
        } | null,
        applicant:  {
          __typename: "JobSeeker",
          id: string,
          userId: string | null,
          firstName: string | null,
          lastName: string | null,
          newGradOrStudent: boolean | null,
          linkedin: string | null,
          website: string | null,
          currentCompany: string | null,
          currentTitle: string | null,
          fullTime: boolean | null,
          partTime: boolean | null,
          contractor: boolean | null,
          fullRemote: boolean | null,
          hybridRemote: boolean | null,
          remoteOptional: boolean | null,
          desiredRole: string | null,
          recommendedJobsEmail: boolean | null,
          newsletterEmail: boolean | null,
          visibleToEmployers: boolean | null,
          emailAddress: string | null,
          phone: string | null,
          phoneVerified: boolean | null,
          profilePic: string | null,
          experienceLevel: ExperienceLevel | null,
          preferencesComplete: boolean | null,
          profileComplete: boolean | null,
          dateCreated: string | null,
          dateModified: string | null,
          deleted: boolean | null,
        } | null,
        proof: string | null,
        isAuto: boolean | null,
        formScreenshot: string | null,
        confirmationScreenshot: string | null,
        generatedResumeUrl: string | null,
        applicationAnswers:  {
          __typename: "ApplicationAnswers",
          id: string,
          applicationId: string,
          jobSeekerId: string,
          jobId: string,
          dateCreated: string | null,
          dateModified: string | null,
        } | null,
        resumeS3Params:  {
          __typename: "ResumeS3Params",
          bucket: string | null,
          key: string | null,
        } | null,
        dateApplied: string | null,
        dateAppliedIndex: string | null,
        dateUpdated: string | null,
      } | null > | null,
      resume:  {
        __typename: "Resume",
        id: string,
        name: string,
        fileType: string,
        size: string,
        url: string,
        resumeJSON: string | null,
        jobSeekerId: string | null,
        dateUploaded: string,
        dateCreated: string,
        deleted: boolean | null,
      } | null,
      autoResumes:  Array< {
        __typename: "Resume",
        id: string,
        name: string,
        fileType: string,
        size: string,
        url: string,
        resumeJSON: string | null,
        jobSeekerId: string | null,
        dateUploaded: string,
        dateCreated: string,
        deleted: boolean | null,
      } | null > | null,
      preferencesComplete: boolean | null,
      profileComplete: boolean | null,
      autoApply:  Array< {
        __typename: "AutoApply",
        id: string | null,
        jobSeekerId: string | null,
        subId: string | null,
        userId: string | null,
        autoGenerateCoverLetter: boolean | null,
        autoGenerateCoverLetterTone: string | null,
        autoGenerateCoverLetterGreeting: string | null,
        autoGenerateCoverLetterSignOff: string | null,
        autoGenerateCoverLetterInstructions: string | null,
        customResumeOptions:  {
          __typename: "ResumeCustomizationOptions",
          shouldCustomize: boolean | null,
          customInstructions: string | null,
        } | null,
        openToRelocation: boolean | null,
        languagesSpoken: Array< string | null > | null,
        age: number | null,
        references:  Array< {
          __typename: "Reference",
          name: string | null,
          email: string | null,
          phone: string | null,
          relationship: string | null,
        } | null > | null,
        genderIdentity: string | null,
        blockedCompanyList: Array< string | null > | null,
        resumeText: string | null,
        coverLetter: string | null,
        aiGenerateCoverLetter: boolean | null,
        coverLetterTone: string | null,
        draft: boolean | null,
        email: string | null,
        isActive: string | null,
        firstName: string | null,
        lastName: string | null,
        remote: boolean | null,
        hybrid: boolean | null,
        onsite: boolean | null,
        jobTitles: Array< string | null > | null,
        negativeJobTitles: Array< string | null > | null,
        industries: Array< string | null > | null,
        education:  {
          __typename: "EducationHistory",
          institution: string,
          certification: string,
          concentration: string | null,
          dateStarted: string,
          dateCompleted: string | null,
          inProgress: boolean | null,
          description: string | null,
        } | null,
        educationHistory:  Array< {
          __typename: "EducationHistory",
          institution: string,
          certification: string,
          concentration: string | null,
          dateStarted: string,
          dateCompleted: string | null,
          inProgress: boolean | null,
          description: string | null,
        } | null > | null,
        experienceLevels: Array< ExperienceLevel | null > | null,
        excludeCompanyNames: Array< string | null > | null,
        expiresAt: string | null,
        subscribedOn: string | null,
        plan: AutoApplySub | null,
        applicationCount: number | null,
        paymentFailed: boolean | null,
        autoLocations:  Array< {
          __typename: "AutoLocation",
          country: string | null,
          region: string | null,
          area: string | null,
        } | null > | null,
        location:  {
          __typename: "CityLocation",
          formatted_address: string,
        } | null,
        country: string | null,
        region: string | null,
        area: string | null,
        customPreference: Array< string | null > | null,
        appliedUrls: Array< string | null > | null,
        salaryMin: number | null,
        salaryMax: number | null,
        salaryRange: string | null,
        searchTags: Array< string | null > | null,
        prompt: string | null,
        phone: string | null,
        address: string | null,
        currentCompany: string | null,
        linkedinProfile: string | null,
        githubProfile: string | null,
        website: string | null,
        gender: string | null,
        pronouns: string | null,
        hispanic: boolean | null,
        race: string | null,
        paused: boolean | null,
        disabled: boolean | null,
        veteran: boolean | null,
        countryAuthorization:  Array< {
          __typename: "CountryAuthorization",
          countryAuthorization: string | null,
          authorizationType: string | null,
          requiresSponsorship: boolean | null,
        } | null > | null,
        secretClearance: boolean | null,
        appCountToday: number | null,
        appCountDateUpdated: string | null,
        maxPerDay: number | null,
        maxPerCo: number | null,
        hourToRun: number | null,
        minuteToRun: number | null,
        resumeUrl: string | null,
        resumeName: string | null,
        trial: boolean | null,
        trialExpired: boolean | null,
        gsiConstant: string | null,
        dateCreated: string | null,
        cancelled: boolean | null,
        searchCustomInstructions: string | null,
      } | null > | null,
      dateCreated: string | null,
      dateModified: string | null,
      deleted: boolean | null,
    } | null,
    notifications:  Array< {
      __typename: "Notification",
      id: string,
      notificationType: NotificationType | null,
      message: string | null,
      textMessage: string | null,
      userId: string,
      url: string | null,
      read: boolean | null,
      dateCreated: string | null,
      dateRead: string | null,
    } | null > | null,
    trailUsed: boolean | null,
    howDidYouFindUs: howDidYouFindUs | null,
    howDidYouFindUsOther: string | null,
    employmentStatus: EmploymentStatus | null,
    jobSearchStage: JobSearchStage | null,
    interviewCount: number | null,
    deleted: boolean | null,
  } | null,
};

export type UpdateEmployerProfileMutationVariables = {
  employerProfileInput?: EmployerProfileInput | null,
};

export type UpdateEmployerProfileMutation = {
  updateEmployerProfile:  {
    __typename: "Company",
    id: string,
    dateCreated: string,
    dateModified: string,
    ownerId: string,
    ownerEmail: string,
    profile:  {
      __typename: "EmployerProfile",
      industries: Array< string | null > | null,
      remotePolicy: Policy | null,
      name: string | null,
      bio: string | null,
      hasHeadquarters: boolean | null,
      hqAddress:  {
        __typename: "CityLocation",
        formatted_address: string,
        coordinate:  {
          __typename: "Location",
          lat: number,
          lon: number,
        },
      } | null,
      emailAddress: string | null,
      phoneNumber: string | null,
      image: string | null,
    } | null,
    publicProfile:  {
      __typename: "CompanyProfile",
      id: string,
      builtId: string | null,
      companyAlias: string | null,
      readableName: string | null,
      description: string,
      headCount: string | null,
      website: string | null,
      careerPage: string | null,
      stage: Stage | null,
      isPublic: boolean | null,
      headquarters: string | null,
      valueMillions: number | null,
      isUnicorn: boolean | null,
      isRemoteFirst: boolean | null,
      isHybrid: boolean | null,
      isMixed: boolean | null,
      workFromAnywhere: boolean | null,
      hasFlexibleHours: boolean | null,
      isMissionDriven: boolean | null,
      linkedinUrl: string | null,
      crunchbaseUrl: string | null,
      glassdoorUrl: string | null,
    } | null,
    jobPostings:  Array< {
      __typename: "Job",
      aboutUs: string,
      applications:  Array< {
        __typename: "Application",
        id: string,
        jobId: string,
        jobSeekerId: string,
        applicationStatus: ApplicationStatus | null,
        coverLetter: string | null,
        job:  {
          __typename: "Job",
          aboutUs: string,
          companyId: string,
          companyWebsite: string | null,
          companyName: string,
          dateCreated: string | null,
          dateModified: string | null,
          datePosted: string | null,
          deleted: boolean | null,
          department: string,
          description: string,
          digitalNomadFriendly: boolean | null,
          elite: boolean | null,
          endSalaryRangeThousands: number | null,
          experience: ExperienceLevel,
          featured: boolean | null,
          featuredRank: number | null,
          flexibleHours: boolean | null,
          id: string,
          jobLogo: string | null,
          jobTitle: string,
          paymentPlan: PaymentPlan | null,
          remoteFirst: boolean | null,
          remotePolicy: JobPolicy | null,
          roleType: WorkType,
          scraped: boolean | null,
          scrapedSource: string | null,
          scrapedUrl: string | null,
          startSalaryRangeThousands: number | null,
          status: JobStatus | null,
          stripeId: string | null,
          tags: Array< JobTag | null > | null,
          timezonePolicy: TimezonePolicy | null,
          wageIsHourly: boolean | null,
          willSponsor: boolean | null,
          workFromAnywhere: boolean | null,
        } | null,
        applicant:  {
          __typename: "JobSeeker",
          id: string,
          userId: string | null,
          firstName: string | null,
          lastName: string | null,
          newGradOrStudent: boolean | null,
          linkedin: string | null,
          website: string | null,
          currentCompany: string | null,
          currentTitle: string | null,
          fullTime: boolean | null,
          partTime: boolean | null,
          contractor: boolean | null,
          fullRemote: boolean | null,
          hybridRemote: boolean | null,
          remoteOptional: boolean | null,
          desiredRole: string | null,
          recommendedJobsEmail: boolean | null,
          newsletterEmail: boolean | null,
          visibleToEmployers: boolean | null,
          emailAddress: string | null,
          phone: string | null,
          phoneVerified: boolean | null,
          profilePic: string | null,
          experienceLevel: ExperienceLevel | null,
          preferencesComplete: boolean | null,
          profileComplete: boolean | null,
          dateCreated: string | null,
          dateModified: string | null,
          deleted: boolean | null,
        } | null,
        proof: string | null,
        isAuto: boolean | null,
        formScreenshot: string | null,
        confirmationScreenshot: string | null,
        generatedResumeUrl: string | null,
        applicationAnswers:  {
          __typename: "ApplicationAnswers",
          id: string,
          applicationId: string,
          jobSeekerId: string,
          jobId: string,
          dateCreated: string | null,
          dateModified: string | null,
        } | null,
        resumeS3Params:  {
          __typename: "ResumeS3Params",
          bucket: string | null,
          key: string | null,
        } | null,
        dateApplied: string | null,
        dateAppliedIndex: string | null,
        dateUpdated: string | null,
      } | null > | null,
      applicationQuestions:  {
        __typename: "ApplicationQuestions",
        id: string,
        jobId: string,
        questions:  Array< {
          __typename: "ApplicationQuestion",
          question: string,
          type: ApplicationQuestionType,
          selector: string,
          options: Array< string | null > | null,
        } | null > | null,
      } | null,
      companyId: string,
      communications:  {
        __typename: "CommunicationInfo",
        emails: Array< string | null > | null,
        phone: string | null,
      } | null,
      companyProfile:  {
        __typename: "EmployerProfile",
        industries: Array< string | null > | null,
        remotePolicy: Policy | null,
        name: string | null,
        bio: string | null,
        hasHeadquarters: boolean | null,
        hqAddress:  {
          __typename: "CityLocation",
          formatted_address: string,
        } | null,
        emailAddress: string | null,
        phoneNumber: string | null,
        image: string | null,
      } | null,
      companyWebsite: string | null,
      companyName: string,
      dateCreated: string | null,
      dateModified: string | null,
      datePosted: string | null,
      deleted: boolean | null,
      department: string,
      description: string,
      digitalNomadFriendly: boolean | null,
      elite: boolean | null,
      endSalaryRangeThousands: number | null,
      experience: ExperienceLevel,
      featured: boolean | null,
      featuredRank: number | null,
      flexibleHours: boolean | null,
      id: string,
      jobLogo: string | null,
      jobTitle: string,
      officeFrequency:  {
        __typename: "OfficeFrequency",
        daysPerMonth: number | null,
        daysPerWeek: number | null,
      } | null,
      officeLocations:  Array< {
        __typename: "CityLocation",
        formatted_address: string,
        coordinate:  {
          __typename: "Location",
          lat: number,
          lon: number,
        },
      } | null > | null,
      paymentHistory:  Array< {
        __typename: "PaymentRecord",
        stripeId: string,
        productId: string,
        paymentPlan: PaymentPlan,
        dateCreated: string,
        dateEnded: string | null,
      } | null > | null,
      paymentPlan: PaymentPlan | null,
      remoteFirst: boolean | null,
      remotePolicy: JobPolicy | null,
      roleType: WorkType,
      scraped: boolean | null,
      scrapedSource: string | null,
      scrapedUrl: string | null,
      startSalaryRangeThousands: number | null,
      status: JobStatus | null,
      stripeId: string | null,
      tags: Array< JobTag | null > | null,
      timezonePolicy: TimezonePolicy | null,
      timezoneRanges:  Array< {
        __typename: "TimezoneRange",
        start: number | null,
        end: number | null,
      } | null > | null,
      wageIsHourly: boolean | null,
      willSponsor: boolean | null,
      workFromAnywhere: boolean | null,
    } | null > | null,
    signupPromo: string | null,
    website: string | null,
    deleted: boolean | null,
  } | null,
};

export type CreateJobSeekerMutationVariables = {
  jobSeeker: JobSeekerInput,
};

export type CreateJobSeekerMutation = {
  createJobSeeker:  {
    __typename: "JobSeeker",
    id: string,
    userId: string | null,
    firstName: string | null,
    lastName: string | null,
    city:  {
      __typename: "CityLocation",
      formatted_address: string,
      coordinate:  {
        __typename: "Location",
        lat: number,
        lon: number,
      },
    } | null,
    newGradOrStudent: boolean | null,
    linkedin: string | null,
    website: string | null,
    currentCompany: string | null,
    currentTitle: string | null,
    fullTime: boolean | null,
    partTime: boolean | null,
    contractor: boolean | null,
    fullRemote: boolean | null,
    hybridRemote: boolean | null,
    remoteOptional: boolean | null,
    desiredRole: string | null,
    salaryRequirement:  {
      __typename: "Salary",
      currencyCode: string | null,
      value: number | null,
    } | null,
    authorization:  {
      __typename: "WorkAuthorization",
      usAuthorized: boolean | null,
      requireSponsorshipUS: boolean | null,
    } | null,
    recommendedJobsEmail: boolean | null,
    newsletterEmail: boolean | null,
    notificationSettings:  {
      __typename: "NotificationSettings",
      reviewsProfile: NotificationSetting | null,
    } | null,
    visibleToEmployers: boolean | null,
    emailAddress: string | null,
    phone: string | null,
    phoneVerified: boolean | null,
    profilePic: string | null,
    experienceLevel: ExperienceLevel | null,
    workHistory:  Array< {
      __typename: "WorkHistory",
      company: string,
      title: string,
      startDate: string,
      endDate: string | null,
      currentJob: boolean,
      description: string | null,
    } | null > | null,
    educationHistory:  Array< {
      __typename: "EducationHistory",
      institution: string,
      certification: string,
      concentration: string | null,
      dateStarted: string,
      dateCompleted: string | null,
      inProgress: boolean | null,
      description: string | null,
    } | null > | null,
    applications:  Array< {
      __typename: "Application",
      id: string,
      jobId: string,
      jobSeekerId: string,
      applicationStatus: ApplicationStatus | null,
      coverLetter: string | null,
      job:  {
        __typename: "Job",
        aboutUs: string,
        applications:  Array< {
          __typename: "Application",
          id: string,
          jobId: string,
          jobSeekerId: string,
          applicationStatus: ApplicationStatus | null,
          coverLetter: string | null,
          proof: string | null,
          isAuto: boolean | null,
          formScreenshot: string | null,
          confirmationScreenshot: string | null,
          generatedResumeUrl: string | null,
          dateApplied: string | null,
          dateAppliedIndex: string | null,
          dateUpdated: string | null,
        } | null > | null,
        applicationQuestions:  {
          __typename: "ApplicationQuestions",
          id: string,
          jobId: string,
        } | null,
        companyId: string,
        communications:  {
          __typename: "CommunicationInfo",
          emails: Array< string | null > | null,
          phone: string | null,
        } | null,
        companyProfile:  {
          __typename: "EmployerProfile",
          industries: Array< string | null > | null,
          remotePolicy: Policy | null,
          name: string | null,
          bio: string | null,
          hasHeadquarters: boolean | null,
          emailAddress: string | null,
          phoneNumber: string | null,
          image: string | null,
        } | null,
        companyWebsite: string | null,
        companyName: string,
        dateCreated: string | null,
        dateModified: string | null,
        datePosted: string | null,
        deleted: boolean | null,
        department: string,
        description: string,
        digitalNomadFriendly: boolean | null,
        elite: boolean | null,
        endSalaryRangeThousands: number | null,
        experience: ExperienceLevel,
        featured: boolean | null,
        featuredRank: number | null,
        flexibleHours: boolean | null,
        id: string,
        jobLogo: string | null,
        jobTitle: string,
        officeFrequency:  {
          __typename: "OfficeFrequency",
          daysPerMonth: number | null,
          daysPerWeek: number | null,
        } | null,
        officeLocations:  Array< {
          __typename: "CityLocation",
          formatted_address: string,
        } | null > | null,
        paymentHistory:  Array< {
          __typename: "PaymentRecord",
          stripeId: string,
          productId: string,
          paymentPlan: PaymentPlan,
          dateCreated: string,
          dateEnded: string | null,
        } | null > | null,
        paymentPlan: PaymentPlan | null,
        remoteFirst: boolean | null,
        remotePolicy: JobPolicy | null,
        roleType: WorkType,
        scraped: boolean | null,
        scrapedSource: string | null,
        scrapedUrl: string | null,
        startSalaryRangeThousands: number | null,
        status: JobStatus | null,
        stripeId: string | null,
        tags: Array< JobTag | null > | null,
        timezonePolicy: TimezonePolicy | null,
        timezoneRanges:  Array< {
          __typename: "TimezoneRange",
          start: number | null,
          end: number | null,
        } | null > | null,
        wageIsHourly: boolean | null,
        willSponsor: boolean | null,
        workFromAnywhere: boolean | null,
      } | null,
      applicant:  {
        __typename: "JobSeeker",
        id: string,
        userId: string | null,
        firstName: string | null,
        lastName: string | null,
        city:  {
          __typename: "CityLocation",
          formatted_address: string,
        } | null,
        newGradOrStudent: boolean | null,
        linkedin: string | null,
        website: string | null,
        currentCompany: string | null,
        currentTitle: string | null,
        fullTime: boolean | null,
        partTime: boolean | null,
        contractor: boolean | null,
        fullRemote: boolean | null,
        hybridRemote: boolean | null,
        remoteOptional: boolean | null,
        desiredRole: string | null,
        salaryRequirement:  {
          __typename: "Salary",
          currencyCode: string | null,
          value: number | null,
        } | null,
        authorization:  {
          __typename: "WorkAuthorization",
          usAuthorized: boolean | null,
          requireSponsorshipUS: boolean | null,
        } | null,
        recommendedJobsEmail: boolean | null,
        newsletterEmail: boolean | null,
        notificationSettings:  {
          __typename: "NotificationSettings",
          reviewsProfile: NotificationSetting | null,
        } | null,
        visibleToEmployers: boolean | null,
        emailAddress: string | null,
        phone: string | null,
        phoneVerified: boolean | null,
        profilePic: string | null,
        experienceLevel: ExperienceLevel | null,
        workHistory:  Array< {
          __typename: "WorkHistory",
          company: string,
          title: string,
          startDate: string,
          endDate: string | null,
          currentJob: boolean,
          description: string | null,
        } | null > | null,
        educationHistory:  Array< {
          __typename: "EducationHistory",
          institution: string,
          certification: string,
          concentration: string | null,
          dateStarted: string,
          dateCompleted: string | null,
          inProgress: boolean | null,
          description: string | null,
        } | null > | null,
        applications:  Array< {
          __typename: "Application",
          id: string,
          jobId: string,
          jobSeekerId: string,
          applicationStatus: ApplicationStatus | null,
          coverLetter: string | null,
          proof: string | null,
          isAuto: boolean | null,
          formScreenshot: string | null,
          confirmationScreenshot: string | null,
          generatedResumeUrl: string | null,
          dateApplied: string | null,
          dateAppliedIndex: string | null,
          dateUpdated: string | null,
        } | null > | null,
        resume:  {
          __typename: "Resume",
          id: string,
          name: string,
          fileType: string,
          size: string,
          url: string,
          resumeJSON: string | null,
          jobSeekerId: string | null,
          dateUploaded: string,
          dateCreated: string,
          deleted: boolean | null,
        } | null,
        autoResumes:  Array< {
          __typename: "Resume",
          id: string,
          name: string,
          fileType: string,
          size: string,
          url: string,
          resumeJSON: string | null,
          jobSeekerId: string | null,
          dateUploaded: string,
          dateCreated: string,
          deleted: boolean | null,
        } | null > | null,
        preferencesComplete: boolean | null,
        profileComplete: boolean | null,
        autoApply:  Array< {
          __typename: "AutoApply",
          id: string | null,
          jobSeekerId: string | null,
          subId: string | null,
          userId: string | null,
          autoGenerateCoverLetter: boolean | null,
          autoGenerateCoverLetterTone: string | null,
          autoGenerateCoverLetterGreeting: string | null,
          autoGenerateCoverLetterSignOff: string | null,
          autoGenerateCoverLetterInstructions: string | null,
          openToRelocation: boolean | null,
          languagesSpoken: Array< string | null > | null,
          age: number | null,
          genderIdentity: string | null,
          blockedCompanyList: Array< string | null > | null,
          resumeText: string | null,
          coverLetter: string | null,
          aiGenerateCoverLetter: boolean | null,
          coverLetterTone: string | null,
          draft: boolean | null,
          email: string | null,
          isActive: string | null,
          firstName: string | null,
          lastName: string | null,
          remote: boolean | null,
          hybrid: boolean | null,
          onsite: boolean | null,
          jobTitles: Array< string | null > | null,
          negativeJobTitles: Array< string | null > | null,
          industries: Array< string | null > | null,
          experienceLevels: Array< ExperienceLevel | null > | null,
          excludeCompanyNames: Array< string | null > | null,
          expiresAt: string | null,
          subscribedOn: string | null,
          plan: AutoApplySub | null,
          applicationCount: number | null,
          paymentFailed: boolean | null,
          country: string | null,
          region: string | null,
          area: string | null,
          customPreference: Array< string | null > | null,
          appliedUrls: Array< string | null > | null,
          salaryMin: number | null,
          salaryMax: number | null,
          salaryRange: string | null,
          searchTags: Array< string | null > | null,
          prompt: string | null,
          phone: string | null,
          address: string | null,
          currentCompany: string | null,
          linkedinProfile: string | null,
          githubProfile: string | null,
          website: string | null,
          gender: string | null,
          pronouns: string | null,
          hispanic: boolean | null,
          race: string | null,
          paused: boolean | null,
          disabled: boolean | null,
          veteran: boolean | null,
          secretClearance: boolean | null,
          appCountToday: number | null,
          appCountDateUpdated: string | null,
          maxPerDay: number | null,
          maxPerCo: number | null,
          hourToRun: number | null,
          minuteToRun: number | null,
          resumeUrl: string | null,
          resumeName: string | null,
          trial: boolean | null,
          trialExpired: boolean | null,
          gsiConstant: string | null,
          dateCreated: string | null,
          cancelled: boolean | null,
          searchCustomInstructions: string | null,
        } | null > | null,
        dateCreated: string | null,
        dateModified: string | null,
        deleted: boolean | null,
      } | null,
      proof: string | null,
      isAuto: boolean | null,
      formScreenshot: string | null,
      confirmationScreenshot: string | null,
      generatedResumeUrl: string | null,
      applicationAnswers:  {
        __typename: "ApplicationAnswers",
        id: string,
        applicationId: string,
        jobSeekerId: string,
        jobId: string,
        responses:  Array< {
          __typename: "ApplicationAnswer",
          id: string,
          question: string | null,
          answer: string | null,
          type: ApplicationQuestionType | null,
        } | null > | null,
        dateCreated: string | null,
        dateModified: string | null,
      } | null,
      resumeS3Params:  {
        __typename: "ResumeS3Params",
        bucket: string | null,
        key: string | null,
      } | null,
      dateApplied: string | null,
      dateAppliedIndex: string | null,
      dateUpdated: string | null,
    } | null > | null,
    resume:  {
      __typename: "Resume",
      id: string,
      name: string,
      fileType: string,
      size: string,
      url: string,
      resumeJSON: string | null,
      jobSeekerId: string | null,
      dateUploaded: string,
      dateCreated: string,
      deleted: boolean | null,
    } | null,
    autoResumes:  Array< {
      __typename: "Resume",
      id: string,
      name: string,
      fileType: string,
      size: string,
      url: string,
      resumeJSON: string | null,
      jobSeekerId: string | null,
      dateUploaded: string,
      dateCreated: string,
      deleted: boolean | null,
    } | null > | null,
    preferencesComplete: boolean | null,
    profileComplete: boolean | null,
    autoApply:  Array< {
      __typename: "AutoApply",
      id: string | null,
      jobSeekerId: string | null,
      subId: string | null,
      userId: string | null,
      autoGenerateCoverLetter: boolean | null,
      autoGenerateCoverLetterTone: string | null,
      autoGenerateCoverLetterGreeting: string | null,
      autoGenerateCoverLetterSignOff: string | null,
      autoGenerateCoverLetterInstructions: string | null,
      customResumeOptions:  {
        __typename: "ResumeCustomizationOptions",
        shouldCustomize: boolean | null,
        customInstructions: string | null,
      } | null,
      openToRelocation: boolean | null,
      languagesSpoken: Array< string | null > | null,
      age: number | null,
      references:  Array< {
        __typename: "Reference",
        name: string | null,
        email: string | null,
        phone: string | null,
        relationship: string | null,
      } | null > | null,
      genderIdentity: string | null,
      blockedCompanyList: Array< string | null > | null,
      resumeText: string | null,
      coverLetter: string | null,
      aiGenerateCoverLetter: boolean | null,
      coverLetterTone: string | null,
      draft: boolean | null,
      email: string | null,
      isActive: string | null,
      firstName: string | null,
      lastName: string | null,
      remote: boolean | null,
      hybrid: boolean | null,
      onsite: boolean | null,
      jobTitles: Array< string | null > | null,
      negativeJobTitles: Array< string | null > | null,
      industries: Array< string | null > | null,
      education:  {
        __typename: "EducationHistory",
        institution: string,
        certification: string,
        concentration: string | null,
        dateStarted: string,
        dateCompleted: string | null,
        inProgress: boolean | null,
        description: string | null,
      } | null,
      educationHistory:  Array< {
        __typename: "EducationHistory",
        institution: string,
        certification: string,
        concentration: string | null,
        dateStarted: string,
        dateCompleted: string | null,
        inProgress: boolean | null,
        description: string | null,
      } | null > | null,
      experienceLevels: Array< ExperienceLevel | null > | null,
      excludeCompanyNames: Array< string | null > | null,
      expiresAt: string | null,
      subscribedOn: string | null,
      plan: AutoApplySub | null,
      applicationCount: number | null,
      paymentFailed: boolean | null,
      autoLocations:  Array< {
        __typename: "AutoLocation",
        location:  {
          __typename: "CityLocation",
          formatted_address: string,
        } | null,
        country: string | null,
        region: string | null,
        area: string | null,
      } | null > | null,
      location:  {
        __typename: "CityLocation",
        formatted_address: string,
        coordinate:  {
          __typename: "Location",
          lat: number,
          lon: number,
        },
      } | null,
      country: string | null,
      region: string | null,
      area: string | null,
      customPreference: Array< string | null > | null,
      appliedUrls: Array< string | null > | null,
      salaryMin: number | null,
      salaryMax: number | null,
      salaryRange: string | null,
      searchTags: Array< string | null > | null,
      prompt: string | null,
      phone: string | null,
      address: string | null,
      currentCompany: string | null,
      linkedinProfile: string | null,
      githubProfile: string | null,
      website: string | null,
      gender: string | null,
      pronouns: string | null,
      hispanic: boolean | null,
      race: string | null,
      paused: boolean | null,
      disabled: boolean | null,
      veteran: boolean | null,
      countryAuthorization:  Array< {
        __typename: "CountryAuthorization",
        countryAuthorization: string | null,
        authorizationType: string | null,
        requiresSponsorship: boolean | null,
      } | null > | null,
      secretClearance: boolean | null,
      appCountToday: number | null,
      appCountDateUpdated: string | null,
      maxPerDay: number | null,
      maxPerCo: number | null,
      hourToRun: number | null,
      minuteToRun: number | null,
      resumeUrl: string | null,
      resumeName: string | null,
      trial: boolean | null,
      trialExpired: boolean | null,
      gsiConstant: string | null,
      dateCreated: string | null,
      cancelled: boolean | null,
      searchCustomInstructions: string | null,
    } | null > | null,
    dateCreated: string | null,
    dateModified: string | null,
    deleted: boolean | null,
  } | null,
};

export type UpdateJobSeekerMutationVariables = {
  jobSeeker: JobSeekerInput,
};

export type UpdateJobSeekerMutation = {
  updateJobSeeker:  {
    __typename: "JobSeeker",
    id: string,
    userId: string | null,
    firstName: string | null,
    lastName: string | null,
    city:  {
      __typename: "CityLocation",
      formatted_address: string,
      coordinate:  {
        __typename: "Location",
        lat: number,
        lon: number,
      },
    } | null,
    newGradOrStudent: boolean | null,
    linkedin: string | null,
    website: string | null,
    currentCompany: string | null,
    currentTitle: string | null,
    fullTime: boolean | null,
    partTime: boolean | null,
    contractor: boolean | null,
    fullRemote: boolean | null,
    hybridRemote: boolean | null,
    remoteOptional: boolean | null,
    desiredRole: string | null,
    salaryRequirement:  {
      __typename: "Salary",
      currencyCode: string | null,
      value: number | null,
    } | null,
    authorization:  {
      __typename: "WorkAuthorization",
      usAuthorized: boolean | null,
      requireSponsorshipUS: boolean | null,
    } | null,
    recommendedJobsEmail: boolean | null,
    newsletterEmail: boolean | null,
    notificationSettings:  {
      __typename: "NotificationSettings",
      reviewsProfile: NotificationSetting | null,
    } | null,
    visibleToEmployers: boolean | null,
    emailAddress: string | null,
    phone: string | null,
    phoneVerified: boolean | null,
    profilePic: string | null,
    experienceLevel: ExperienceLevel | null,
    workHistory:  Array< {
      __typename: "WorkHistory",
      company: string,
      title: string,
      startDate: string,
      endDate: string | null,
      currentJob: boolean,
      description: string | null,
    } | null > | null,
    educationHistory:  Array< {
      __typename: "EducationHistory",
      institution: string,
      certification: string,
      concentration: string | null,
      dateStarted: string,
      dateCompleted: string | null,
      inProgress: boolean | null,
      description: string | null,
    } | null > | null,
    applications:  Array< {
      __typename: "Application",
      id: string,
      jobId: string,
      jobSeekerId: string,
      applicationStatus: ApplicationStatus | null,
      coverLetter: string | null,
      job:  {
        __typename: "Job",
        aboutUs: string,
        applications:  Array< {
          __typename: "Application",
          id: string,
          jobId: string,
          jobSeekerId: string,
          applicationStatus: ApplicationStatus | null,
          coverLetter: string | null,
          proof: string | null,
          isAuto: boolean | null,
          formScreenshot: string | null,
          confirmationScreenshot: string | null,
          generatedResumeUrl: string | null,
          dateApplied: string | null,
          dateAppliedIndex: string | null,
          dateUpdated: string | null,
        } | null > | null,
        applicationQuestions:  {
          __typename: "ApplicationQuestions",
          id: string,
          jobId: string,
        } | null,
        companyId: string,
        communications:  {
          __typename: "CommunicationInfo",
          emails: Array< string | null > | null,
          phone: string | null,
        } | null,
        companyProfile:  {
          __typename: "EmployerProfile",
          industries: Array< string | null > | null,
          remotePolicy: Policy | null,
          name: string | null,
          bio: string | null,
          hasHeadquarters: boolean | null,
          emailAddress: string | null,
          phoneNumber: string | null,
          image: string | null,
        } | null,
        companyWebsite: string | null,
        companyName: string,
        dateCreated: string | null,
        dateModified: string | null,
        datePosted: string | null,
        deleted: boolean | null,
        department: string,
        description: string,
        digitalNomadFriendly: boolean | null,
        elite: boolean | null,
        endSalaryRangeThousands: number | null,
        experience: ExperienceLevel,
        featured: boolean | null,
        featuredRank: number | null,
        flexibleHours: boolean | null,
        id: string,
        jobLogo: string | null,
        jobTitle: string,
        officeFrequency:  {
          __typename: "OfficeFrequency",
          daysPerMonth: number | null,
          daysPerWeek: number | null,
        } | null,
        officeLocations:  Array< {
          __typename: "CityLocation",
          formatted_address: string,
        } | null > | null,
        paymentHistory:  Array< {
          __typename: "PaymentRecord",
          stripeId: string,
          productId: string,
          paymentPlan: PaymentPlan,
          dateCreated: string,
          dateEnded: string | null,
        } | null > | null,
        paymentPlan: PaymentPlan | null,
        remoteFirst: boolean | null,
        remotePolicy: JobPolicy | null,
        roleType: WorkType,
        scraped: boolean | null,
        scrapedSource: string | null,
        scrapedUrl: string | null,
        startSalaryRangeThousands: number | null,
        status: JobStatus | null,
        stripeId: string | null,
        tags: Array< JobTag | null > | null,
        timezonePolicy: TimezonePolicy | null,
        timezoneRanges:  Array< {
          __typename: "TimezoneRange",
          start: number | null,
          end: number | null,
        } | null > | null,
        wageIsHourly: boolean | null,
        willSponsor: boolean | null,
        workFromAnywhere: boolean | null,
      } | null,
      applicant:  {
        __typename: "JobSeeker",
        id: string,
        userId: string | null,
        firstName: string | null,
        lastName: string | null,
        city:  {
          __typename: "CityLocation",
          formatted_address: string,
        } | null,
        newGradOrStudent: boolean | null,
        linkedin: string | null,
        website: string | null,
        currentCompany: string | null,
        currentTitle: string | null,
        fullTime: boolean | null,
        partTime: boolean | null,
        contractor: boolean | null,
        fullRemote: boolean | null,
        hybridRemote: boolean | null,
        remoteOptional: boolean | null,
        desiredRole: string | null,
        salaryRequirement:  {
          __typename: "Salary",
          currencyCode: string | null,
          value: number | null,
        } | null,
        authorization:  {
          __typename: "WorkAuthorization",
          usAuthorized: boolean | null,
          requireSponsorshipUS: boolean | null,
        } | null,
        recommendedJobsEmail: boolean | null,
        newsletterEmail: boolean | null,
        notificationSettings:  {
          __typename: "NotificationSettings",
          reviewsProfile: NotificationSetting | null,
        } | null,
        visibleToEmployers: boolean | null,
        emailAddress: string | null,
        phone: string | null,
        phoneVerified: boolean | null,
        profilePic: string | null,
        experienceLevel: ExperienceLevel | null,
        workHistory:  Array< {
          __typename: "WorkHistory",
          company: string,
          title: string,
          startDate: string,
          endDate: string | null,
          currentJob: boolean,
          description: string | null,
        } | null > | null,
        educationHistory:  Array< {
          __typename: "EducationHistory",
          institution: string,
          certification: string,
          concentration: string | null,
          dateStarted: string,
          dateCompleted: string | null,
          inProgress: boolean | null,
          description: string | null,
        } | null > | null,
        applications:  Array< {
          __typename: "Application",
          id: string,
          jobId: string,
          jobSeekerId: string,
          applicationStatus: ApplicationStatus | null,
          coverLetter: string | null,
          proof: string | null,
          isAuto: boolean | null,
          formScreenshot: string | null,
          confirmationScreenshot: string | null,
          generatedResumeUrl: string | null,
          dateApplied: string | null,
          dateAppliedIndex: string | null,
          dateUpdated: string | null,
        } | null > | null,
        resume:  {
          __typename: "Resume",
          id: string,
          name: string,
          fileType: string,
          size: string,
          url: string,
          resumeJSON: string | null,
          jobSeekerId: string | null,
          dateUploaded: string,
          dateCreated: string,
          deleted: boolean | null,
        } | null,
        autoResumes:  Array< {
          __typename: "Resume",
          id: string,
          name: string,
          fileType: string,
          size: string,
          url: string,
          resumeJSON: string | null,
          jobSeekerId: string | null,
          dateUploaded: string,
          dateCreated: string,
          deleted: boolean | null,
        } | null > | null,
        preferencesComplete: boolean | null,
        profileComplete: boolean | null,
        autoApply:  Array< {
          __typename: "AutoApply",
          id: string | null,
          jobSeekerId: string | null,
          subId: string | null,
          userId: string | null,
          autoGenerateCoverLetter: boolean | null,
          autoGenerateCoverLetterTone: string | null,
          autoGenerateCoverLetterGreeting: string | null,
          autoGenerateCoverLetterSignOff: string | null,
          autoGenerateCoverLetterInstructions: string | null,
          openToRelocation: boolean | null,
          languagesSpoken: Array< string | null > | null,
          age: number | null,
          genderIdentity: string | null,
          blockedCompanyList: Array< string | null > | null,
          resumeText: string | null,
          coverLetter: string | null,
          aiGenerateCoverLetter: boolean | null,
          coverLetterTone: string | null,
          draft: boolean | null,
          email: string | null,
          isActive: string | null,
          firstName: string | null,
          lastName: string | null,
          remote: boolean | null,
          hybrid: boolean | null,
          onsite: boolean | null,
          jobTitles: Array< string | null > | null,
          negativeJobTitles: Array< string | null > | null,
          industries: Array< string | null > | null,
          experienceLevels: Array< ExperienceLevel | null > | null,
          excludeCompanyNames: Array< string | null > | null,
          expiresAt: string | null,
          subscribedOn: string | null,
          plan: AutoApplySub | null,
          applicationCount: number | null,
          paymentFailed: boolean | null,
          country: string | null,
          region: string | null,
          area: string | null,
          customPreference: Array< string | null > | null,
          appliedUrls: Array< string | null > | null,
          salaryMin: number | null,
          salaryMax: number | null,
          salaryRange: string | null,
          searchTags: Array< string | null > | null,
          prompt: string | null,
          phone: string | null,
          address: string | null,
          currentCompany: string | null,
          linkedinProfile: string | null,
          githubProfile: string | null,
          website: string | null,
          gender: string | null,
          pronouns: string | null,
          hispanic: boolean | null,
          race: string | null,
          paused: boolean | null,
          disabled: boolean | null,
          veteran: boolean | null,
          secretClearance: boolean | null,
          appCountToday: number | null,
          appCountDateUpdated: string | null,
          maxPerDay: number | null,
          maxPerCo: number | null,
          hourToRun: number | null,
          minuteToRun: number | null,
          resumeUrl: string | null,
          resumeName: string | null,
          trial: boolean | null,
          trialExpired: boolean | null,
          gsiConstant: string | null,
          dateCreated: string | null,
          cancelled: boolean | null,
          searchCustomInstructions: string | null,
        } | null > | null,
        dateCreated: string | null,
        dateModified: string | null,
        deleted: boolean | null,
      } | null,
      proof: string | null,
      isAuto: boolean | null,
      formScreenshot: string | null,
      confirmationScreenshot: string | null,
      generatedResumeUrl: string | null,
      applicationAnswers:  {
        __typename: "ApplicationAnswers",
        id: string,
        applicationId: string,
        jobSeekerId: string,
        jobId: string,
        responses:  Array< {
          __typename: "ApplicationAnswer",
          id: string,
          question: string | null,
          answer: string | null,
          type: ApplicationQuestionType | null,
        } | null > | null,
        dateCreated: string | null,
        dateModified: string | null,
      } | null,
      resumeS3Params:  {
        __typename: "ResumeS3Params",
        bucket: string | null,
        key: string | null,
      } | null,
      dateApplied: string | null,
      dateAppliedIndex: string | null,
      dateUpdated: string | null,
    } | null > | null,
    resume:  {
      __typename: "Resume",
      id: string,
      name: string,
      fileType: string,
      size: string,
      url: string,
      resumeJSON: string | null,
      jobSeekerId: string | null,
      dateUploaded: string,
      dateCreated: string,
      deleted: boolean | null,
    } | null,
    autoResumes:  Array< {
      __typename: "Resume",
      id: string,
      name: string,
      fileType: string,
      size: string,
      url: string,
      resumeJSON: string | null,
      jobSeekerId: string | null,
      dateUploaded: string,
      dateCreated: string,
      deleted: boolean | null,
    } | null > | null,
    preferencesComplete: boolean | null,
    profileComplete: boolean | null,
    autoApply:  Array< {
      __typename: "AutoApply",
      id: string | null,
      jobSeekerId: string | null,
      subId: string | null,
      userId: string | null,
      autoGenerateCoverLetter: boolean | null,
      autoGenerateCoverLetterTone: string | null,
      autoGenerateCoverLetterGreeting: string | null,
      autoGenerateCoverLetterSignOff: string | null,
      autoGenerateCoverLetterInstructions: string | null,
      customResumeOptions:  {
        __typename: "ResumeCustomizationOptions",
        shouldCustomize: boolean | null,
        customInstructions: string | null,
      } | null,
      openToRelocation: boolean | null,
      languagesSpoken: Array< string | null > | null,
      age: number | null,
      references:  Array< {
        __typename: "Reference",
        name: string | null,
        email: string | null,
        phone: string | null,
        relationship: string | null,
      } | null > | null,
      genderIdentity: string | null,
      blockedCompanyList: Array< string | null > | null,
      resumeText: string | null,
      coverLetter: string | null,
      aiGenerateCoverLetter: boolean | null,
      coverLetterTone: string | null,
      draft: boolean | null,
      email: string | null,
      isActive: string | null,
      firstName: string | null,
      lastName: string | null,
      remote: boolean | null,
      hybrid: boolean | null,
      onsite: boolean | null,
      jobTitles: Array< string | null > | null,
      negativeJobTitles: Array< string | null > | null,
      industries: Array< string | null > | null,
      education:  {
        __typename: "EducationHistory",
        institution: string,
        certification: string,
        concentration: string | null,
        dateStarted: string,
        dateCompleted: string | null,
        inProgress: boolean | null,
        description: string | null,
      } | null,
      educationHistory:  Array< {
        __typename: "EducationHistory",
        institution: string,
        certification: string,
        concentration: string | null,
        dateStarted: string,
        dateCompleted: string | null,
        inProgress: boolean | null,
        description: string | null,
      } | null > | null,
      experienceLevels: Array< ExperienceLevel | null > | null,
      excludeCompanyNames: Array< string | null > | null,
      expiresAt: string | null,
      subscribedOn: string | null,
      plan: AutoApplySub | null,
      applicationCount: number | null,
      paymentFailed: boolean | null,
      autoLocations:  Array< {
        __typename: "AutoLocation",
        location:  {
          __typename: "CityLocation",
          formatted_address: string,
        } | null,
        country: string | null,
        region: string | null,
        area: string | null,
      } | null > | null,
      location:  {
        __typename: "CityLocation",
        formatted_address: string,
        coordinate:  {
          __typename: "Location",
          lat: number,
          lon: number,
        },
      } | null,
      country: string | null,
      region: string | null,
      area: string | null,
      customPreference: Array< string | null > | null,
      appliedUrls: Array< string | null > | null,
      salaryMin: number | null,
      salaryMax: number | null,
      salaryRange: string | null,
      searchTags: Array< string | null > | null,
      prompt: string | null,
      phone: string | null,
      address: string | null,
      currentCompany: string | null,
      linkedinProfile: string | null,
      githubProfile: string | null,
      website: string | null,
      gender: string | null,
      pronouns: string | null,
      hispanic: boolean | null,
      race: string | null,
      paused: boolean | null,
      disabled: boolean | null,
      veteran: boolean | null,
      countryAuthorization:  Array< {
        __typename: "CountryAuthorization",
        countryAuthorization: string | null,
        authorizationType: string | null,
        requiresSponsorship: boolean | null,
      } | null > | null,
      secretClearance: boolean | null,
      appCountToday: number | null,
      appCountDateUpdated: string | null,
      maxPerDay: number | null,
      maxPerCo: number | null,
      hourToRun: number | null,
      minuteToRun: number | null,
      resumeUrl: string | null,
      resumeName: string | null,
      trial: boolean | null,
      trialExpired: boolean | null,
      gsiConstant: string | null,
      dateCreated: string | null,
      cancelled: boolean | null,
      searchCustomInstructions: string | null,
    } | null > | null,
    dateCreated: string | null,
    dateModified: string | null,
    deleted: boolean | null,
  } | null,
};

export type DeleteUserMutationVariables = {
  userId: string,
};

export type DeleteUserMutation = {
  deleteUser: string | null,
};

export type CreateApplicationMutationVariables = {
  input?: ApplyInput | null,
};

export type CreateApplicationMutation = {
  createApplication:  {
    __typename: "Application",
    id: string,
    jobId: string,
    jobSeekerId: string,
    applicationStatus: ApplicationStatus | null,
    coverLetter: string | null,
    job:  {
      __typename: "Job",
      aboutUs: string,
      applications:  Array< {
        __typename: "Application",
        id: string,
        jobId: string,
        jobSeekerId: string,
        applicationStatus: ApplicationStatus | null,
        coverLetter: string | null,
        job:  {
          __typename: "Job",
          aboutUs: string,
          companyId: string,
          companyWebsite: string | null,
          companyName: string,
          dateCreated: string | null,
          dateModified: string | null,
          datePosted: string | null,
          deleted: boolean | null,
          department: string,
          description: string,
          digitalNomadFriendly: boolean | null,
          elite: boolean | null,
          endSalaryRangeThousands: number | null,
          experience: ExperienceLevel,
          featured: boolean | null,
          featuredRank: number | null,
          flexibleHours: boolean | null,
          id: string,
          jobLogo: string | null,
          jobTitle: string,
          paymentPlan: PaymentPlan | null,
          remoteFirst: boolean | null,
          remotePolicy: JobPolicy | null,
          roleType: WorkType,
          scraped: boolean | null,
          scrapedSource: string | null,
          scrapedUrl: string | null,
          startSalaryRangeThousands: number | null,
          status: JobStatus | null,
          stripeId: string | null,
          tags: Array< JobTag | null > | null,
          timezonePolicy: TimezonePolicy | null,
          wageIsHourly: boolean | null,
          willSponsor: boolean | null,
          workFromAnywhere: boolean | null,
        } | null,
        applicant:  {
          __typename: "JobSeeker",
          id: string,
          userId: string | null,
          firstName: string | null,
          lastName: string | null,
          newGradOrStudent: boolean | null,
          linkedin: string | null,
          website: string | null,
          currentCompany: string | null,
          currentTitle: string | null,
          fullTime: boolean | null,
          partTime: boolean | null,
          contractor: boolean | null,
          fullRemote: boolean | null,
          hybridRemote: boolean | null,
          remoteOptional: boolean | null,
          desiredRole: string | null,
          recommendedJobsEmail: boolean | null,
          newsletterEmail: boolean | null,
          visibleToEmployers: boolean | null,
          emailAddress: string | null,
          phone: string | null,
          phoneVerified: boolean | null,
          profilePic: string | null,
          experienceLevel: ExperienceLevel | null,
          preferencesComplete: boolean | null,
          profileComplete: boolean | null,
          dateCreated: string | null,
          dateModified: string | null,
          deleted: boolean | null,
        } | null,
        proof: string | null,
        isAuto: boolean | null,
        formScreenshot: string | null,
        confirmationScreenshot: string | null,
        generatedResumeUrl: string | null,
        applicationAnswers:  {
          __typename: "ApplicationAnswers",
          id: string,
          applicationId: string,
          jobSeekerId: string,
          jobId: string,
          dateCreated: string | null,
          dateModified: string | null,
        } | null,
        resumeS3Params:  {
          __typename: "ResumeS3Params",
          bucket: string | null,
          key: string | null,
        } | null,
        dateApplied: string | null,
        dateAppliedIndex: string | null,
        dateUpdated: string | null,
      } | null > | null,
      applicationQuestions:  {
        __typename: "ApplicationQuestions",
        id: string,
        jobId: string,
        questions:  Array< {
          __typename: "ApplicationQuestion",
          question: string,
          type: ApplicationQuestionType,
          selector: string,
          options: Array< string | null > | null,
        } | null > | null,
      } | null,
      companyId: string,
      communications:  {
        __typename: "CommunicationInfo",
        emails: Array< string | null > | null,
        phone: string | null,
      } | null,
      companyProfile:  {
        __typename: "EmployerProfile",
        industries: Array< string | null > | null,
        remotePolicy: Policy | null,
        name: string | null,
        bio: string | null,
        hasHeadquarters: boolean | null,
        hqAddress:  {
          __typename: "CityLocation",
          formatted_address: string,
        } | null,
        emailAddress: string | null,
        phoneNumber: string | null,
        image: string | null,
      } | null,
      companyWebsite: string | null,
      companyName: string,
      dateCreated: string | null,
      dateModified: string | null,
      datePosted: string | null,
      deleted: boolean | null,
      department: string,
      description: string,
      digitalNomadFriendly: boolean | null,
      elite: boolean | null,
      endSalaryRangeThousands: number | null,
      experience: ExperienceLevel,
      featured: boolean | null,
      featuredRank: number | null,
      flexibleHours: boolean | null,
      id: string,
      jobLogo: string | null,
      jobTitle: string,
      officeFrequency:  {
        __typename: "OfficeFrequency",
        daysPerMonth: number | null,
        daysPerWeek: number | null,
      } | null,
      officeLocations:  Array< {
        __typename: "CityLocation",
        formatted_address: string,
        coordinate:  {
          __typename: "Location",
          lat: number,
          lon: number,
        },
      } | null > | null,
      paymentHistory:  Array< {
        __typename: "PaymentRecord",
        stripeId: string,
        productId: string,
        paymentPlan: PaymentPlan,
        dateCreated: string,
        dateEnded: string | null,
      } | null > | null,
      paymentPlan: PaymentPlan | null,
      remoteFirst: boolean | null,
      remotePolicy: JobPolicy | null,
      roleType: WorkType,
      scraped: boolean | null,
      scrapedSource: string | null,
      scrapedUrl: string | null,
      startSalaryRangeThousands: number | null,
      status: JobStatus | null,
      stripeId: string | null,
      tags: Array< JobTag | null > | null,
      timezonePolicy: TimezonePolicy | null,
      timezoneRanges:  Array< {
        __typename: "TimezoneRange",
        start: number | null,
        end: number | null,
      } | null > | null,
      wageIsHourly: boolean | null,
      willSponsor: boolean | null,
      workFromAnywhere: boolean | null,
    } | null,
    applicant:  {
      __typename: "JobSeeker",
      id: string,
      userId: string | null,
      firstName: string | null,
      lastName: string | null,
      city:  {
        __typename: "CityLocation",
        formatted_address: string,
        coordinate:  {
          __typename: "Location",
          lat: number,
          lon: number,
        },
      } | null,
      newGradOrStudent: boolean | null,
      linkedin: string | null,
      website: string | null,
      currentCompany: string | null,
      currentTitle: string | null,
      fullTime: boolean | null,
      partTime: boolean | null,
      contractor: boolean | null,
      fullRemote: boolean | null,
      hybridRemote: boolean | null,
      remoteOptional: boolean | null,
      desiredRole: string | null,
      salaryRequirement:  {
        __typename: "Salary",
        currencyCode: string | null,
        value: number | null,
      } | null,
      authorization:  {
        __typename: "WorkAuthorization",
        usAuthorized: boolean | null,
        requireSponsorshipUS: boolean | null,
      } | null,
      recommendedJobsEmail: boolean | null,
      newsletterEmail: boolean | null,
      notificationSettings:  {
        __typename: "NotificationSettings",
        reviewsProfile: NotificationSetting | null,
      } | null,
      visibleToEmployers: boolean | null,
      emailAddress: string | null,
      phone: string | null,
      phoneVerified: boolean | null,
      profilePic: string | null,
      experienceLevel: ExperienceLevel | null,
      workHistory:  Array< {
        __typename: "WorkHistory",
        company: string,
        title: string,
        startDate: string,
        endDate: string | null,
        currentJob: boolean,
        description: string | null,
      } | null > | null,
      educationHistory:  Array< {
        __typename: "EducationHistory",
        institution: string,
        certification: string,
        concentration: string | null,
        dateStarted: string,
        dateCompleted: string | null,
        inProgress: boolean | null,
        description: string | null,
      } | null > | null,
      applications:  Array< {
        __typename: "Application",
        id: string,
        jobId: string,
        jobSeekerId: string,
        applicationStatus: ApplicationStatus | null,
        coverLetter: string | null,
        job:  {
          __typename: "Job",
          aboutUs: string,
          companyId: string,
          companyWebsite: string | null,
          companyName: string,
          dateCreated: string | null,
          dateModified: string | null,
          datePosted: string | null,
          deleted: boolean | null,
          department: string,
          description: string,
          digitalNomadFriendly: boolean | null,
          elite: boolean | null,
          endSalaryRangeThousands: number | null,
          experience: ExperienceLevel,
          featured: boolean | null,
          featuredRank: number | null,
          flexibleHours: boolean | null,
          id: string,
          jobLogo: string | null,
          jobTitle: string,
          paymentPlan: PaymentPlan | null,
          remoteFirst: boolean | null,
          remotePolicy: JobPolicy | null,
          roleType: WorkType,
          scraped: boolean | null,
          scrapedSource: string | null,
          scrapedUrl: string | null,
          startSalaryRangeThousands: number | null,
          status: JobStatus | null,
          stripeId: string | null,
          tags: Array< JobTag | null > | null,
          timezonePolicy: TimezonePolicy | null,
          wageIsHourly: boolean | null,
          willSponsor: boolean | null,
          workFromAnywhere: boolean | null,
        } | null,
        applicant:  {
          __typename: "JobSeeker",
          id: string,
          userId: string | null,
          firstName: string | null,
          lastName: string | null,
          newGradOrStudent: boolean | null,
          linkedin: string | null,
          website: string | null,
          currentCompany: string | null,
          currentTitle: string | null,
          fullTime: boolean | null,
          partTime: boolean | null,
          contractor: boolean | null,
          fullRemote: boolean | null,
          hybridRemote: boolean | null,
          remoteOptional: boolean | null,
          desiredRole: string | null,
          recommendedJobsEmail: boolean | null,
          newsletterEmail: boolean | null,
          visibleToEmployers: boolean | null,
          emailAddress: string | null,
          phone: string | null,
          phoneVerified: boolean | null,
          profilePic: string | null,
          experienceLevel: ExperienceLevel | null,
          preferencesComplete: boolean | null,
          profileComplete: boolean | null,
          dateCreated: string | null,
          dateModified: string | null,
          deleted: boolean | null,
        } | null,
        proof: string | null,
        isAuto: boolean | null,
        formScreenshot: string | null,
        confirmationScreenshot: string | null,
        generatedResumeUrl: string | null,
        applicationAnswers:  {
          __typename: "ApplicationAnswers",
          id: string,
          applicationId: string,
          jobSeekerId: string,
          jobId: string,
          dateCreated: string | null,
          dateModified: string | null,
        } | null,
        resumeS3Params:  {
          __typename: "ResumeS3Params",
          bucket: string | null,
          key: string | null,
        } | null,
        dateApplied: string | null,
        dateAppliedIndex: string | null,
        dateUpdated: string | null,
      } | null > | null,
      resume:  {
        __typename: "Resume",
        id: string,
        name: string,
        fileType: string,
        size: string,
        url: string,
        resumeJSON: string | null,
        jobSeekerId: string | null,
        dateUploaded: string,
        dateCreated: string,
        deleted: boolean | null,
      } | null,
      autoResumes:  Array< {
        __typename: "Resume",
        id: string,
        name: string,
        fileType: string,
        size: string,
        url: string,
        resumeJSON: string | null,
        jobSeekerId: string | null,
        dateUploaded: string,
        dateCreated: string,
        deleted: boolean | null,
      } | null > | null,
      preferencesComplete: boolean | null,
      profileComplete: boolean | null,
      autoApply:  Array< {
        __typename: "AutoApply",
        id: string | null,
        jobSeekerId: string | null,
        subId: string | null,
        userId: string | null,
        autoGenerateCoverLetter: boolean | null,
        autoGenerateCoverLetterTone: string | null,
        autoGenerateCoverLetterGreeting: string | null,
        autoGenerateCoverLetterSignOff: string | null,
        autoGenerateCoverLetterInstructions: string | null,
        customResumeOptions:  {
          __typename: "ResumeCustomizationOptions",
          shouldCustomize: boolean | null,
          customInstructions: string | null,
        } | null,
        openToRelocation: boolean | null,
        languagesSpoken: Array< string | null > | null,
        age: number | null,
        references:  Array< {
          __typename: "Reference",
          name: string | null,
          email: string | null,
          phone: string | null,
          relationship: string | null,
        } | null > | null,
        genderIdentity: string | null,
        blockedCompanyList: Array< string | null > | null,
        resumeText: string | null,
        coverLetter: string | null,
        aiGenerateCoverLetter: boolean | null,
        coverLetterTone: string | null,
        draft: boolean | null,
        email: string | null,
        isActive: string | null,
        firstName: string | null,
        lastName: string | null,
        remote: boolean | null,
        hybrid: boolean | null,
        onsite: boolean | null,
        jobTitles: Array< string | null > | null,
        negativeJobTitles: Array< string | null > | null,
        industries: Array< string | null > | null,
        education:  {
          __typename: "EducationHistory",
          institution: string,
          certification: string,
          concentration: string | null,
          dateStarted: string,
          dateCompleted: string | null,
          inProgress: boolean | null,
          description: string | null,
        } | null,
        educationHistory:  Array< {
          __typename: "EducationHistory",
          institution: string,
          certification: string,
          concentration: string | null,
          dateStarted: string,
          dateCompleted: string | null,
          inProgress: boolean | null,
          description: string | null,
        } | null > | null,
        experienceLevels: Array< ExperienceLevel | null > | null,
        excludeCompanyNames: Array< string | null > | null,
        expiresAt: string | null,
        subscribedOn: string | null,
        plan: AutoApplySub | null,
        applicationCount: number | null,
        paymentFailed: boolean | null,
        autoLocations:  Array< {
          __typename: "AutoLocation",
          country: string | null,
          region: string | null,
          area: string | null,
        } | null > | null,
        location:  {
          __typename: "CityLocation",
          formatted_address: string,
        } | null,
        country: string | null,
        region: string | null,
        area: string | null,
        customPreference: Array< string | null > | null,
        appliedUrls: Array< string | null > | null,
        salaryMin: number | null,
        salaryMax: number | null,
        salaryRange: string | null,
        searchTags: Array< string | null > | null,
        prompt: string | null,
        phone: string | null,
        address: string | null,
        currentCompany: string | null,
        linkedinProfile: string | null,
        githubProfile: string | null,
        website: string | null,
        gender: string | null,
        pronouns: string | null,
        hispanic: boolean | null,
        race: string | null,
        paused: boolean | null,
        disabled: boolean | null,
        veteran: boolean | null,
        countryAuthorization:  Array< {
          __typename: "CountryAuthorization",
          countryAuthorization: string | null,
          authorizationType: string | null,
          requiresSponsorship: boolean | null,
        } | null > | null,
        secretClearance: boolean | null,
        appCountToday: number | null,
        appCountDateUpdated: string | null,
        maxPerDay: number | null,
        maxPerCo: number | null,
        hourToRun: number | null,
        minuteToRun: number | null,
        resumeUrl: string | null,
        resumeName: string | null,
        trial: boolean | null,
        trialExpired: boolean | null,
        gsiConstant: string | null,
        dateCreated: string | null,
        cancelled: boolean | null,
        searchCustomInstructions: string | null,
      } | null > | null,
      dateCreated: string | null,
      dateModified: string | null,
      deleted: boolean | null,
    } | null,
    proof: string | null,
    isAuto: boolean | null,
    formScreenshot: string | null,
    confirmationScreenshot: string | null,
    generatedResumeUrl: string | null,
    applicationAnswers:  {
      __typename: "ApplicationAnswers",
      id: string,
      applicationId: string,
      jobSeekerId: string,
      jobId: string,
      responses:  Array< {
        __typename: "ApplicationAnswer",
        id: string,
        question: string | null,
        answer: string | null,
        type: ApplicationQuestionType | null,
      } | null > | null,
      dateCreated: string | null,
      dateModified: string | null,
    } | null,
    resumeS3Params:  {
      __typename: "ResumeS3Params",
      bucket: string | null,
      key: string | null,
    } | null,
    dateApplied: string | null,
    dateAppliedIndex: string | null,
    dateUpdated: string | null,
  } | null,
};

export type UpdateApplicationMutationVariables = {
  input?: UpdateApplicationInput | null,
};

export type UpdateApplicationMutation = {
  updateApplication:  {
    __typename: "Application",
    id: string,
    jobId: string,
    jobSeekerId: string,
    applicationStatus: ApplicationStatus | null,
    coverLetter: string | null,
    job:  {
      __typename: "Job",
      aboutUs: string,
      applications:  Array< {
        __typename: "Application",
        id: string,
        jobId: string,
        jobSeekerId: string,
        applicationStatus: ApplicationStatus | null,
        coverLetter: string | null,
        job:  {
          __typename: "Job",
          aboutUs: string,
          companyId: string,
          companyWebsite: string | null,
          companyName: string,
          dateCreated: string | null,
          dateModified: string | null,
          datePosted: string | null,
          deleted: boolean | null,
          department: string,
          description: string,
          digitalNomadFriendly: boolean | null,
          elite: boolean | null,
          endSalaryRangeThousands: number | null,
          experience: ExperienceLevel,
          featured: boolean | null,
          featuredRank: number | null,
          flexibleHours: boolean | null,
          id: string,
          jobLogo: string | null,
          jobTitle: string,
          paymentPlan: PaymentPlan | null,
          remoteFirst: boolean | null,
          remotePolicy: JobPolicy | null,
          roleType: WorkType,
          scraped: boolean | null,
          scrapedSource: string | null,
          scrapedUrl: string | null,
          startSalaryRangeThousands: number | null,
          status: JobStatus | null,
          stripeId: string | null,
          tags: Array< JobTag | null > | null,
          timezonePolicy: TimezonePolicy | null,
          wageIsHourly: boolean | null,
          willSponsor: boolean | null,
          workFromAnywhere: boolean | null,
        } | null,
        applicant:  {
          __typename: "JobSeeker",
          id: string,
          userId: string | null,
          firstName: string | null,
          lastName: string | null,
          newGradOrStudent: boolean | null,
          linkedin: string | null,
          website: string | null,
          currentCompany: string | null,
          currentTitle: string | null,
          fullTime: boolean | null,
          partTime: boolean | null,
          contractor: boolean | null,
          fullRemote: boolean | null,
          hybridRemote: boolean | null,
          remoteOptional: boolean | null,
          desiredRole: string | null,
          recommendedJobsEmail: boolean | null,
          newsletterEmail: boolean | null,
          visibleToEmployers: boolean | null,
          emailAddress: string | null,
          phone: string | null,
          phoneVerified: boolean | null,
          profilePic: string | null,
          experienceLevel: ExperienceLevel | null,
          preferencesComplete: boolean | null,
          profileComplete: boolean | null,
          dateCreated: string | null,
          dateModified: string | null,
          deleted: boolean | null,
        } | null,
        proof: string | null,
        isAuto: boolean | null,
        formScreenshot: string | null,
        confirmationScreenshot: string | null,
        generatedResumeUrl: string | null,
        applicationAnswers:  {
          __typename: "ApplicationAnswers",
          id: string,
          applicationId: string,
          jobSeekerId: string,
          jobId: string,
          dateCreated: string | null,
          dateModified: string | null,
        } | null,
        resumeS3Params:  {
          __typename: "ResumeS3Params",
          bucket: string | null,
          key: string | null,
        } | null,
        dateApplied: string | null,
        dateAppliedIndex: string | null,
        dateUpdated: string | null,
      } | null > | null,
      applicationQuestions:  {
        __typename: "ApplicationQuestions",
        id: string,
        jobId: string,
        questions:  Array< {
          __typename: "ApplicationQuestion",
          question: string,
          type: ApplicationQuestionType,
          selector: string,
          options: Array< string | null > | null,
        } | null > | null,
      } | null,
      companyId: string,
      communications:  {
        __typename: "CommunicationInfo",
        emails: Array< string | null > | null,
        phone: string | null,
      } | null,
      companyProfile:  {
        __typename: "EmployerProfile",
        industries: Array< string | null > | null,
        remotePolicy: Policy | null,
        name: string | null,
        bio: string | null,
        hasHeadquarters: boolean | null,
        hqAddress:  {
          __typename: "CityLocation",
          formatted_address: string,
        } | null,
        emailAddress: string | null,
        phoneNumber: string | null,
        image: string | null,
      } | null,
      companyWebsite: string | null,
      companyName: string,
      dateCreated: string | null,
      dateModified: string | null,
      datePosted: string | null,
      deleted: boolean | null,
      department: string,
      description: string,
      digitalNomadFriendly: boolean | null,
      elite: boolean | null,
      endSalaryRangeThousands: number | null,
      experience: ExperienceLevel,
      featured: boolean | null,
      featuredRank: number | null,
      flexibleHours: boolean | null,
      id: string,
      jobLogo: string | null,
      jobTitle: string,
      officeFrequency:  {
        __typename: "OfficeFrequency",
        daysPerMonth: number | null,
        daysPerWeek: number | null,
      } | null,
      officeLocations:  Array< {
        __typename: "CityLocation",
        formatted_address: string,
        coordinate:  {
          __typename: "Location",
          lat: number,
          lon: number,
        },
      } | null > | null,
      paymentHistory:  Array< {
        __typename: "PaymentRecord",
        stripeId: string,
        productId: string,
        paymentPlan: PaymentPlan,
        dateCreated: string,
        dateEnded: string | null,
      } | null > | null,
      paymentPlan: PaymentPlan | null,
      remoteFirst: boolean | null,
      remotePolicy: JobPolicy | null,
      roleType: WorkType,
      scraped: boolean | null,
      scrapedSource: string | null,
      scrapedUrl: string | null,
      startSalaryRangeThousands: number | null,
      status: JobStatus | null,
      stripeId: string | null,
      tags: Array< JobTag | null > | null,
      timezonePolicy: TimezonePolicy | null,
      timezoneRanges:  Array< {
        __typename: "TimezoneRange",
        start: number | null,
        end: number | null,
      } | null > | null,
      wageIsHourly: boolean | null,
      willSponsor: boolean | null,
      workFromAnywhere: boolean | null,
    } | null,
    applicant:  {
      __typename: "JobSeeker",
      id: string,
      userId: string | null,
      firstName: string | null,
      lastName: string | null,
      city:  {
        __typename: "CityLocation",
        formatted_address: string,
        coordinate:  {
          __typename: "Location",
          lat: number,
          lon: number,
        },
      } | null,
      newGradOrStudent: boolean | null,
      linkedin: string | null,
      website: string | null,
      currentCompany: string | null,
      currentTitle: string | null,
      fullTime: boolean | null,
      partTime: boolean | null,
      contractor: boolean | null,
      fullRemote: boolean | null,
      hybridRemote: boolean | null,
      remoteOptional: boolean | null,
      desiredRole: string | null,
      salaryRequirement:  {
        __typename: "Salary",
        currencyCode: string | null,
        value: number | null,
      } | null,
      authorization:  {
        __typename: "WorkAuthorization",
        usAuthorized: boolean | null,
        requireSponsorshipUS: boolean | null,
      } | null,
      recommendedJobsEmail: boolean | null,
      newsletterEmail: boolean | null,
      notificationSettings:  {
        __typename: "NotificationSettings",
        reviewsProfile: NotificationSetting | null,
      } | null,
      visibleToEmployers: boolean | null,
      emailAddress: string | null,
      phone: string | null,
      phoneVerified: boolean | null,
      profilePic: string | null,
      experienceLevel: ExperienceLevel | null,
      workHistory:  Array< {
        __typename: "WorkHistory",
        company: string,
        title: string,
        startDate: string,
        endDate: string | null,
        currentJob: boolean,
        description: string | null,
      } | null > | null,
      educationHistory:  Array< {
        __typename: "EducationHistory",
        institution: string,
        certification: string,
        concentration: string | null,
        dateStarted: string,
        dateCompleted: string | null,
        inProgress: boolean | null,
        description: string | null,
      } | null > | null,
      applications:  Array< {
        __typename: "Application",
        id: string,
        jobId: string,
        jobSeekerId: string,
        applicationStatus: ApplicationStatus | null,
        coverLetter: string | null,
        job:  {
          __typename: "Job",
          aboutUs: string,
          companyId: string,
          companyWebsite: string | null,
          companyName: string,
          dateCreated: string | null,
          dateModified: string | null,
          datePosted: string | null,
          deleted: boolean | null,
          department: string,
          description: string,
          digitalNomadFriendly: boolean | null,
          elite: boolean | null,
          endSalaryRangeThousands: number | null,
          experience: ExperienceLevel,
          featured: boolean | null,
          featuredRank: number | null,
          flexibleHours: boolean | null,
          id: string,
          jobLogo: string | null,
          jobTitle: string,
          paymentPlan: PaymentPlan | null,
          remoteFirst: boolean | null,
          remotePolicy: JobPolicy | null,
          roleType: WorkType,
          scraped: boolean | null,
          scrapedSource: string | null,
          scrapedUrl: string | null,
          startSalaryRangeThousands: number | null,
          status: JobStatus | null,
          stripeId: string | null,
          tags: Array< JobTag | null > | null,
          timezonePolicy: TimezonePolicy | null,
          wageIsHourly: boolean | null,
          willSponsor: boolean | null,
          workFromAnywhere: boolean | null,
        } | null,
        applicant:  {
          __typename: "JobSeeker",
          id: string,
          userId: string | null,
          firstName: string | null,
          lastName: string | null,
          newGradOrStudent: boolean | null,
          linkedin: string | null,
          website: string | null,
          currentCompany: string | null,
          currentTitle: string | null,
          fullTime: boolean | null,
          partTime: boolean | null,
          contractor: boolean | null,
          fullRemote: boolean | null,
          hybridRemote: boolean | null,
          remoteOptional: boolean | null,
          desiredRole: string | null,
          recommendedJobsEmail: boolean | null,
          newsletterEmail: boolean | null,
          visibleToEmployers: boolean | null,
          emailAddress: string | null,
          phone: string | null,
          phoneVerified: boolean | null,
          profilePic: string | null,
          experienceLevel: ExperienceLevel | null,
          preferencesComplete: boolean | null,
          profileComplete: boolean | null,
          dateCreated: string | null,
          dateModified: string | null,
          deleted: boolean | null,
        } | null,
        proof: string | null,
        isAuto: boolean | null,
        formScreenshot: string | null,
        confirmationScreenshot: string | null,
        generatedResumeUrl: string | null,
        applicationAnswers:  {
          __typename: "ApplicationAnswers",
          id: string,
          applicationId: string,
          jobSeekerId: string,
          jobId: string,
          dateCreated: string | null,
          dateModified: string | null,
        } | null,
        resumeS3Params:  {
          __typename: "ResumeS3Params",
          bucket: string | null,
          key: string | null,
        } | null,
        dateApplied: string | null,
        dateAppliedIndex: string | null,
        dateUpdated: string | null,
      } | null > | null,
      resume:  {
        __typename: "Resume",
        id: string,
        name: string,
        fileType: string,
        size: string,
        url: string,
        resumeJSON: string | null,
        jobSeekerId: string | null,
        dateUploaded: string,
        dateCreated: string,
        deleted: boolean | null,
      } | null,
      autoResumes:  Array< {
        __typename: "Resume",
        id: string,
        name: string,
        fileType: string,
        size: string,
        url: string,
        resumeJSON: string | null,
        jobSeekerId: string | null,
        dateUploaded: string,
        dateCreated: string,
        deleted: boolean | null,
      } | null > | null,
      preferencesComplete: boolean | null,
      profileComplete: boolean | null,
      autoApply:  Array< {
        __typename: "AutoApply",
        id: string | null,
        jobSeekerId: string | null,
        subId: string | null,
        userId: string | null,
        autoGenerateCoverLetter: boolean | null,
        autoGenerateCoverLetterTone: string | null,
        autoGenerateCoverLetterGreeting: string | null,
        autoGenerateCoverLetterSignOff: string | null,
        autoGenerateCoverLetterInstructions: string | null,
        customResumeOptions:  {
          __typename: "ResumeCustomizationOptions",
          shouldCustomize: boolean | null,
          customInstructions: string | null,
        } | null,
        openToRelocation: boolean | null,
        languagesSpoken: Array< string | null > | null,
        age: number | null,
        references:  Array< {
          __typename: "Reference",
          name: string | null,
          email: string | null,
          phone: string | null,
          relationship: string | null,
        } | null > | null,
        genderIdentity: string | null,
        blockedCompanyList: Array< string | null > | null,
        resumeText: string | null,
        coverLetter: string | null,
        aiGenerateCoverLetter: boolean | null,
        coverLetterTone: string | null,
        draft: boolean | null,
        email: string | null,
        isActive: string | null,
        firstName: string | null,
        lastName: string | null,
        remote: boolean | null,
        hybrid: boolean | null,
        onsite: boolean | null,
        jobTitles: Array< string | null > | null,
        negativeJobTitles: Array< string | null > | null,
        industries: Array< string | null > | null,
        education:  {
          __typename: "EducationHistory",
          institution: string,
          certification: string,
          concentration: string | null,
          dateStarted: string,
          dateCompleted: string | null,
          inProgress: boolean | null,
          description: string | null,
        } | null,
        educationHistory:  Array< {
          __typename: "EducationHistory",
          institution: string,
          certification: string,
          concentration: string | null,
          dateStarted: string,
          dateCompleted: string | null,
          inProgress: boolean | null,
          description: string | null,
        } | null > | null,
        experienceLevels: Array< ExperienceLevel | null > | null,
        excludeCompanyNames: Array< string | null > | null,
        expiresAt: string | null,
        subscribedOn: string | null,
        plan: AutoApplySub | null,
        applicationCount: number | null,
        paymentFailed: boolean | null,
        autoLocations:  Array< {
          __typename: "AutoLocation",
          country: string | null,
          region: string | null,
          area: string | null,
        } | null > | null,
        location:  {
          __typename: "CityLocation",
          formatted_address: string,
        } | null,
        country: string | null,
        region: string | null,
        area: string | null,
        customPreference: Array< string | null > | null,
        appliedUrls: Array< string | null > | null,
        salaryMin: number | null,
        salaryMax: number | null,
        salaryRange: string | null,
        searchTags: Array< string | null > | null,
        prompt: string | null,
        phone: string | null,
        address: string | null,
        currentCompany: string | null,
        linkedinProfile: string | null,
        githubProfile: string | null,
        website: string | null,
        gender: string | null,
        pronouns: string | null,
        hispanic: boolean | null,
        race: string | null,
        paused: boolean | null,
        disabled: boolean | null,
        veteran: boolean | null,
        countryAuthorization:  Array< {
          __typename: "CountryAuthorization",
          countryAuthorization: string | null,
          authorizationType: string | null,
          requiresSponsorship: boolean | null,
        } | null > | null,
        secretClearance: boolean | null,
        appCountToday: number | null,
        appCountDateUpdated: string | null,
        maxPerDay: number | null,
        maxPerCo: number | null,
        hourToRun: number | null,
        minuteToRun: number | null,
        resumeUrl: string | null,
        resumeName: string | null,
        trial: boolean | null,
        trialExpired: boolean | null,
        gsiConstant: string | null,
        dateCreated: string | null,
        cancelled: boolean | null,
        searchCustomInstructions: string | null,
      } | null > | null,
      dateCreated: string | null,
      dateModified: string | null,
      deleted: boolean | null,
    } | null,
    proof: string | null,
    isAuto: boolean | null,
    formScreenshot: string | null,
    confirmationScreenshot: string | null,
    generatedResumeUrl: string | null,
    applicationAnswers:  {
      __typename: "ApplicationAnswers",
      id: string,
      applicationId: string,
      jobSeekerId: string,
      jobId: string,
      responses:  Array< {
        __typename: "ApplicationAnswer",
        id: string,
        question: string | null,
        answer: string | null,
        type: ApplicationQuestionType | null,
      } | null > | null,
      dateCreated: string | null,
      dateModified: string | null,
    } | null,
    resumeS3Params:  {
      __typename: "ResumeS3Params",
      bucket: string | null,
      key: string | null,
    } | null,
    dateApplied: string | null,
    dateAppliedIndex: string | null,
    dateUpdated: string | null,
  } | null,
};

export type MarkAllNotificationsAsReadForUserMutationVariables = {
  userId?: string | null,
};

export type MarkAllNotificationsAsReadForUserMutation = {
  markAllNotificationsAsReadForUser: boolean | null,
};

export type FlagContentMutationVariables = {
  input?: FlaggedContentInput | null,
};

export type FlagContentMutation = {
  flagContent:  {
    __typename: "FlaggedContent",
    id: string,
    flaggedContentType: FlaggedContentType | null,
    contentID: string,
    reviewed: boolean,
    description: string | null,
    actionTaken: FlaggedContentActionTaken | null,
    reviewer: string | null,
    dateCreated: string | null,
  } | null,
};

export type AddTestMutationVariables = {
  id: string,
  name: string,
};

export type AddTestMutation = {
  addTest:  {
    __typename: "Test",
    id: string,
    name: string,
  } | null,
};

export type CreateAutoApplyMutationVariables = {
  input?: CreateAutoApplyInput | null,
};

export type CreateAutoApplyMutation = {
  createAutoApply:  {
    __typename: "AutoApply",
    id: string | null,
    jobSeekerId: string | null,
    subId: string | null,
    userId: string | null,
    autoGenerateCoverLetter: boolean | null,
    autoGenerateCoverLetterTone: string | null,
    autoGenerateCoverLetterGreeting: string | null,
    autoGenerateCoverLetterSignOff: string | null,
    autoGenerateCoverLetterInstructions: string | null,
    customResumeOptions:  {
      __typename: "ResumeCustomizationOptions",
      shouldCustomize: boolean | null,
      customInstructions: string | null,
    } | null,
    openToRelocation: boolean | null,
    languagesSpoken: Array< string | null > | null,
    age: number | null,
    references:  Array< {
      __typename: "Reference",
      name: string | null,
      email: string | null,
      phone: string | null,
      relationship: string | null,
    } | null > | null,
    genderIdentity: string | null,
    blockedCompanyList: Array< string | null > | null,
    resumeText: string | null,
    coverLetter: string | null,
    aiGenerateCoverLetter: boolean | null,
    coverLetterTone: string | null,
    draft: boolean | null,
    email: string | null,
    isActive: string | null,
    firstName: string | null,
    lastName: string | null,
    remote: boolean | null,
    hybrid: boolean | null,
    onsite: boolean | null,
    jobTitles: Array< string | null > | null,
    negativeJobTitles: Array< string | null > | null,
    industries: Array< string | null > | null,
    education:  {
      __typename: "EducationHistory",
      institution: string,
      certification: string,
      concentration: string | null,
      dateStarted: string,
      dateCompleted: string | null,
      inProgress: boolean | null,
      description: string | null,
    } | null,
    educationHistory:  Array< {
      __typename: "EducationHistory",
      institution: string,
      certification: string,
      concentration: string | null,
      dateStarted: string,
      dateCompleted: string | null,
      inProgress: boolean | null,
      description: string | null,
    } | null > | null,
    experienceLevels: Array< ExperienceLevel | null > | null,
    excludeCompanyNames: Array< string | null > | null,
    expiresAt: string | null,
    subscribedOn: string | null,
    plan: AutoApplySub | null,
    applicationCount: number | null,
    paymentFailed: boolean | null,
    autoLocations:  Array< {
      __typename: "AutoLocation",
      location:  {
        __typename: "CityLocation",
        formatted_address: string,
        coordinate:  {
          __typename: "Location",
          lat: number,
          lon: number,
        },
      } | null,
      country: string | null,
      region: string | null,
      area: string | null,
    } | null > | null,
    location:  {
      __typename: "CityLocation",
      formatted_address: string,
      coordinate:  {
        __typename: "Location",
        lat: number,
        lon: number,
      },
    } | null,
    country: string | null,
    region: string | null,
    area: string | null,
    customPreference: Array< string | null > | null,
    appliedUrls: Array< string | null > | null,
    salaryMin: number | null,
    salaryMax: number | null,
    salaryRange: string | null,
    searchTags: Array< string | null > | null,
    prompt: string | null,
    phone: string | null,
    address: string | null,
    currentCompany: string | null,
    linkedinProfile: string | null,
    githubProfile: string | null,
    website: string | null,
    gender: string | null,
    pronouns: string | null,
    hispanic: boolean | null,
    race: string | null,
    paused: boolean | null,
    disabled: boolean | null,
    veteran: boolean | null,
    countryAuthorization:  Array< {
      __typename: "CountryAuthorization",
      countryAuthorization: string | null,
      authorizationType: string | null,
      requiresSponsorship: boolean | null,
    } | null > | null,
    secretClearance: boolean | null,
    appCountToday: number | null,
    appCountDateUpdated: string | null,
    maxPerDay: number | null,
    maxPerCo: number | null,
    hourToRun: number | null,
    minuteToRun: number | null,
    resumeUrl: string | null,
    resumeName: string | null,
    trial: boolean | null,
    trialExpired: boolean | null,
    gsiConstant: string | null,
    dateCreated: string | null,
    cancelled: boolean | null,
    searchCustomInstructions: string | null,
  } | null,
};

export type UpdateAutoApplyMutationVariables = {
  input?: UpdateAutoApplyInput | null,
};

export type UpdateAutoApplyMutation = {
  updateAutoApply:  {
    __typename: "AutoApply",
    id: string | null,
    jobSeekerId: string | null,
    subId: string | null,
    userId: string | null,
    autoGenerateCoverLetter: boolean | null,
    autoGenerateCoverLetterTone: string | null,
    autoGenerateCoverLetterGreeting: string | null,
    autoGenerateCoverLetterSignOff: string | null,
    autoGenerateCoverLetterInstructions: string | null,
    customResumeOptions:  {
      __typename: "ResumeCustomizationOptions",
      shouldCustomize: boolean | null,
      customInstructions: string | null,
    } | null,
    openToRelocation: boolean | null,
    languagesSpoken: Array< string | null > | null,
    age: number | null,
    references:  Array< {
      __typename: "Reference",
      name: string | null,
      email: string | null,
      phone: string | null,
      relationship: string | null,
    } | null > | null,
    genderIdentity: string | null,
    blockedCompanyList: Array< string | null > | null,
    resumeText: string | null,
    coverLetter: string | null,
    aiGenerateCoverLetter: boolean | null,
    coverLetterTone: string | null,
    draft: boolean | null,
    email: string | null,
    isActive: string | null,
    firstName: string | null,
    lastName: string | null,
    remote: boolean | null,
    hybrid: boolean | null,
    onsite: boolean | null,
    jobTitles: Array< string | null > | null,
    negativeJobTitles: Array< string | null > | null,
    industries: Array< string | null > | null,
    education:  {
      __typename: "EducationHistory",
      institution: string,
      certification: string,
      concentration: string | null,
      dateStarted: string,
      dateCompleted: string | null,
      inProgress: boolean | null,
      description: string | null,
    } | null,
    educationHistory:  Array< {
      __typename: "EducationHistory",
      institution: string,
      certification: string,
      concentration: string | null,
      dateStarted: string,
      dateCompleted: string | null,
      inProgress: boolean | null,
      description: string | null,
    } | null > | null,
    experienceLevels: Array< ExperienceLevel | null > | null,
    excludeCompanyNames: Array< string | null > | null,
    expiresAt: string | null,
    subscribedOn: string | null,
    plan: AutoApplySub | null,
    applicationCount: number | null,
    paymentFailed: boolean | null,
    autoLocations:  Array< {
      __typename: "AutoLocation",
      location:  {
        __typename: "CityLocation",
        formatted_address: string,
        coordinate:  {
          __typename: "Location",
          lat: number,
          lon: number,
        },
      } | null,
      country: string | null,
      region: string | null,
      area: string | null,
    } | null > | null,
    location:  {
      __typename: "CityLocation",
      formatted_address: string,
      coordinate:  {
        __typename: "Location",
        lat: number,
        lon: number,
      },
    } | null,
    country: string | null,
    region: string | null,
    area: string | null,
    customPreference: Array< string | null > | null,
    appliedUrls: Array< string | null > | null,
    salaryMin: number | null,
    salaryMax: number | null,
    salaryRange: string | null,
    searchTags: Array< string | null > | null,
    prompt: string | null,
    phone: string | null,
    address: string | null,
    currentCompany: string | null,
    linkedinProfile: string | null,
    githubProfile: string | null,
    website: string | null,
    gender: string | null,
    pronouns: string | null,
    hispanic: boolean | null,
    race: string | null,
    paused: boolean | null,
    disabled: boolean | null,
    veteran: boolean | null,
    countryAuthorization:  Array< {
      __typename: "CountryAuthorization",
      countryAuthorization: string | null,
      authorizationType: string | null,
      requiresSponsorship: boolean | null,
    } | null > | null,
    secretClearance: boolean | null,
    appCountToday: number | null,
    appCountDateUpdated: string | null,
    maxPerDay: number | null,
    maxPerCo: number | null,
    hourToRun: number | null,
    minuteToRun: number | null,
    resumeUrl: string | null,
    resumeName: string | null,
    trial: boolean | null,
    trialExpired: boolean | null,
    gsiConstant: string | null,
    dateCreated: string | null,
    cancelled: boolean | null,
    searchCustomInstructions: string | null,
  } | null,
};

export type AddAutoResumeToJobSeekerMutationVariables = {
  input?: ResumeInput | null,
};

export type AddAutoResumeToJobSeekerMutation = {
  addAutoResumeToJobSeeker:  {
    __typename: "Resume",
    id: string,
    name: string,
    fileType: string,
    size: string,
    url: string,
    resumeJSON: string | null,
    jobSeekerId: string | null,
    dateUploaded: string,
    dateCreated: string,
    deleted: boolean | null,
  } | null,
};

export type RemoveAutoResumeFromJobSeekerMutationVariables = {
  resumeId?: string | null,
  dateCreated?: string | null,
};

export type RemoveAutoResumeFromJobSeekerMutation = {
  removeAutoResumeFromJobSeeker:  {
    __typename: "Resume",
    id: string,
    name: string,
    fileType: string,
    size: string,
    url: string,
    resumeJSON: string | null,
    jobSeekerId: string | null,
    dateUploaded: string,
    dateCreated: string,
    deleted: boolean | null,
  } | null,
};

export type CreateResumeMutationVariables = {
  input?: ResumeInput | null,
};

export type CreateResumeMutation = {
  createResume:  {
    __typename: "Resume",
    id: string,
    name: string,
    fileType: string,
    size: string,
    url: string,
    resumeJSON: string | null,
    jobSeekerId: string | null,
    dateUploaded: string,
    dateCreated: string,
    deleted: boolean | null,
  } | null,
};

export type ListJobsQuery = {
  listJobs:  Array< {
    __typename: "Job",
    aboutUs: string,
    applications:  Array< {
      __typename: "Application",
      id: string,
      jobId: string,
      jobSeekerId: string,
      applicationStatus: ApplicationStatus | null,
      coverLetter: string | null,
      job:  {
        __typename: "Job",
        aboutUs: string,
        applications:  Array< {
          __typename: "Application",
          id: string,
          jobId: string,
          jobSeekerId: string,
          applicationStatus: ApplicationStatus | null,
          coverLetter: string | null,
          proof: string | null,
          isAuto: boolean | null,
          formScreenshot: string | null,
          confirmationScreenshot: string | null,
          generatedResumeUrl: string | null,
          dateApplied: string | null,
          dateAppliedIndex: string | null,
          dateUpdated: string | null,
        } | null > | null,
        applicationQuestions:  {
          __typename: "ApplicationQuestions",
          id: string,
          jobId: string,
        } | null,
        companyId: string,
        communications:  {
          __typename: "CommunicationInfo",
          emails: Array< string | null > | null,
          phone: string | null,
        } | null,
        companyProfile:  {
          __typename: "EmployerProfile",
          industries: Array< string | null > | null,
          remotePolicy: Policy | null,
          name: string | null,
          bio: string | null,
          hasHeadquarters: boolean | null,
          emailAddress: string | null,
          phoneNumber: string | null,
          image: string | null,
        } | null,
        companyWebsite: string | null,
        companyName: string,
        dateCreated: string | null,
        dateModified: string | null,
        datePosted: string | null,
        deleted: boolean | null,
        department: string,
        description: string,
        digitalNomadFriendly: boolean | null,
        elite: boolean | null,
        endSalaryRangeThousands: number | null,
        experience: ExperienceLevel,
        featured: boolean | null,
        featuredRank: number | null,
        flexibleHours: boolean | null,
        id: string,
        jobLogo: string | null,
        jobTitle: string,
        officeFrequency:  {
          __typename: "OfficeFrequency",
          daysPerMonth: number | null,
          daysPerWeek: number | null,
        } | null,
        officeLocations:  Array< {
          __typename: "CityLocation",
          formatted_address: string,
        } | null > | null,
        paymentHistory:  Array< {
          __typename: "PaymentRecord",
          stripeId: string,
          productId: string,
          paymentPlan: PaymentPlan,
          dateCreated: string,
          dateEnded: string | null,
        } | null > | null,
        paymentPlan: PaymentPlan | null,
        remoteFirst: boolean | null,
        remotePolicy: JobPolicy | null,
        roleType: WorkType,
        scraped: boolean | null,
        scrapedSource: string | null,
        scrapedUrl: string | null,
        startSalaryRangeThousands: number | null,
        status: JobStatus | null,
        stripeId: string | null,
        tags: Array< JobTag | null > | null,
        timezonePolicy: TimezonePolicy | null,
        timezoneRanges:  Array< {
          __typename: "TimezoneRange",
          start: number | null,
          end: number | null,
        } | null > | null,
        wageIsHourly: boolean | null,
        willSponsor: boolean | null,
        workFromAnywhere: boolean | null,
      } | null,
      applicant:  {
        __typename: "JobSeeker",
        id: string,
        userId: string | null,
        firstName: string | null,
        lastName: string | null,
        city:  {
          __typename: "CityLocation",
          formatted_address: string,
        } | null,
        newGradOrStudent: boolean | null,
        linkedin: string | null,
        website: string | null,
        currentCompany: string | null,
        currentTitle: string | null,
        fullTime: boolean | null,
        partTime: boolean | null,
        contractor: boolean | null,
        fullRemote: boolean | null,
        hybridRemote: boolean | null,
        remoteOptional: boolean | null,
        desiredRole: string | null,
        salaryRequirement:  {
          __typename: "Salary",
          currencyCode: string | null,
          value: number | null,
        } | null,
        authorization:  {
          __typename: "WorkAuthorization",
          usAuthorized: boolean | null,
          requireSponsorshipUS: boolean | null,
        } | null,
        recommendedJobsEmail: boolean | null,
        newsletterEmail: boolean | null,
        notificationSettings:  {
          __typename: "NotificationSettings",
          reviewsProfile: NotificationSetting | null,
        } | null,
        visibleToEmployers: boolean | null,
        emailAddress: string | null,
        phone: string | null,
        phoneVerified: boolean | null,
        profilePic: string | null,
        experienceLevel: ExperienceLevel | null,
        workHistory:  Array< {
          __typename: "WorkHistory",
          company: string,
          title: string,
          startDate: string,
          endDate: string | null,
          currentJob: boolean,
          description: string | null,
        } | null > | null,
        educationHistory:  Array< {
          __typename: "EducationHistory",
          institution: string,
          certification: string,
          concentration: string | null,
          dateStarted: string,
          dateCompleted: string | null,
          inProgress: boolean | null,
          description: string | null,
        } | null > | null,
        applications:  Array< {
          __typename: "Application",
          id: string,
          jobId: string,
          jobSeekerId: string,
          applicationStatus: ApplicationStatus | null,
          coverLetter: string | null,
          proof: string | null,
          isAuto: boolean | null,
          formScreenshot: string | null,
          confirmationScreenshot: string | null,
          generatedResumeUrl: string | null,
          dateApplied: string | null,
          dateAppliedIndex: string | null,
          dateUpdated: string | null,
        } | null > | null,
        resume:  {
          __typename: "Resume",
          id: string,
          name: string,
          fileType: string,
          size: string,
          url: string,
          resumeJSON: string | null,
          jobSeekerId: string | null,
          dateUploaded: string,
          dateCreated: string,
          deleted: boolean | null,
        } | null,
        autoResumes:  Array< {
          __typename: "Resume",
          id: string,
          name: string,
          fileType: string,
          size: string,
          url: string,
          resumeJSON: string | null,
          jobSeekerId: string | null,
          dateUploaded: string,
          dateCreated: string,
          deleted: boolean | null,
        } | null > | null,
        preferencesComplete: boolean | null,
        profileComplete: boolean | null,
        autoApply:  Array< {
          __typename: "AutoApply",
          id: string | null,
          jobSeekerId: string | null,
          subId: string | null,
          userId: string | null,
          autoGenerateCoverLetter: boolean | null,
          autoGenerateCoverLetterTone: string | null,
          autoGenerateCoverLetterGreeting: string | null,
          autoGenerateCoverLetterSignOff: string | null,
          autoGenerateCoverLetterInstructions: string | null,
          openToRelocation: boolean | null,
          languagesSpoken: Array< string | null > | null,
          age: number | null,
          genderIdentity: string | null,
          blockedCompanyList: Array< string | null > | null,
          resumeText: string | null,
          coverLetter: string | null,
          aiGenerateCoverLetter: boolean | null,
          coverLetterTone: string | null,
          draft: boolean | null,
          email: string | null,
          isActive: string | null,
          firstName: string | null,
          lastName: string | null,
          remote: boolean | null,
          hybrid: boolean | null,
          onsite: boolean | null,
          jobTitles: Array< string | null > | null,
          negativeJobTitles: Array< string | null > | null,
          industries: Array< string | null > | null,
          experienceLevels: Array< ExperienceLevel | null > | null,
          excludeCompanyNames: Array< string | null > | null,
          expiresAt: string | null,
          subscribedOn: string | null,
          plan: AutoApplySub | null,
          applicationCount: number | null,
          paymentFailed: boolean | null,
          country: string | null,
          region: string | null,
          area: string | null,
          customPreference: Array< string | null > | null,
          appliedUrls: Array< string | null > | null,
          salaryMin: number | null,
          salaryMax: number | null,
          salaryRange: string | null,
          searchTags: Array< string | null > | null,
          prompt: string | null,
          phone: string | null,
          address: string | null,
          currentCompany: string | null,
          linkedinProfile: string | null,
          githubProfile: string | null,
          website: string | null,
          gender: string | null,
          pronouns: string | null,
          hispanic: boolean | null,
          race: string | null,
          paused: boolean | null,
          disabled: boolean | null,
          veteran: boolean | null,
          secretClearance: boolean | null,
          appCountToday: number | null,
          appCountDateUpdated: string | null,
          maxPerDay: number | null,
          maxPerCo: number | null,
          hourToRun: number | null,
          minuteToRun: number | null,
          resumeUrl: string | null,
          resumeName: string | null,
          trial: boolean | null,
          trialExpired: boolean | null,
          gsiConstant: string | null,
          dateCreated: string | null,
          cancelled: boolean | null,
          searchCustomInstructions: string | null,
        } | null > | null,
        dateCreated: string | null,
        dateModified: string | null,
        deleted: boolean | null,
      } | null,
      proof: string | null,
      isAuto: boolean | null,
      formScreenshot: string | null,
      confirmationScreenshot: string | null,
      generatedResumeUrl: string | null,
      applicationAnswers:  {
        __typename: "ApplicationAnswers",
        id: string,
        applicationId: string,
        jobSeekerId: string,
        jobId: string,
        responses:  Array< {
          __typename: "ApplicationAnswer",
          id: string,
          question: string | null,
          answer: string | null,
          type: ApplicationQuestionType | null,
        } | null > | null,
        dateCreated: string | null,
        dateModified: string | null,
      } | null,
      resumeS3Params:  {
        __typename: "ResumeS3Params",
        bucket: string | null,
        key: string | null,
      } | null,
      dateApplied: string | null,
      dateAppliedIndex: string | null,
      dateUpdated: string | null,
    } | null > | null,
    applicationQuestions:  {
      __typename: "ApplicationQuestions",
      id: string,
      jobId: string,
      questions:  Array< {
        __typename: "ApplicationQuestion",
        question: string,
        type: ApplicationQuestionType,
        selector: string,
        options: Array< string | null > | null,
      } | null > | null,
    } | null,
    companyId: string,
    communications:  {
      __typename: "CommunicationInfo",
      emails: Array< string | null > | null,
      phone: string | null,
    } | null,
    companyProfile:  {
      __typename: "EmployerProfile",
      industries: Array< string | null > | null,
      remotePolicy: Policy | null,
      name: string | null,
      bio: string | null,
      hasHeadquarters: boolean | null,
      hqAddress:  {
        __typename: "CityLocation",
        formatted_address: string,
        coordinate:  {
          __typename: "Location",
          lat: number,
          lon: number,
        },
      } | null,
      emailAddress: string | null,
      phoneNumber: string | null,
      image: string | null,
    } | null,
    companyWebsite: string | null,
    companyName: string,
    dateCreated: string | null,
    dateModified: string | null,
    datePosted: string | null,
    deleted: boolean | null,
    department: string,
    description: string,
    digitalNomadFriendly: boolean | null,
    elite: boolean | null,
    endSalaryRangeThousands: number | null,
    experience: ExperienceLevel,
    featured: boolean | null,
    featuredRank: number | null,
    flexibleHours: boolean | null,
    id: string,
    jobLogo: string | null,
    jobTitle: string,
    officeFrequency:  {
      __typename: "OfficeFrequency",
      daysPerMonth: number | null,
      daysPerWeek: number | null,
    } | null,
    officeLocations:  Array< {
      __typename: "CityLocation",
      formatted_address: string,
      coordinate:  {
        __typename: "Location",
        lat: number,
        lon: number,
      },
    } | null > | null,
    paymentHistory:  Array< {
      __typename: "PaymentRecord",
      stripeId: string,
      productId: string,
      paymentPlan: PaymentPlan,
      dateCreated: string,
      dateEnded: string | null,
    } | null > | null,
    paymentPlan: PaymentPlan | null,
    remoteFirst: boolean | null,
    remotePolicy: JobPolicy | null,
    roleType: WorkType,
    scraped: boolean | null,
    scrapedSource: string | null,
    scrapedUrl: string | null,
    startSalaryRangeThousands: number | null,
    status: JobStatus | null,
    stripeId: string | null,
    tags: Array< JobTag | null > | null,
    timezonePolicy: TimezonePolicy | null,
    timezoneRanges:  Array< {
      __typename: "TimezoneRange",
      start: number | null,
      end: number | null,
    } | null > | null,
    wageIsHourly: boolean | null,
    willSponsor: boolean | null,
    workFromAnywhere: boolean | null,
  } | null > | null,
};

export type GetExecutionHistoryForJobSeekerIdQueryVariables = {
  jobSeekerId: string,
  first?: number | null,
  after?: ExecutionCursorInput | null,
  last?: number | null,
  before?: ExecutionCursorInput | null,
};

export type GetExecutionHistoryForJobSeekerIdQuery = {
  getExecutionHistoryForJobSeekerId:  {
    __typename: "ExecutionConnection",
    edges:  Array< {
      __typename: "ExecutionEdge",
      node:  {
        __typename: "ExecutionHistoryEntry",
        id: string,
        jobSeekerId: string,
        executionArn: string,
        queuedJobsAtStart: Array< string | null > | null,
        queueLengthAtStart: number | null,
        queueLengthAtEnd: number | null,
        jobsSucceededCount: number | null,
        jobsSucceeded: Array< string | null > | null,
        jobsFailedCount: number | null,
        jobsFailed: Array< string | null > | null,
        jobsEvaluatedCount: number | null,
        jobsEvaluated: Array< string | null > | null,
        passedJobTitleList: Array< string | null > | null,
        passedJobTitleListCount: number | null,
        passedJobDescriptionList: Array< string | null > | null,
        passedJobDescriptionListCount: number | null,
        jobsAddedToQueue: Array< string | null > | null,
        jobsAddedToQueueCount: number | null,
        dateCreated: string | null,
        dateStarted: string | null,
      },
      cursor:  {
        __typename: "ExecutionCursor",
        id: string,
        dateCreated: string | null,
      },
    } >,
    pageInfo:  {
      __typename: "ExecutionPageInfo",
      startCursor:  {
        __typename: "ExecutionCursor",
        id: string,
        dateCreated: string | null,
      } | null,
      endCursor:  {
        __typename: "ExecutionCursor",
        id: string,
        dateCreated: string | null,
      } | null,
      hasNextPage: boolean,
      hasPreviousPage: boolean,
    } | null,
  } | null,
};

export type GetUserByIdQueryVariables = {
  userId: string,
};

export type GetUserByIdQuery = {
  getUserById:  {
    __typename: "User",
    id: string,
    email: string | null,
    emailVerified: boolean | null,
    phoneVerified: boolean | null,
    companyId: string | null,
    group: string | null,
    onboardingCompleted: boolean | null,
    firstName: string | null,
    lastName: string | null,
    age: number | null,
    company:  {
      __typename: "Company",
      id: string,
      dateCreated: string,
      dateModified: string,
      ownerId: string,
      ownerEmail: string,
      profile:  {
        __typename: "EmployerProfile",
        industries: Array< string | null > | null,
        remotePolicy: Policy | null,
        name: string | null,
        bio: string | null,
        hasHeadquarters: boolean | null,
        hqAddress:  {
          __typename: "CityLocation",
          formatted_address: string,
        } | null,
        emailAddress: string | null,
        phoneNumber: string | null,
        image: string | null,
      } | null,
      publicProfile:  {
        __typename: "CompanyProfile",
        id: string,
        builtId: string | null,
        companyAlias: string | null,
        readableName: string | null,
        description: string,
        headCount: string | null,
        website: string | null,
        careerPage: string | null,
        stage: Stage | null,
        isPublic: boolean | null,
        headquarters: string | null,
        valueMillions: number | null,
        isUnicorn: boolean | null,
        isRemoteFirst: boolean | null,
        isHybrid: boolean | null,
        isMixed: boolean | null,
        workFromAnywhere: boolean | null,
        hasFlexibleHours: boolean | null,
        isMissionDriven: boolean | null,
        linkedinUrl: string | null,
        crunchbaseUrl: string | null,
        glassdoorUrl: string | null,
      } | null,
      jobPostings:  Array< {
        __typename: "Job",
        aboutUs: string,
        applications:  Array< {
          __typename: "Application",
          id: string,
          jobId: string,
          jobSeekerId: string,
          applicationStatus: ApplicationStatus | null,
          coverLetter: string | null,
          proof: string | null,
          isAuto: boolean | null,
          formScreenshot: string | null,
          confirmationScreenshot: string | null,
          generatedResumeUrl: string | null,
          dateApplied: string | null,
          dateAppliedIndex: string | null,
          dateUpdated: string | null,
        } | null > | null,
        applicationQuestions:  {
          __typename: "ApplicationQuestions",
          id: string,
          jobId: string,
        } | null,
        companyId: string,
        communications:  {
          __typename: "CommunicationInfo",
          emails: Array< string | null > | null,
          phone: string | null,
        } | null,
        companyProfile:  {
          __typename: "EmployerProfile",
          industries: Array< string | null > | null,
          remotePolicy: Policy | null,
          name: string | null,
          bio: string | null,
          hasHeadquarters: boolean | null,
          emailAddress: string | null,
          phoneNumber: string | null,
          image: string | null,
        } | null,
        companyWebsite: string | null,
        companyName: string,
        dateCreated: string | null,
        dateModified: string | null,
        datePosted: string | null,
        deleted: boolean | null,
        department: string,
        description: string,
        digitalNomadFriendly: boolean | null,
        elite: boolean | null,
        endSalaryRangeThousands: number | null,
        experience: ExperienceLevel,
        featured: boolean | null,
        featuredRank: number | null,
        flexibleHours: boolean | null,
        id: string,
        jobLogo: string | null,
        jobTitle: string,
        officeFrequency:  {
          __typename: "OfficeFrequency",
          daysPerMonth: number | null,
          daysPerWeek: number | null,
        } | null,
        officeLocations:  Array< {
          __typename: "CityLocation",
          formatted_address: string,
        } | null > | null,
        paymentHistory:  Array< {
          __typename: "PaymentRecord",
          stripeId: string,
          productId: string,
          paymentPlan: PaymentPlan,
          dateCreated: string,
          dateEnded: string | null,
        } | null > | null,
        paymentPlan: PaymentPlan | null,
        remoteFirst: boolean | null,
        remotePolicy: JobPolicy | null,
        roleType: WorkType,
        scraped: boolean | null,
        scrapedSource: string | null,
        scrapedUrl: string | null,
        startSalaryRangeThousands: number | null,
        status: JobStatus | null,
        stripeId: string | null,
        tags: Array< JobTag | null > | null,
        timezonePolicy: TimezonePolicy | null,
        timezoneRanges:  Array< {
          __typename: "TimezoneRange",
          start: number | null,
          end: number | null,
        } | null > | null,
        wageIsHourly: boolean | null,
        willSponsor: boolean | null,
        workFromAnywhere: boolean | null,
      } | null > | null,
      signupPromo: string | null,
      website: string | null,
      deleted: boolean | null,
    } | null,
    jobSeeker:  {
      __typename: "JobSeeker",
      id: string,
      userId: string | null,
      firstName: string | null,
      lastName: string | null,
      city:  {
        __typename: "CityLocation",
        formatted_address: string,
        coordinate:  {
          __typename: "Location",
          lat: number,
          lon: number,
        },
      } | null,
      newGradOrStudent: boolean | null,
      linkedin: string | null,
      website: string | null,
      currentCompany: string | null,
      currentTitle: string | null,
      fullTime: boolean | null,
      partTime: boolean | null,
      contractor: boolean | null,
      fullRemote: boolean | null,
      hybridRemote: boolean | null,
      remoteOptional: boolean | null,
      desiredRole: string | null,
      salaryRequirement:  {
        __typename: "Salary",
        currencyCode: string | null,
        value: number | null,
      } | null,
      authorization:  {
        __typename: "WorkAuthorization",
        usAuthorized: boolean | null,
        requireSponsorshipUS: boolean | null,
      } | null,
      recommendedJobsEmail: boolean | null,
      newsletterEmail: boolean | null,
      notificationSettings:  {
        __typename: "NotificationSettings",
        reviewsProfile: NotificationSetting | null,
      } | null,
      visibleToEmployers: boolean | null,
      emailAddress: string | null,
      phone: string | null,
      phoneVerified: boolean | null,
      profilePic: string | null,
      experienceLevel: ExperienceLevel | null,
      workHistory:  Array< {
        __typename: "WorkHistory",
        company: string,
        title: string,
        startDate: string,
        endDate: string | null,
        currentJob: boolean,
        description: string | null,
      } | null > | null,
      educationHistory:  Array< {
        __typename: "EducationHistory",
        institution: string,
        certification: string,
        concentration: string | null,
        dateStarted: string,
        dateCompleted: string | null,
        inProgress: boolean | null,
        description: string | null,
      } | null > | null,
      applications:  Array< {
        __typename: "Application",
        id: string,
        jobId: string,
        jobSeekerId: string,
        applicationStatus: ApplicationStatus | null,
        coverLetter: string | null,
        job:  {
          __typename: "Job",
          aboutUs: string,
          companyId: string,
          companyWebsite: string | null,
          companyName: string,
          dateCreated: string | null,
          dateModified: string | null,
          datePosted: string | null,
          deleted: boolean | null,
          department: string,
          description: string,
          digitalNomadFriendly: boolean | null,
          elite: boolean | null,
          endSalaryRangeThousands: number | null,
          experience: ExperienceLevel,
          featured: boolean | null,
          featuredRank: number | null,
          flexibleHours: boolean | null,
          id: string,
          jobLogo: string | null,
          jobTitle: string,
          paymentPlan: PaymentPlan | null,
          remoteFirst: boolean | null,
          remotePolicy: JobPolicy | null,
          roleType: WorkType,
          scraped: boolean | null,
          scrapedSource: string | null,
          scrapedUrl: string | null,
          startSalaryRangeThousands: number | null,
          status: JobStatus | null,
          stripeId: string | null,
          tags: Array< JobTag | null > | null,
          timezonePolicy: TimezonePolicy | null,
          wageIsHourly: boolean | null,
          willSponsor: boolean | null,
          workFromAnywhere: boolean | null,
        } | null,
        applicant:  {
          __typename: "JobSeeker",
          id: string,
          userId: string | null,
          firstName: string | null,
          lastName: string | null,
          newGradOrStudent: boolean | null,
          linkedin: string | null,
          website: string | null,
          currentCompany: string | null,
          currentTitle: string | null,
          fullTime: boolean | null,
          partTime: boolean | null,
          contractor: boolean | null,
          fullRemote: boolean | null,
          hybridRemote: boolean | null,
          remoteOptional: boolean | null,
          desiredRole: string | null,
          recommendedJobsEmail: boolean | null,
          newsletterEmail: boolean | null,
          visibleToEmployers: boolean | null,
          emailAddress: string | null,
          phone: string | null,
          phoneVerified: boolean | null,
          profilePic: string | null,
          experienceLevel: ExperienceLevel | null,
          preferencesComplete: boolean | null,
          profileComplete: boolean | null,
          dateCreated: string | null,
          dateModified: string | null,
          deleted: boolean | null,
        } | null,
        proof: string | null,
        isAuto: boolean | null,
        formScreenshot: string | null,
        confirmationScreenshot: string | null,
        generatedResumeUrl: string | null,
        applicationAnswers:  {
          __typename: "ApplicationAnswers",
          id: string,
          applicationId: string,
          jobSeekerId: string,
          jobId: string,
          dateCreated: string | null,
          dateModified: string | null,
        } | null,
        resumeS3Params:  {
          __typename: "ResumeS3Params",
          bucket: string | null,
          key: string | null,
        } | null,
        dateApplied: string | null,
        dateAppliedIndex: string | null,
        dateUpdated: string | null,
      } | null > | null,
      resume:  {
        __typename: "Resume",
        id: string,
        name: string,
        fileType: string,
        size: string,
        url: string,
        resumeJSON: string | null,
        jobSeekerId: string | null,
        dateUploaded: string,
        dateCreated: string,
        deleted: boolean | null,
      } | null,
      autoResumes:  Array< {
        __typename: "Resume",
        id: string,
        name: string,
        fileType: string,
        size: string,
        url: string,
        resumeJSON: string | null,
        jobSeekerId: string | null,
        dateUploaded: string,
        dateCreated: string,
        deleted: boolean | null,
      } | null > | null,
      preferencesComplete: boolean | null,
      profileComplete: boolean | null,
      autoApply:  Array< {
        __typename: "AutoApply",
        id: string | null,
        jobSeekerId: string | null,
        subId: string | null,
        userId: string | null,
        autoGenerateCoverLetter: boolean | null,
        autoGenerateCoverLetterTone: string | null,
        autoGenerateCoverLetterGreeting: string | null,
        autoGenerateCoverLetterSignOff: string | null,
        autoGenerateCoverLetterInstructions: string | null,
        customResumeOptions:  {
          __typename: "ResumeCustomizationOptions",
          shouldCustomize: boolean | null,
          customInstructions: string | null,
        } | null,
        openToRelocation: boolean | null,
        languagesSpoken: Array< string | null > | null,
        age: number | null,
        references:  Array< {
          __typename: "Reference",
          name: string | null,
          email: string | null,
          phone: string | null,
          relationship: string | null,
        } | null > | null,
        genderIdentity: string | null,
        blockedCompanyList: Array< string | null > | null,
        resumeText: string | null,
        coverLetter: string | null,
        aiGenerateCoverLetter: boolean | null,
        coverLetterTone: string | null,
        draft: boolean | null,
        email: string | null,
        isActive: string | null,
        firstName: string | null,
        lastName: string | null,
        remote: boolean | null,
        hybrid: boolean | null,
        onsite: boolean | null,
        jobTitles: Array< string | null > | null,
        negativeJobTitles: Array< string | null > | null,
        industries: Array< string | null > | null,
        education:  {
          __typename: "EducationHistory",
          institution: string,
          certification: string,
          concentration: string | null,
          dateStarted: string,
          dateCompleted: string | null,
          inProgress: boolean | null,
          description: string | null,
        } | null,
        educationHistory:  Array< {
          __typename: "EducationHistory",
          institution: string,
          certification: string,
          concentration: string | null,
          dateStarted: string,
          dateCompleted: string | null,
          inProgress: boolean | null,
          description: string | null,
        } | null > | null,
        experienceLevels: Array< ExperienceLevel | null > | null,
        excludeCompanyNames: Array< string | null > | null,
        expiresAt: string | null,
        subscribedOn: string | null,
        plan: AutoApplySub | null,
        applicationCount: number | null,
        paymentFailed: boolean | null,
        autoLocations:  Array< {
          __typename: "AutoLocation",
          country: string | null,
          region: string | null,
          area: string | null,
        } | null > | null,
        location:  {
          __typename: "CityLocation",
          formatted_address: string,
        } | null,
        country: string | null,
        region: string | null,
        area: string | null,
        customPreference: Array< string | null > | null,
        appliedUrls: Array< string | null > | null,
        salaryMin: number | null,
        salaryMax: number | null,
        salaryRange: string | null,
        searchTags: Array< string | null > | null,
        prompt: string | null,
        phone: string | null,
        address: string | null,
        currentCompany: string | null,
        linkedinProfile: string | null,
        githubProfile: string | null,
        website: string | null,
        gender: string | null,
        pronouns: string | null,
        hispanic: boolean | null,
        race: string | null,
        paused: boolean | null,
        disabled: boolean | null,
        veteran: boolean | null,
        countryAuthorization:  Array< {
          __typename: "CountryAuthorization",
          countryAuthorization: string | null,
          authorizationType: string | null,
          requiresSponsorship: boolean | null,
        } | null > | null,
        secretClearance: boolean | null,
        appCountToday: number | null,
        appCountDateUpdated: string | null,
        maxPerDay: number | null,
        maxPerCo: number | null,
        hourToRun: number | null,
        minuteToRun: number | null,
        resumeUrl: string | null,
        resumeName: string | null,
        trial: boolean | null,
        trialExpired: boolean | null,
        gsiConstant: string | null,
        dateCreated: string | null,
        cancelled: boolean | null,
        searchCustomInstructions: string | null,
      } | null > | null,
      dateCreated: string | null,
      dateModified: string | null,
      deleted: boolean | null,
    } | null,
    notifications:  Array< {
      __typename: "Notification",
      id: string,
      notificationType: NotificationType | null,
      message: string | null,
      textMessage: string | null,
      userId: string,
      url: string | null,
      read: boolean | null,
      dateCreated: string | null,
      dateRead: string | null,
    } | null > | null,
    trailUsed: boolean | null,
    howDidYouFindUs: howDidYouFindUs | null,
    howDidYouFindUsOther: string | null,
    employmentStatus: EmploymentStatus | null,
    jobSearchStage: JobSearchStage | null,
    interviewCount: number | null,
    deleted: boolean | null,
  } | null,
};

export type GetJobByIdQueryVariables = {
  jobId: string,
};

export type GetJobByIdQuery = {
  getJobById:  {
    __typename: "Job",
    aboutUs: string,
    applications:  Array< {
      __typename: "Application",
      id: string,
      jobId: string,
      jobSeekerId: string,
      applicationStatus: ApplicationStatus | null,
      coverLetter: string | null,
      job:  {
        __typename: "Job",
        aboutUs: string,
        applications:  Array< {
          __typename: "Application",
          id: string,
          jobId: string,
          jobSeekerId: string,
          applicationStatus: ApplicationStatus | null,
          coverLetter: string | null,
          proof: string | null,
          isAuto: boolean | null,
          formScreenshot: string | null,
          confirmationScreenshot: string | null,
          generatedResumeUrl: string | null,
          dateApplied: string | null,
          dateAppliedIndex: string | null,
          dateUpdated: string | null,
        } | null > | null,
        applicationQuestions:  {
          __typename: "ApplicationQuestions",
          id: string,
          jobId: string,
        } | null,
        companyId: string,
        communications:  {
          __typename: "CommunicationInfo",
          emails: Array< string | null > | null,
          phone: string | null,
        } | null,
        companyProfile:  {
          __typename: "EmployerProfile",
          industries: Array< string | null > | null,
          remotePolicy: Policy | null,
          name: string | null,
          bio: string | null,
          hasHeadquarters: boolean | null,
          emailAddress: string | null,
          phoneNumber: string | null,
          image: string | null,
        } | null,
        companyWebsite: string | null,
        companyName: string,
        dateCreated: string | null,
        dateModified: string | null,
        datePosted: string | null,
        deleted: boolean | null,
        department: string,
        description: string,
        digitalNomadFriendly: boolean | null,
        elite: boolean | null,
        endSalaryRangeThousands: number | null,
        experience: ExperienceLevel,
        featured: boolean | null,
        featuredRank: number | null,
        flexibleHours: boolean | null,
        id: string,
        jobLogo: string | null,
        jobTitle: string,
        officeFrequency:  {
          __typename: "OfficeFrequency",
          daysPerMonth: number | null,
          daysPerWeek: number | null,
        } | null,
        officeLocations:  Array< {
          __typename: "CityLocation",
          formatted_address: string,
        } | null > | null,
        paymentHistory:  Array< {
          __typename: "PaymentRecord",
          stripeId: string,
          productId: string,
          paymentPlan: PaymentPlan,
          dateCreated: string,
          dateEnded: string | null,
        } | null > | null,
        paymentPlan: PaymentPlan | null,
        remoteFirst: boolean | null,
        remotePolicy: JobPolicy | null,
        roleType: WorkType,
        scraped: boolean | null,
        scrapedSource: string | null,
        scrapedUrl: string | null,
        startSalaryRangeThousands: number | null,
        status: JobStatus | null,
        stripeId: string | null,
        tags: Array< JobTag | null > | null,
        timezonePolicy: TimezonePolicy | null,
        timezoneRanges:  Array< {
          __typename: "TimezoneRange",
          start: number | null,
          end: number | null,
        } | null > | null,
        wageIsHourly: boolean | null,
        willSponsor: boolean | null,
        workFromAnywhere: boolean | null,
      } | null,
      applicant:  {
        __typename: "JobSeeker",
        id: string,
        userId: string | null,
        firstName: string | null,
        lastName: string | null,
        city:  {
          __typename: "CityLocation",
          formatted_address: string,
        } | null,
        newGradOrStudent: boolean | null,
        linkedin: string | null,
        website: string | null,
        currentCompany: string | null,
        currentTitle: string | null,
        fullTime: boolean | null,
        partTime: boolean | null,
        contractor: boolean | null,
        fullRemote: boolean | null,
        hybridRemote: boolean | null,
        remoteOptional: boolean | null,
        desiredRole: string | null,
        salaryRequirement:  {
          __typename: "Salary",
          currencyCode: string | null,
          value: number | null,
        } | null,
        authorization:  {
          __typename: "WorkAuthorization",
          usAuthorized: boolean | null,
          requireSponsorshipUS: boolean | null,
        } | null,
        recommendedJobsEmail: boolean | null,
        newsletterEmail: boolean | null,
        notificationSettings:  {
          __typename: "NotificationSettings",
          reviewsProfile: NotificationSetting | null,
        } | null,
        visibleToEmployers: boolean | null,
        emailAddress: string | null,
        phone: string | null,
        phoneVerified: boolean | null,
        profilePic: string | null,
        experienceLevel: ExperienceLevel | null,
        workHistory:  Array< {
          __typename: "WorkHistory",
          company: string,
          title: string,
          startDate: string,
          endDate: string | null,
          currentJob: boolean,
          description: string | null,
        } | null > | null,
        educationHistory:  Array< {
          __typename: "EducationHistory",
          institution: string,
          certification: string,
          concentration: string | null,
          dateStarted: string,
          dateCompleted: string | null,
          inProgress: boolean | null,
          description: string | null,
        } | null > | null,
        applications:  Array< {
          __typename: "Application",
          id: string,
          jobId: string,
          jobSeekerId: string,
          applicationStatus: ApplicationStatus | null,
          coverLetter: string | null,
          proof: string | null,
          isAuto: boolean | null,
          formScreenshot: string | null,
          confirmationScreenshot: string | null,
          generatedResumeUrl: string | null,
          dateApplied: string | null,
          dateAppliedIndex: string | null,
          dateUpdated: string | null,
        } | null > | null,
        resume:  {
          __typename: "Resume",
          id: string,
          name: string,
          fileType: string,
          size: string,
          url: string,
          resumeJSON: string | null,
          jobSeekerId: string | null,
          dateUploaded: string,
          dateCreated: string,
          deleted: boolean | null,
        } | null,
        autoResumes:  Array< {
          __typename: "Resume",
          id: string,
          name: string,
          fileType: string,
          size: string,
          url: string,
          resumeJSON: string | null,
          jobSeekerId: string | null,
          dateUploaded: string,
          dateCreated: string,
          deleted: boolean | null,
        } | null > | null,
        preferencesComplete: boolean | null,
        profileComplete: boolean | null,
        autoApply:  Array< {
          __typename: "AutoApply",
          id: string | null,
          jobSeekerId: string | null,
          subId: string | null,
          userId: string | null,
          autoGenerateCoverLetter: boolean | null,
          autoGenerateCoverLetterTone: string | null,
          autoGenerateCoverLetterGreeting: string | null,
          autoGenerateCoverLetterSignOff: string | null,
          autoGenerateCoverLetterInstructions: string | null,
          openToRelocation: boolean | null,
          languagesSpoken: Array< string | null > | null,
          age: number | null,
          genderIdentity: string | null,
          blockedCompanyList: Array< string | null > | null,
          resumeText: string | null,
          coverLetter: string | null,
          aiGenerateCoverLetter: boolean | null,
          coverLetterTone: string | null,
          draft: boolean | null,
          email: string | null,
          isActive: string | null,
          firstName: string | null,
          lastName: string | null,
          remote: boolean | null,
          hybrid: boolean | null,
          onsite: boolean | null,
          jobTitles: Array< string | null > | null,
          negativeJobTitles: Array< string | null > | null,
          industries: Array< string | null > | null,
          experienceLevels: Array< ExperienceLevel | null > | null,
          excludeCompanyNames: Array< string | null > | null,
          expiresAt: string | null,
          subscribedOn: string | null,
          plan: AutoApplySub | null,
          applicationCount: number | null,
          paymentFailed: boolean | null,
          country: string | null,
          region: string | null,
          area: string | null,
          customPreference: Array< string | null > | null,
          appliedUrls: Array< string | null > | null,
          salaryMin: number | null,
          salaryMax: number | null,
          salaryRange: string | null,
          searchTags: Array< string | null > | null,
          prompt: string | null,
          phone: string | null,
          address: string | null,
          currentCompany: string | null,
          linkedinProfile: string | null,
          githubProfile: string | null,
          website: string | null,
          gender: string | null,
          pronouns: string | null,
          hispanic: boolean | null,
          race: string | null,
          paused: boolean | null,
          disabled: boolean | null,
          veteran: boolean | null,
          secretClearance: boolean | null,
          appCountToday: number | null,
          appCountDateUpdated: string | null,
          maxPerDay: number | null,
          maxPerCo: number | null,
          hourToRun: number | null,
          minuteToRun: number | null,
          resumeUrl: string | null,
          resumeName: string | null,
          trial: boolean | null,
          trialExpired: boolean | null,
          gsiConstant: string | null,
          dateCreated: string | null,
          cancelled: boolean | null,
          searchCustomInstructions: string | null,
        } | null > | null,
        dateCreated: string | null,
        dateModified: string | null,
        deleted: boolean | null,
      } | null,
      proof: string | null,
      isAuto: boolean | null,
      formScreenshot: string | null,
      confirmationScreenshot: string | null,
      generatedResumeUrl: string | null,
      applicationAnswers:  {
        __typename: "ApplicationAnswers",
        id: string,
        applicationId: string,
        jobSeekerId: string,
        jobId: string,
        responses:  Array< {
          __typename: "ApplicationAnswer",
          id: string,
          question: string | null,
          answer: string | null,
          type: ApplicationQuestionType | null,
        } | null > | null,
        dateCreated: string | null,
        dateModified: string | null,
      } | null,
      resumeS3Params:  {
        __typename: "ResumeS3Params",
        bucket: string | null,
        key: string | null,
      } | null,
      dateApplied: string | null,
      dateAppliedIndex: string | null,
      dateUpdated: string | null,
    } | null > | null,
    applicationQuestions:  {
      __typename: "ApplicationQuestions",
      id: string,
      jobId: string,
      questions:  Array< {
        __typename: "ApplicationQuestion",
        question: string,
        type: ApplicationQuestionType,
        selector: string,
        options: Array< string | null > | null,
      } | null > | null,
    } | null,
    companyId: string,
    communications:  {
      __typename: "CommunicationInfo",
      emails: Array< string | null > | null,
      phone: string | null,
    } | null,
    companyProfile:  {
      __typename: "EmployerProfile",
      industries: Array< string | null > | null,
      remotePolicy: Policy | null,
      name: string | null,
      bio: string | null,
      hasHeadquarters: boolean | null,
      hqAddress:  {
        __typename: "CityLocation",
        formatted_address: string,
        coordinate:  {
          __typename: "Location",
          lat: number,
          lon: number,
        },
      } | null,
      emailAddress: string | null,
      phoneNumber: string | null,
      image: string | null,
    } | null,
    companyWebsite: string | null,
    companyName: string,
    dateCreated: string | null,
    dateModified: string | null,
    datePosted: string | null,
    deleted: boolean | null,
    department: string,
    description: string,
    digitalNomadFriendly: boolean | null,
    elite: boolean | null,
    endSalaryRangeThousands: number | null,
    experience: ExperienceLevel,
    featured: boolean | null,
    featuredRank: number | null,
    flexibleHours: boolean | null,
    id: string,
    jobLogo: string | null,
    jobTitle: string,
    officeFrequency:  {
      __typename: "OfficeFrequency",
      daysPerMonth: number | null,
      daysPerWeek: number | null,
    } | null,
    officeLocations:  Array< {
      __typename: "CityLocation",
      formatted_address: string,
      coordinate:  {
        __typename: "Location",
        lat: number,
        lon: number,
      },
    } | null > | null,
    paymentHistory:  Array< {
      __typename: "PaymentRecord",
      stripeId: string,
      productId: string,
      paymentPlan: PaymentPlan,
      dateCreated: string,
      dateEnded: string | null,
    } | null > | null,
    paymentPlan: PaymentPlan | null,
    remoteFirst: boolean | null,
    remotePolicy: JobPolicy | null,
    roleType: WorkType,
    scraped: boolean | null,
    scrapedSource: string | null,
    scrapedUrl: string | null,
    startSalaryRangeThousands: number | null,
    status: JobStatus | null,
    stripeId: string | null,
    tags: Array< JobTag | null > | null,
    timezonePolicy: TimezonePolicy | null,
    timezoneRanges:  Array< {
      __typename: "TimezoneRange",
      start: number | null,
      end: number | null,
    } | null > | null,
    wageIsHourly: boolean | null,
    willSponsor: boolean | null,
    workFromAnywhere: boolean | null,
  } | null,
};

export type SearchJobsQueryVariables = {
  input?: SearchInput | null,
};

export type SearchJobsQuery = {
  searchJobs:  Array< {
    __typename: "Job",
    aboutUs: string,
    applications:  Array< {
      __typename: "Application",
      id: string,
      jobId: string,
      jobSeekerId: string,
      applicationStatus: ApplicationStatus | null,
      coverLetter: string | null,
      job:  {
        __typename: "Job",
        aboutUs: string,
        applications:  Array< {
          __typename: "Application",
          id: string,
          jobId: string,
          jobSeekerId: string,
          applicationStatus: ApplicationStatus | null,
          coverLetter: string | null,
          proof: string | null,
          isAuto: boolean | null,
          formScreenshot: string | null,
          confirmationScreenshot: string | null,
          generatedResumeUrl: string | null,
          dateApplied: string | null,
          dateAppliedIndex: string | null,
          dateUpdated: string | null,
        } | null > | null,
        applicationQuestions:  {
          __typename: "ApplicationQuestions",
          id: string,
          jobId: string,
        } | null,
        companyId: string,
        communications:  {
          __typename: "CommunicationInfo",
          emails: Array< string | null > | null,
          phone: string | null,
        } | null,
        companyProfile:  {
          __typename: "EmployerProfile",
          industries: Array< string | null > | null,
          remotePolicy: Policy | null,
          name: string | null,
          bio: string | null,
          hasHeadquarters: boolean | null,
          emailAddress: string | null,
          phoneNumber: string | null,
          image: string | null,
        } | null,
        companyWebsite: string | null,
        companyName: string,
        dateCreated: string | null,
        dateModified: string | null,
        datePosted: string | null,
        deleted: boolean | null,
        department: string,
        description: string,
        digitalNomadFriendly: boolean | null,
        elite: boolean | null,
        endSalaryRangeThousands: number | null,
        experience: ExperienceLevel,
        featured: boolean | null,
        featuredRank: number | null,
        flexibleHours: boolean | null,
        id: string,
        jobLogo: string | null,
        jobTitle: string,
        officeFrequency:  {
          __typename: "OfficeFrequency",
          daysPerMonth: number | null,
          daysPerWeek: number | null,
        } | null,
        officeLocations:  Array< {
          __typename: "CityLocation",
          formatted_address: string,
        } | null > | null,
        paymentHistory:  Array< {
          __typename: "PaymentRecord",
          stripeId: string,
          productId: string,
          paymentPlan: PaymentPlan,
          dateCreated: string,
          dateEnded: string | null,
        } | null > | null,
        paymentPlan: PaymentPlan | null,
        remoteFirst: boolean | null,
        remotePolicy: JobPolicy | null,
        roleType: WorkType,
        scraped: boolean | null,
        scrapedSource: string | null,
        scrapedUrl: string | null,
        startSalaryRangeThousands: number | null,
        status: JobStatus | null,
        stripeId: string | null,
        tags: Array< JobTag | null > | null,
        timezonePolicy: TimezonePolicy | null,
        timezoneRanges:  Array< {
          __typename: "TimezoneRange",
          start: number | null,
          end: number | null,
        } | null > | null,
        wageIsHourly: boolean | null,
        willSponsor: boolean | null,
        workFromAnywhere: boolean | null,
      } | null,
      applicant:  {
        __typename: "JobSeeker",
        id: string,
        userId: string | null,
        firstName: string | null,
        lastName: string | null,
        city:  {
          __typename: "CityLocation",
          formatted_address: string,
        } | null,
        newGradOrStudent: boolean | null,
        linkedin: string | null,
        website: string | null,
        currentCompany: string | null,
        currentTitle: string | null,
        fullTime: boolean | null,
        partTime: boolean | null,
        contractor: boolean | null,
        fullRemote: boolean | null,
        hybridRemote: boolean | null,
        remoteOptional: boolean | null,
        desiredRole: string | null,
        salaryRequirement:  {
          __typename: "Salary",
          currencyCode: string | null,
          value: number | null,
        } | null,
        authorization:  {
          __typename: "WorkAuthorization",
          usAuthorized: boolean | null,
          requireSponsorshipUS: boolean | null,
        } | null,
        recommendedJobsEmail: boolean | null,
        newsletterEmail: boolean | null,
        notificationSettings:  {
          __typename: "NotificationSettings",
          reviewsProfile: NotificationSetting | null,
        } | null,
        visibleToEmployers: boolean | null,
        emailAddress: string | null,
        phone: string | null,
        phoneVerified: boolean | null,
        profilePic: string | null,
        experienceLevel: ExperienceLevel | null,
        workHistory:  Array< {
          __typename: "WorkHistory",
          company: string,
          title: string,
          startDate: string,
          endDate: string | null,
          currentJob: boolean,
          description: string | null,
        } | null > | null,
        educationHistory:  Array< {
          __typename: "EducationHistory",
          institution: string,
          certification: string,
          concentration: string | null,
          dateStarted: string,
          dateCompleted: string | null,
          inProgress: boolean | null,
          description: string | null,
        } | null > | null,
        applications:  Array< {
          __typename: "Application",
          id: string,
          jobId: string,
          jobSeekerId: string,
          applicationStatus: ApplicationStatus | null,
          coverLetter: string | null,
          proof: string | null,
          isAuto: boolean | null,
          formScreenshot: string | null,
          confirmationScreenshot: string | null,
          generatedResumeUrl: string | null,
          dateApplied: string | null,
          dateAppliedIndex: string | null,
          dateUpdated: string | null,
        } | null > | null,
        resume:  {
          __typename: "Resume",
          id: string,
          name: string,
          fileType: string,
          size: string,
          url: string,
          resumeJSON: string | null,
          jobSeekerId: string | null,
          dateUploaded: string,
          dateCreated: string,
          deleted: boolean | null,
        } | null,
        autoResumes:  Array< {
          __typename: "Resume",
          id: string,
          name: string,
          fileType: string,
          size: string,
          url: string,
          resumeJSON: string | null,
          jobSeekerId: string | null,
          dateUploaded: string,
          dateCreated: string,
          deleted: boolean | null,
        } | null > | null,
        preferencesComplete: boolean | null,
        profileComplete: boolean | null,
        autoApply:  Array< {
          __typename: "AutoApply",
          id: string | null,
          jobSeekerId: string | null,
          subId: string | null,
          userId: string | null,
          autoGenerateCoverLetter: boolean | null,
          autoGenerateCoverLetterTone: string | null,
          autoGenerateCoverLetterGreeting: string | null,
          autoGenerateCoverLetterSignOff: string | null,
          autoGenerateCoverLetterInstructions: string | null,
          openToRelocation: boolean | null,
          languagesSpoken: Array< string | null > | null,
          age: number | null,
          genderIdentity: string | null,
          blockedCompanyList: Array< string | null > | null,
          resumeText: string | null,
          coverLetter: string | null,
          aiGenerateCoverLetter: boolean | null,
          coverLetterTone: string | null,
          draft: boolean | null,
          email: string | null,
          isActive: string | null,
          firstName: string | null,
          lastName: string | null,
          remote: boolean | null,
          hybrid: boolean | null,
          onsite: boolean | null,
          jobTitles: Array< string | null > | null,
          negativeJobTitles: Array< string | null > | null,
          industries: Array< string | null > | null,
          experienceLevels: Array< ExperienceLevel | null > | null,
          excludeCompanyNames: Array< string | null > | null,
          expiresAt: string | null,
          subscribedOn: string | null,
          plan: AutoApplySub | null,
          applicationCount: number | null,
          paymentFailed: boolean | null,
          country: string | null,
          region: string | null,
          area: string | null,
          customPreference: Array< string | null > | null,
          appliedUrls: Array< string | null > | null,
          salaryMin: number | null,
          salaryMax: number | null,
          salaryRange: string | null,
          searchTags: Array< string | null > | null,
          prompt: string | null,
          phone: string | null,
          address: string | null,
          currentCompany: string | null,
          linkedinProfile: string | null,
          githubProfile: string | null,
          website: string | null,
          gender: string | null,
          pronouns: string | null,
          hispanic: boolean | null,
          race: string | null,
          paused: boolean | null,
          disabled: boolean | null,
          veteran: boolean | null,
          secretClearance: boolean | null,
          appCountToday: number | null,
          appCountDateUpdated: string | null,
          maxPerDay: number | null,
          maxPerCo: number | null,
          hourToRun: number | null,
          minuteToRun: number | null,
          resumeUrl: string | null,
          resumeName: string | null,
          trial: boolean | null,
          trialExpired: boolean | null,
          gsiConstant: string | null,
          dateCreated: string | null,
          cancelled: boolean | null,
          searchCustomInstructions: string | null,
        } | null > | null,
        dateCreated: string | null,
        dateModified: string | null,
        deleted: boolean | null,
      } | null,
      proof: string | null,
      isAuto: boolean | null,
      formScreenshot: string | null,
      confirmationScreenshot: string | null,
      generatedResumeUrl: string | null,
      applicationAnswers:  {
        __typename: "ApplicationAnswers",
        id: string,
        applicationId: string,
        jobSeekerId: string,
        jobId: string,
        responses:  Array< {
          __typename: "ApplicationAnswer",
          id: string,
          question: string | null,
          answer: string | null,
          type: ApplicationQuestionType | null,
        } | null > | null,
        dateCreated: string | null,
        dateModified: string | null,
      } | null,
      resumeS3Params:  {
        __typename: "ResumeS3Params",
        bucket: string | null,
        key: string | null,
      } | null,
      dateApplied: string | null,
      dateAppliedIndex: string | null,
      dateUpdated: string | null,
    } | null > | null,
    applicationQuestions:  {
      __typename: "ApplicationQuestions",
      id: string,
      jobId: string,
      questions:  Array< {
        __typename: "ApplicationQuestion",
        question: string,
        type: ApplicationQuestionType,
        selector: string,
        options: Array< string | null > | null,
      } | null > | null,
    } | null,
    companyId: string,
    communications:  {
      __typename: "CommunicationInfo",
      emails: Array< string | null > | null,
      phone: string | null,
    } | null,
    companyProfile:  {
      __typename: "EmployerProfile",
      industries: Array< string | null > | null,
      remotePolicy: Policy | null,
      name: string | null,
      bio: string | null,
      hasHeadquarters: boolean | null,
      hqAddress:  {
        __typename: "CityLocation",
        formatted_address: string,
        coordinate:  {
          __typename: "Location",
          lat: number,
          lon: number,
        },
      } | null,
      emailAddress: string | null,
      phoneNumber: string | null,
      image: string | null,
    } | null,
    companyWebsite: string | null,
    companyName: string,
    dateCreated: string | null,
    dateModified: string | null,
    datePosted: string | null,
    deleted: boolean | null,
    department: string,
    description: string,
    digitalNomadFriendly: boolean | null,
    elite: boolean | null,
    endSalaryRangeThousands: number | null,
    experience: ExperienceLevel,
    featured: boolean | null,
    featuredRank: number | null,
    flexibleHours: boolean | null,
    id: string,
    jobLogo: string | null,
    jobTitle: string,
    officeFrequency:  {
      __typename: "OfficeFrequency",
      daysPerMonth: number | null,
      daysPerWeek: number | null,
    } | null,
    officeLocations:  Array< {
      __typename: "CityLocation",
      formatted_address: string,
      coordinate:  {
        __typename: "Location",
        lat: number,
        lon: number,
      },
    } | null > | null,
    paymentHistory:  Array< {
      __typename: "PaymentRecord",
      stripeId: string,
      productId: string,
      paymentPlan: PaymentPlan,
      dateCreated: string,
      dateEnded: string | null,
    } | null > | null,
    paymentPlan: PaymentPlan | null,
    remoteFirst: boolean | null,
    remotePolicy: JobPolicy | null,
    roleType: WorkType,
    scraped: boolean | null,
    scrapedSource: string | null,
    scrapedUrl: string | null,
    startSalaryRangeThousands: number | null,
    status: JobStatus | null,
    stripeId: string | null,
    tags: Array< JobTag | null > | null,
    timezonePolicy: TimezonePolicy | null,
    timezoneRanges:  Array< {
      __typename: "TimezoneRange",
      start: number | null,
      end: number | null,
    } | null > | null,
    wageIsHourly: boolean | null,
    willSponsor: boolean | null,
    workFromAnywhere: boolean | null,
  } | null > | null,
};

export type SearchJobsByTermQueryVariables = {
  input?: SearchJobsByTermInput | null,
};

export type SearchJobsByTermQuery = {
  searchJobsByTerm:  Array< {
    __typename: "Job",
    aboutUs: string,
    applications:  Array< {
      __typename: "Application",
      id: string,
      jobId: string,
      jobSeekerId: string,
      applicationStatus: ApplicationStatus | null,
      coverLetter: string | null,
      job:  {
        __typename: "Job",
        aboutUs: string,
        applications:  Array< {
          __typename: "Application",
          id: string,
          jobId: string,
          jobSeekerId: string,
          applicationStatus: ApplicationStatus | null,
          coverLetter: string | null,
          proof: string | null,
          isAuto: boolean | null,
          formScreenshot: string | null,
          confirmationScreenshot: string | null,
          generatedResumeUrl: string | null,
          dateApplied: string | null,
          dateAppliedIndex: string | null,
          dateUpdated: string | null,
        } | null > | null,
        applicationQuestions:  {
          __typename: "ApplicationQuestions",
          id: string,
          jobId: string,
        } | null,
        companyId: string,
        communications:  {
          __typename: "CommunicationInfo",
          emails: Array< string | null > | null,
          phone: string | null,
        } | null,
        companyProfile:  {
          __typename: "EmployerProfile",
          industries: Array< string | null > | null,
          remotePolicy: Policy | null,
          name: string | null,
          bio: string | null,
          hasHeadquarters: boolean | null,
          emailAddress: string | null,
          phoneNumber: string | null,
          image: string | null,
        } | null,
        companyWebsite: string | null,
        companyName: string,
        dateCreated: string | null,
        dateModified: string | null,
        datePosted: string | null,
        deleted: boolean | null,
        department: string,
        description: string,
        digitalNomadFriendly: boolean | null,
        elite: boolean | null,
        endSalaryRangeThousands: number | null,
        experience: ExperienceLevel,
        featured: boolean | null,
        featuredRank: number | null,
        flexibleHours: boolean | null,
        id: string,
        jobLogo: string | null,
        jobTitle: string,
        officeFrequency:  {
          __typename: "OfficeFrequency",
          daysPerMonth: number | null,
          daysPerWeek: number | null,
        } | null,
        officeLocations:  Array< {
          __typename: "CityLocation",
          formatted_address: string,
        } | null > | null,
        paymentHistory:  Array< {
          __typename: "PaymentRecord",
          stripeId: string,
          productId: string,
          paymentPlan: PaymentPlan,
          dateCreated: string,
          dateEnded: string | null,
        } | null > | null,
        paymentPlan: PaymentPlan | null,
        remoteFirst: boolean | null,
        remotePolicy: JobPolicy | null,
        roleType: WorkType,
        scraped: boolean | null,
        scrapedSource: string | null,
        scrapedUrl: string | null,
        startSalaryRangeThousands: number | null,
        status: JobStatus | null,
        stripeId: string | null,
        tags: Array< JobTag | null > | null,
        timezonePolicy: TimezonePolicy | null,
        timezoneRanges:  Array< {
          __typename: "TimezoneRange",
          start: number | null,
          end: number | null,
        } | null > | null,
        wageIsHourly: boolean | null,
        willSponsor: boolean | null,
        workFromAnywhere: boolean | null,
      } | null,
      applicant:  {
        __typename: "JobSeeker",
        id: string,
        userId: string | null,
        firstName: string | null,
        lastName: string | null,
        city:  {
          __typename: "CityLocation",
          formatted_address: string,
        } | null,
        newGradOrStudent: boolean | null,
        linkedin: string | null,
        website: string | null,
        currentCompany: string | null,
        currentTitle: string | null,
        fullTime: boolean | null,
        partTime: boolean | null,
        contractor: boolean | null,
        fullRemote: boolean | null,
        hybridRemote: boolean | null,
        remoteOptional: boolean | null,
        desiredRole: string | null,
        salaryRequirement:  {
          __typename: "Salary",
          currencyCode: string | null,
          value: number | null,
        } | null,
        authorization:  {
          __typename: "WorkAuthorization",
          usAuthorized: boolean | null,
          requireSponsorshipUS: boolean | null,
        } | null,
        recommendedJobsEmail: boolean | null,
        newsletterEmail: boolean | null,
        notificationSettings:  {
          __typename: "NotificationSettings",
          reviewsProfile: NotificationSetting | null,
        } | null,
        visibleToEmployers: boolean | null,
        emailAddress: string | null,
        phone: string | null,
        phoneVerified: boolean | null,
        profilePic: string | null,
        experienceLevel: ExperienceLevel | null,
        workHistory:  Array< {
          __typename: "WorkHistory",
          company: string,
          title: string,
          startDate: string,
          endDate: string | null,
          currentJob: boolean,
          description: string | null,
        } | null > | null,
        educationHistory:  Array< {
          __typename: "EducationHistory",
          institution: string,
          certification: string,
          concentration: string | null,
          dateStarted: string,
          dateCompleted: string | null,
          inProgress: boolean | null,
          description: string | null,
        } | null > | null,
        applications:  Array< {
          __typename: "Application",
          id: string,
          jobId: string,
          jobSeekerId: string,
          applicationStatus: ApplicationStatus | null,
          coverLetter: string | null,
          proof: string | null,
          isAuto: boolean | null,
          formScreenshot: string | null,
          confirmationScreenshot: string | null,
          generatedResumeUrl: string | null,
          dateApplied: string | null,
          dateAppliedIndex: string | null,
          dateUpdated: string | null,
        } | null > | null,
        resume:  {
          __typename: "Resume",
          id: string,
          name: string,
          fileType: string,
          size: string,
          url: string,
          resumeJSON: string | null,
          jobSeekerId: string | null,
          dateUploaded: string,
          dateCreated: string,
          deleted: boolean | null,
        } | null,
        autoResumes:  Array< {
          __typename: "Resume",
          id: string,
          name: string,
          fileType: string,
          size: string,
          url: string,
          resumeJSON: string | null,
          jobSeekerId: string | null,
          dateUploaded: string,
          dateCreated: string,
          deleted: boolean | null,
        } | null > | null,
        preferencesComplete: boolean | null,
        profileComplete: boolean | null,
        autoApply:  Array< {
          __typename: "AutoApply",
          id: string | null,
          jobSeekerId: string | null,
          subId: string | null,
          userId: string | null,
          autoGenerateCoverLetter: boolean | null,
          autoGenerateCoverLetterTone: string | null,
          autoGenerateCoverLetterGreeting: string | null,
          autoGenerateCoverLetterSignOff: string | null,
          autoGenerateCoverLetterInstructions: string | null,
          openToRelocation: boolean | null,
          languagesSpoken: Array< string | null > | null,
          age: number | null,
          genderIdentity: string | null,
          blockedCompanyList: Array< string | null > | null,
          resumeText: string | null,
          coverLetter: string | null,
          aiGenerateCoverLetter: boolean | null,
          coverLetterTone: string | null,
          draft: boolean | null,
          email: string | null,
          isActive: string | null,
          firstName: string | null,
          lastName: string | null,
          remote: boolean | null,
          hybrid: boolean | null,
          onsite: boolean | null,
          jobTitles: Array< string | null > | null,
          negativeJobTitles: Array< string | null > | null,
          industries: Array< string | null > | null,
          experienceLevels: Array< ExperienceLevel | null > | null,
          excludeCompanyNames: Array< string | null > | null,
          expiresAt: string | null,
          subscribedOn: string | null,
          plan: AutoApplySub | null,
          applicationCount: number | null,
          paymentFailed: boolean | null,
          country: string | null,
          region: string | null,
          area: string | null,
          customPreference: Array< string | null > | null,
          appliedUrls: Array< string | null > | null,
          salaryMin: number | null,
          salaryMax: number | null,
          salaryRange: string | null,
          searchTags: Array< string | null > | null,
          prompt: string | null,
          phone: string | null,
          address: string | null,
          currentCompany: string | null,
          linkedinProfile: string | null,
          githubProfile: string | null,
          website: string | null,
          gender: string | null,
          pronouns: string | null,
          hispanic: boolean | null,
          race: string | null,
          paused: boolean | null,
          disabled: boolean | null,
          veteran: boolean | null,
          secretClearance: boolean | null,
          appCountToday: number | null,
          appCountDateUpdated: string | null,
          maxPerDay: number | null,
          maxPerCo: number | null,
          hourToRun: number | null,
          minuteToRun: number | null,
          resumeUrl: string | null,
          resumeName: string | null,
          trial: boolean | null,
          trialExpired: boolean | null,
          gsiConstant: string | null,
          dateCreated: string | null,
          cancelled: boolean | null,
          searchCustomInstructions: string | null,
        } | null > | null,
        dateCreated: string | null,
        dateModified: string | null,
        deleted: boolean | null,
      } | null,
      proof: string | null,
      isAuto: boolean | null,
      formScreenshot: string | null,
      confirmationScreenshot: string | null,
      generatedResumeUrl: string | null,
      applicationAnswers:  {
        __typename: "ApplicationAnswers",
        id: string,
        applicationId: string,
        jobSeekerId: string,
        jobId: string,
        responses:  Array< {
          __typename: "ApplicationAnswer",
          id: string,
          question: string | null,
          answer: string | null,
          type: ApplicationQuestionType | null,
        } | null > | null,
        dateCreated: string | null,
        dateModified: string | null,
      } | null,
      resumeS3Params:  {
        __typename: "ResumeS3Params",
        bucket: string | null,
        key: string | null,
      } | null,
      dateApplied: string | null,
      dateAppliedIndex: string | null,
      dateUpdated: string | null,
    } | null > | null,
    applicationQuestions:  {
      __typename: "ApplicationQuestions",
      id: string,
      jobId: string,
      questions:  Array< {
        __typename: "ApplicationQuestion",
        question: string,
        type: ApplicationQuestionType,
        selector: string,
        options: Array< string | null > | null,
      } | null > | null,
    } | null,
    companyId: string,
    communications:  {
      __typename: "CommunicationInfo",
      emails: Array< string | null > | null,
      phone: string | null,
    } | null,
    companyProfile:  {
      __typename: "EmployerProfile",
      industries: Array< string | null > | null,
      remotePolicy: Policy | null,
      name: string | null,
      bio: string | null,
      hasHeadquarters: boolean | null,
      hqAddress:  {
        __typename: "CityLocation",
        formatted_address: string,
        coordinate:  {
          __typename: "Location",
          lat: number,
          lon: number,
        },
      } | null,
      emailAddress: string | null,
      phoneNumber: string | null,
      image: string | null,
    } | null,
    companyWebsite: string | null,
    companyName: string,
    dateCreated: string | null,
    dateModified: string | null,
    datePosted: string | null,
    deleted: boolean | null,
    department: string,
    description: string,
    digitalNomadFriendly: boolean | null,
    elite: boolean | null,
    endSalaryRangeThousands: number | null,
    experience: ExperienceLevel,
    featured: boolean | null,
    featuredRank: number | null,
    flexibleHours: boolean | null,
    id: string,
    jobLogo: string | null,
    jobTitle: string,
    officeFrequency:  {
      __typename: "OfficeFrequency",
      daysPerMonth: number | null,
      daysPerWeek: number | null,
    } | null,
    officeLocations:  Array< {
      __typename: "CityLocation",
      formatted_address: string,
      coordinate:  {
        __typename: "Location",
        lat: number,
        lon: number,
      },
    } | null > | null,
    paymentHistory:  Array< {
      __typename: "PaymentRecord",
      stripeId: string,
      productId: string,
      paymentPlan: PaymentPlan,
      dateCreated: string,
      dateEnded: string | null,
    } | null > | null,
    paymentPlan: PaymentPlan | null,
    remoteFirst: boolean | null,
    remotePolicy: JobPolicy | null,
    roleType: WorkType,
    scraped: boolean | null,
    scrapedSource: string | null,
    scrapedUrl: string | null,
    startSalaryRangeThousands: number | null,
    status: JobStatus | null,
    stripeId: string | null,
    tags: Array< JobTag | null > | null,
    timezonePolicy: TimezonePolicy | null,
    timezoneRanges:  Array< {
      __typename: "TimezoneRange",
      start: number | null,
      end: number | null,
    } | null > | null,
    wageIsHourly: boolean | null,
    willSponsor: boolean | null,
    workFromAnywhere: boolean | null,
  } | null > | null,
};

export type SearchJobsByLocationQueryVariables = {
  input?: SearchJobsByLocationInput | null,
};

export type SearchJobsByLocationQuery = {
  searchJobsByLocation:  Array< {
    __typename: "Job",
    aboutUs: string,
    applications:  Array< {
      __typename: "Application",
      id: string,
      jobId: string,
      jobSeekerId: string,
      applicationStatus: ApplicationStatus | null,
      coverLetter: string | null,
      job:  {
        __typename: "Job",
        aboutUs: string,
        applications:  Array< {
          __typename: "Application",
          id: string,
          jobId: string,
          jobSeekerId: string,
          applicationStatus: ApplicationStatus | null,
          coverLetter: string | null,
          proof: string | null,
          isAuto: boolean | null,
          formScreenshot: string | null,
          confirmationScreenshot: string | null,
          generatedResumeUrl: string | null,
          dateApplied: string | null,
          dateAppliedIndex: string | null,
          dateUpdated: string | null,
        } | null > | null,
        applicationQuestions:  {
          __typename: "ApplicationQuestions",
          id: string,
          jobId: string,
        } | null,
        companyId: string,
        communications:  {
          __typename: "CommunicationInfo",
          emails: Array< string | null > | null,
          phone: string | null,
        } | null,
        companyProfile:  {
          __typename: "EmployerProfile",
          industries: Array< string | null > | null,
          remotePolicy: Policy | null,
          name: string | null,
          bio: string | null,
          hasHeadquarters: boolean | null,
          emailAddress: string | null,
          phoneNumber: string | null,
          image: string | null,
        } | null,
        companyWebsite: string | null,
        companyName: string,
        dateCreated: string | null,
        dateModified: string | null,
        datePosted: string | null,
        deleted: boolean | null,
        department: string,
        description: string,
        digitalNomadFriendly: boolean | null,
        elite: boolean | null,
        endSalaryRangeThousands: number | null,
        experience: ExperienceLevel,
        featured: boolean | null,
        featuredRank: number | null,
        flexibleHours: boolean | null,
        id: string,
        jobLogo: string | null,
        jobTitle: string,
        officeFrequency:  {
          __typename: "OfficeFrequency",
          daysPerMonth: number | null,
          daysPerWeek: number | null,
        } | null,
        officeLocations:  Array< {
          __typename: "CityLocation",
          formatted_address: string,
        } | null > | null,
        paymentHistory:  Array< {
          __typename: "PaymentRecord",
          stripeId: string,
          productId: string,
          paymentPlan: PaymentPlan,
          dateCreated: string,
          dateEnded: string | null,
        } | null > | null,
        paymentPlan: PaymentPlan | null,
        remoteFirst: boolean | null,
        remotePolicy: JobPolicy | null,
        roleType: WorkType,
        scraped: boolean | null,
        scrapedSource: string | null,
        scrapedUrl: string | null,
        startSalaryRangeThousands: number | null,
        status: JobStatus | null,
        stripeId: string | null,
        tags: Array< JobTag | null > | null,
        timezonePolicy: TimezonePolicy | null,
        timezoneRanges:  Array< {
          __typename: "TimezoneRange",
          start: number | null,
          end: number | null,
        } | null > | null,
        wageIsHourly: boolean | null,
        willSponsor: boolean | null,
        workFromAnywhere: boolean | null,
      } | null,
      applicant:  {
        __typename: "JobSeeker",
        id: string,
        userId: string | null,
        firstName: string | null,
        lastName: string | null,
        city:  {
          __typename: "CityLocation",
          formatted_address: string,
        } | null,
        newGradOrStudent: boolean | null,
        linkedin: string | null,
        website: string | null,
        currentCompany: string | null,
        currentTitle: string | null,
        fullTime: boolean | null,
        partTime: boolean | null,
        contractor: boolean | null,
        fullRemote: boolean | null,
        hybridRemote: boolean | null,
        remoteOptional: boolean | null,
        desiredRole: string | null,
        salaryRequirement:  {
          __typename: "Salary",
          currencyCode: string | null,
          value: number | null,
        } | null,
        authorization:  {
          __typename: "WorkAuthorization",
          usAuthorized: boolean | null,
          requireSponsorshipUS: boolean | null,
        } | null,
        recommendedJobsEmail: boolean | null,
        newsletterEmail: boolean | null,
        notificationSettings:  {
          __typename: "NotificationSettings",
          reviewsProfile: NotificationSetting | null,
        } | null,
        visibleToEmployers: boolean | null,
        emailAddress: string | null,
        phone: string | null,
        phoneVerified: boolean | null,
        profilePic: string | null,
        experienceLevel: ExperienceLevel | null,
        workHistory:  Array< {
          __typename: "WorkHistory",
          company: string,
          title: string,
          startDate: string,
          endDate: string | null,
          currentJob: boolean,
          description: string | null,
        } | null > | null,
        educationHistory:  Array< {
          __typename: "EducationHistory",
          institution: string,
          certification: string,
          concentration: string | null,
          dateStarted: string,
          dateCompleted: string | null,
          inProgress: boolean | null,
          description: string | null,
        } | null > | null,
        applications:  Array< {
          __typename: "Application",
          id: string,
          jobId: string,
          jobSeekerId: string,
          applicationStatus: ApplicationStatus | null,
          coverLetter: string | null,
          proof: string | null,
          isAuto: boolean | null,
          formScreenshot: string | null,
          confirmationScreenshot: string | null,
          generatedResumeUrl: string | null,
          dateApplied: string | null,
          dateAppliedIndex: string | null,
          dateUpdated: string | null,
        } | null > | null,
        resume:  {
          __typename: "Resume",
          id: string,
          name: string,
          fileType: string,
          size: string,
          url: string,
          resumeJSON: string | null,
          jobSeekerId: string | null,
          dateUploaded: string,
          dateCreated: string,
          deleted: boolean | null,
        } | null,
        autoResumes:  Array< {
          __typename: "Resume",
          id: string,
          name: string,
          fileType: string,
          size: string,
          url: string,
          resumeJSON: string | null,
          jobSeekerId: string | null,
          dateUploaded: string,
          dateCreated: string,
          deleted: boolean | null,
        } | null > | null,
        preferencesComplete: boolean | null,
        profileComplete: boolean | null,
        autoApply:  Array< {
          __typename: "AutoApply",
          id: string | null,
          jobSeekerId: string | null,
          subId: string | null,
          userId: string | null,
          autoGenerateCoverLetter: boolean | null,
          autoGenerateCoverLetterTone: string | null,
          autoGenerateCoverLetterGreeting: string | null,
          autoGenerateCoverLetterSignOff: string | null,
          autoGenerateCoverLetterInstructions: string | null,
          openToRelocation: boolean | null,
          languagesSpoken: Array< string | null > | null,
          age: number | null,
          genderIdentity: string | null,
          blockedCompanyList: Array< string | null > | null,
          resumeText: string | null,
          coverLetter: string | null,
          aiGenerateCoverLetter: boolean | null,
          coverLetterTone: string | null,
          draft: boolean | null,
          email: string | null,
          isActive: string | null,
          firstName: string | null,
          lastName: string | null,
          remote: boolean | null,
          hybrid: boolean | null,
          onsite: boolean | null,
          jobTitles: Array< string | null > | null,
          negativeJobTitles: Array< string | null > | null,
          industries: Array< string | null > | null,
          experienceLevels: Array< ExperienceLevel | null > | null,
          excludeCompanyNames: Array< string | null > | null,
          expiresAt: string | null,
          subscribedOn: string | null,
          plan: AutoApplySub | null,
          applicationCount: number | null,
          paymentFailed: boolean | null,
          country: string | null,
          region: string | null,
          area: string | null,
          customPreference: Array< string | null > | null,
          appliedUrls: Array< string | null > | null,
          salaryMin: number | null,
          salaryMax: number | null,
          salaryRange: string | null,
          searchTags: Array< string | null > | null,
          prompt: string | null,
          phone: string | null,
          address: string | null,
          currentCompany: string | null,
          linkedinProfile: string | null,
          githubProfile: string | null,
          website: string | null,
          gender: string | null,
          pronouns: string | null,
          hispanic: boolean | null,
          race: string | null,
          paused: boolean | null,
          disabled: boolean | null,
          veteran: boolean | null,
          secretClearance: boolean | null,
          appCountToday: number | null,
          appCountDateUpdated: string | null,
          maxPerDay: number | null,
          maxPerCo: number | null,
          hourToRun: number | null,
          minuteToRun: number | null,
          resumeUrl: string | null,
          resumeName: string | null,
          trial: boolean | null,
          trialExpired: boolean | null,
          gsiConstant: string | null,
          dateCreated: string | null,
          cancelled: boolean | null,
          searchCustomInstructions: string | null,
        } | null > | null,
        dateCreated: string | null,
        dateModified: string | null,
        deleted: boolean | null,
      } | null,
      proof: string | null,
      isAuto: boolean | null,
      formScreenshot: string | null,
      confirmationScreenshot: string | null,
      generatedResumeUrl: string | null,
      applicationAnswers:  {
        __typename: "ApplicationAnswers",
        id: string,
        applicationId: string,
        jobSeekerId: string,
        jobId: string,
        responses:  Array< {
          __typename: "ApplicationAnswer",
          id: string,
          question: string | null,
          answer: string | null,
          type: ApplicationQuestionType | null,
        } | null > | null,
        dateCreated: string | null,
        dateModified: string | null,
      } | null,
      resumeS3Params:  {
        __typename: "ResumeS3Params",
        bucket: string | null,
        key: string | null,
      } | null,
      dateApplied: string | null,
      dateAppliedIndex: string | null,
      dateUpdated: string | null,
    } | null > | null,
    applicationQuestions:  {
      __typename: "ApplicationQuestions",
      id: string,
      jobId: string,
      questions:  Array< {
        __typename: "ApplicationQuestion",
        question: string,
        type: ApplicationQuestionType,
        selector: string,
        options: Array< string | null > | null,
      } | null > | null,
    } | null,
    companyId: string,
    communications:  {
      __typename: "CommunicationInfo",
      emails: Array< string | null > | null,
      phone: string | null,
    } | null,
    companyProfile:  {
      __typename: "EmployerProfile",
      industries: Array< string | null > | null,
      remotePolicy: Policy | null,
      name: string | null,
      bio: string | null,
      hasHeadquarters: boolean | null,
      hqAddress:  {
        __typename: "CityLocation",
        formatted_address: string,
        coordinate:  {
          __typename: "Location",
          lat: number,
          lon: number,
        },
      } | null,
      emailAddress: string | null,
      phoneNumber: string | null,
      image: string | null,
    } | null,
    companyWebsite: string | null,
    companyName: string,
    dateCreated: string | null,
    dateModified: string | null,
    datePosted: string | null,
    deleted: boolean | null,
    department: string,
    description: string,
    digitalNomadFriendly: boolean | null,
    elite: boolean | null,
    endSalaryRangeThousands: number | null,
    experience: ExperienceLevel,
    featured: boolean | null,
    featuredRank: number | null,
    flexibleHours: boolean | null,
    id: string,
    jobLogo: string | null,
    jobTitle: string,
    officeFrequency:  {
      __typename: "OfficeFrequency",
      daysPerMonth: number | null,
      daysPerWeek: number | null,
    } | null,
    officeLocations:  Array< {
      __typename: "CityLocation",
      formatted_address: string,
      coordinate:  {
        __typename: "Location",
        lat: number,
        lon: number,
      },
    } | null > | null,
    paymentHistory:  Array< {
      __typename: "PaymentRecord",
      stripeId: string,
      productId: string,
      paymentPlan: PaymentPlan,
      dateCreated: string,
      dateEnded: string | null,
    } | null > | null,
    paymentPlan: PaymentPlan | null,
    remoteFirst: boolean | null,
    remotePolicy: JobPolicy | null,
    roleType: WorkType,
    scraped: boolean | null,
    scrapedSource: string | null,
    scrapedUrl: string | null,
    startSalaryRangeThousands: number | null,
    status: JobStatus | null,
    stripeId: string | null,
    tags: Array< JobTag | null > | null,
    timezonePolicy: TimezonePolicy | null,
    timezoneRanges:  Array< {
      __typename: "TimezoneRange",
      start: number | null,
      end: number | null,
    } | null > | null,
    wageIsHourly: boolean | null,
    willSponsor: boolean | null,
    workFromAnywhere: boolean | null,
  } | null > | null,
};

export type SearchJobsDbQueryVariables = {
  input?: SearchInput | null,
};

export type SearchJobsDbQuery = {
  searchJobsDb:  Array< {
    __typename: "Job",
    aboutUs: string,
    applications:  Array< {
      __typename: "Application",
      id: string,
      jobId: string,
      jobSeekerId: string,
      applicationStatus: ApplicationStatus | null,
      coverLetter: string | null,
      job:  {
        __typename: "Job",
        aboutUs: string,
        applications:  Array< {
          __typename: "Application",
          id: string,
          jobId: string,
          jobSeekerId: string,
          applicationStatus: ApplicationStatus | null,
          coverLetter: string | null,
          proof: string | null,
          isAuto: boolean | null,
          formScreenshot: string | null,
          confirmationScreenshot: string | null,
          generatedResumeUrl: string | null,
          dateApplied: string | null,
          dateAppliedIndex: string | null,
          dateUpdated: string | null,
        } | null > | null,
        applicationQuestions:  {
          __typename: "ApplicationQuestions",
          id: string,
          jobId: string,
        } | null,
        companyId: string,
        communications:  {
          __typename: "CommunicationInfo",
          emails: Array< string | null > | null,
          phone: string | null,
        } | null,
        companyProfile:  {
          __typename: "EmployerProfile",
          industries: Array< string | null > | null,
          remotePolicy: Policy | null,
          name: string | null,
          bio: string | null,
          hasHeadquarters: boolean | null,
          emailAddress: string | null,
          phoneNumber: string | null,
          image: string | null,
        } | null,
        companyWebsite: string | null,
        companyName: string,
        dateCreated: string | null,
        dateModified: string | null,
        datePosted: string | null,
        deleted: boolean | null,
        department: string,
        description: string,
        digitalNomadFriendly: boolean | null,
        elite: boolean | null,
        endSalaryRangeThousands: number | null,
        experience: ExperienceLevel,
        featured: boolean | null,
        featuredRank: number | null,
        flexibleHours: boolean | null,
        id: string,
        jobLogo: string | null,
        jobTitle: string,
        officeFrequency:  {
          __typename: "OfficeFrequency",
          daysPerMonth: number | null,
          daysPerWeek: number | null,
        } | null,
        officeLocations:  Array< {
          __typename: "CityLocation",
          formatted_address: string,
        } | null > | null,
        paymentHistory:  Array< {
          __typename: "PaymentRecord",
          stripeId: string,
          productId: string,
          paymentPlan: PaymentPlan,
          dateCreated: string,
          dateEnded: string | null,
        } | null > | null,
        paymentPlan: PaymentPlan | null,
        remoteFirst: boolean | null,
        remotePolicy: JobPolicy | null,
        roleType: WorkType,
        scraped: boolean | null,
        scrapedSource: string | null,
        scrapedUrl: string | null,
        startSalaryRangeThousands: number | null,
        status: JobStatus | null,
        stripeId: string | null,
        tags: Array< JobTag | null > | null,
        timezonePolicy: TimezonePolicy | null,
        timezoneRanges:  Array< {
          __typename: "TimezoneRange",
          start: number | null,
          end: number | null,
        } | null > | null,
        wageIsHourly: boolean | null,
        willSponsor: boolean | null,
        workFromAnywhere: boolean | null,
      } | null,
      applicant:  {
        __typename: "JobSeeker",
        id: string,
        userId: string | null,
        firstName: string | null,
        lastName: string | null,
        city:  {
          __typename: "CityLocation",
          formatted_address: string,
        } | null,
        newGradOrStudent: boolean | null,
        linkedin: string | null,
        website: string | null,
        currentCompany: string | null,
        currentTitle: string | null,
        fullTime: boolean | null,
        partTime: boolean | null,
        contractor: boolean | null,
        fullRemote: boolean | null,
        hybridRemote: boolean | null,
        remoteOptional: boolean | null,
        desiredRole: string | null,
        salaryRequirement:  {
          __typename: "Salary",
          currencyCode: string | null,
          value: number | null,
        } | null,
        authorization:  {
          __typename: "WorkAuthorization",
          usAuthorized: boolean | null,
          requireSponsorshipUS: boolean | null,
        } | null,
        recommendedJobsEmail: boolean | null,
        newsletterEmail: boolean | null,
        notificationSettings:  {
          __typename: "NotificationSettings",
          reviewsProfile: NotificationSetting | null,
        } | null,
        visibleToEmployers: boolean | null,
        emailAddress: string | null,
        phone: string | null,
        phoneVerified: boolean | null,
        profilePic: string | null,
        experienceLevel: ExperienceLevel | null,
        workHistory:  Array< {
          __typename: "WorkHistory",
          company: string,
          title: string,
          startDate: string,
          endDate: string | null,
          currentJob: boolean,
          description: string | null,
        } | null > | null,
        educationHistory:  Array< {
          __typename: "EducationHistory",
          institution: string,
          certification: string,
          concentration: string | null,
          dateStarted: string,
          dateCompleted: string | null,
          inProgress: boolean | null,
          description: string | null,
        } | null > | null,
        applications:  Array< {
          __typename: "Application",
          id: string,
          jobId: string,
          jobSeekerId: string,
          applicationStatus: ApplicationStatus | null,
          coverLetter: string | null,
          proof: string | null,
          isAuto: boolean | null,
          formScreenshot: string | null,
          confirmationScreenshot: string | null,
          generatedResumeUrl: string | null,
          dateApplied: string | null,
          dateAppliedIndex: string | null,
          dateUpdated: string | null,
        } | null > | null,
        resume:  {
          __typename: "Resume",
          id: string,
          name: string,
          fileType: string,
          size: string,
          url: string,
          resumeJSON: string | null,
          jobSeekerId: string | null,
          dateUploaded: string,
          dateCreated: string,
          deleted: boolean | null,
        } | null,
        autoResumes:  Array< {
          __typename: "Resume",
          id: string,
          name: string,
          fileType: string,
          size: string,
          url: string,
          resumeJSON: string | null,
          jobSeekerId: string | null,
          dateUploaded: string,
          dateCreated: string,
          deleted: boolean | null,
        } | null > | null,
        preferencesComplete: boolean | null,
        profileComplete: boolean | null,
        autoApply:  Array< {
          __typename: "AutoApply",
          id: string | null,
          jobSeekerId: string | null,
          subId: string | null,
          userId: string | null,
          autoGenerateCoverLetter: boolean | null,
          autoGenerateCoverLetterTone: string | null,
          autoGenerateCoverLetterGreeting: string | null,
          autoGenerateCoverLetterSignOff: string | null,
          autoGenerateCoverLetterInstructions: string | null,
          openToRelocation: boolean | null,
          languagesSpoken: Array< string | null > | null,
          age: number | null,
          genderIdentity: string | null,
          blockedCompanyList: Array< string | null > | null,
          resumeText: string | null,
          coverLetter: string | null,
          aiGenerateCoverLetter: boolean | null,
          coverLetterTone: string | null,
          draft: boolean | null,
          email: string | null,
          isActive: string | null,
          firstName: string | null,
          lastName: string | null,
          remote: boolean | null,
          hybrid: boolean | null,
          onsite: boolean | null,
          jobTitles: Array< string | null > | null,
          negativeJobTitles: Array< string | null > | null,
          industries: Array< string | null > | null,
          experienceLevels: Array< ExperienceLevel | null > | null,
          excludeCompanyNames: Array< string | null > | null,
          expiresAt: string | null,
          subscribedOn: string | null,
          plan: AutoApplySub | null,
          applicationCount: number | null,
          paymentFailed: boolean | null,
          country: string | null,
          region: string | null,
          area: string | null,
          customPreference: Array< string | null > | null,
          appliedUrls: Array< string | null > | null,
          salaryMin: number | null,
          salaryMax: number | null,
          salaryRange: string | null,
          searchTags: Array< string | null > | null,
          prompt: string | null,
          phone: string | null,
          address: string | null,
          currentCompany: string | null,
          linkedinProfile: string | null,
          githubProfile: string | null,
          website: string | null,
          gender: string | null,
          pronouns: string | null,
          hispanic: boolean | null,
          race: string | null,
          paused: boolean | null,
          disabled: boolean | null,
          veteran: boolean | null,
          secretClearance: boolean | null,
          appCountToday: number | null,
          appCountDateUpdated: string | null,
          maxPerDay: number | null,
          maxPerCo: number | null,
          hourToRun: number | null,
          minuteToRun: number | null,
          resumeUrl: string | null,
          resumeName: string | null,
          trial: boolean | null,
          trialExpired: boolean | null,
          gsiConstant: string | null,
          dateCreated: string | null,
          cancelled: boolean | null,
          searchCustomInstructions: string | null,
        } | null > | null,
        dateCreated: string | null,
        dateModified: string | null,
        deleted: boolean | null,
      } | null,
      proof: string | null,
      isAuto: boolean | null,
      formScreenshot: string | null,
      confirmationScreenshot: string | null,
      generatedResumeUrl: string | null,
      applicationAnswers:  {
        __typename: "ApplicationAnswers",
        id: string,
        applicationId: string,
        jobSeekerId: string,
        jobId: string,
        responses:  Array< {
          __typename: "ApplicationAnswer",
          id: string,
          question: string | null,
          answer: string | null,
          type: ApplicationQuestionType | null,
        } | null > | null,
        dateCreated: string | null,
        dateModified: string | null,
      } | null,
      resumeS3Params:  {
        __typename: "ResumeS3Params",
        bucket: string | null,
        key: string | null,
      } | null,
      dateApplied: string | null,
      dateAppliedIndex: string | null,
      dateUpdated: string | null,
    } | null > | null,
    applicationQuestions:  {
      __typename: "ApplicationQuestions",
      id: string,
      jobId: string,
      questions:  Array< {
        __typename: "ApplicationQuestion",
        question: string,
        type: ApplicationQuestionType,
        selector: string,
        options: Array< string | null > | null,
      } | null > | null,
    } | null,
    companyId: string,
    communications:  {
      __typename: "CommunicationInfo",
      emails: Array< string | null > | null,
      phone: string | null,
    } | null,
    companyProfile:  {
      __typename: "EmployerProfile",
      industries: Array< string | null > | null,
      remotePolicy: Policy | null,
      name: string | null,
      bio: string | null,
      hasHeadquarters: boolean | null,
      hqAddress:  {
        __typename: "CityLocation",
        formatted_address: string,
        coordinate:  {
          __typename: "Location",
          lat: number,
          lon: number,
        },
      } | null,
      emailAddress: string | null,
      phoneNumber: string | null,
      image: string | null,
    } | null,
    companyWebsite: string | null,
    companyName: string,
    dateCreated: string | null,
    dateModified: string | null,
    datePosted: string | null,
    deleted: boolean | null,
    department: string,
    description: string,
    digitalNomadFriendly: boolean | null,
    elite: boolean | null,
    endSalaryRangeThousands: number | null,
    experience: ExperienceLevel,
    featured: boolean | null,
    featuredRank: number | null,
    flexibleHours: boolean | null,
    id: string,
    jobLogo: string | null,
    jobTitle: string,
    officeFrequency:  {
      __typename: "OfficeFrequency",
      daysPerMonth: number | null,
      daysPerWeek: number | null,
    } | null,
    officeLocations:  Array< {
      __typename: "CityLocation",
      formatted_address: string,
      coordinate:  {
        __typename: "Location",
        lat: number,
        lon: number,
      },
    } | null > | null,
    paymentHistory:  Array< {
      __typename: "PaymentRecord",
      stripeId: string,
      productId: string,
      paymentPlan: PaymentPlan,
      dateCreated: string,
      dateEnded: string | null,
    } | null > | null,
    paymentPlan: PaymentPlan | null,
    remoteFirst: boolean | null,
    remotePolicy: JobPolicy | null,
    roleType: WorkType,
    scraped: boolean | null,
    scrapedSource: string | null,
    scrapedUrl: string | null,
    startSalaryRangeThousands: number | null,
    status: JobStatus | null,
    stripeId: string | null,
    tags: Array< JobTag | null > | null,
    timezonePolicy: TimezonePolicy | null,
    timezoneRanges:  Array< {
      __typename: "TimezoneRange",
      start: number | null,
      end: number | null,
    } | null > | null,
    wageIsHourly: boolean | null,
    willSponsor: boolean | null,
    workFromAnywhere: boolean | null,
  } | null > | null,
};

export type SearchJobsAutoApplyQueryVariables = {
  input?: AutoSearchInput | null,
};

export type SearchJobsAutoApplyQuery = {
  searchJobsAutoApply:  Array< {
    __typename: "Job",
    aboutUs: string,
    applications:  Array< {
      __typename: "Application",
      id: string,
      jobId: string,
      jobSeekerId: string,
      applicationStatus: ApplicationStatus | null,
      coverLetter: string | null,
      job:  {
        __typename: "Job",
        aboutUs: string,
        applications:  Array< {
          __typename: "Application",
          id: string,
          jobId: string,
          jobSeekerId: string,
          applicationStatus: ApplicationStatus | null,
          coverLetter: string | null,
          proof: string | null,
          isAuto: boolean | null,
          formScreenshot: string | null,
          confirmationScreenshot: string | null,
          generatedResumeUrl: string | null,
          dateApplied: string | null,
          dateAppliedIndex: string | null,
          dateUpdated: string | null,
        } | null > | null,
        applicationQuestions:  {
          __typename: "ApplicationQuestions",
          id: string,
          jobId: string,
        } | null,
        companyId: string,
        communications:  {
          __typename: "CommunicationInfo",
          emails: Array< string | null > | null,
          phone: string | null,
        } | null,
        companyProfile:  {
          __typename: "EmployerProfile",
          industries: Array< string | null > | null,
          remotePolicy: Policy | null,
          name: string | null,
          bio: string | null,
          hasHeadquarters: boolean | null,
          emailAddress: string | null,
          phoneNumber: string | null,
          image: string | null,
        } | null,
        companyWebsite: string | null,
        companyName: string,
        dateCreated: string | null,
        dateModified: string | null,
        datePosted: string | null,
        deleted: boolean | null,
        department: string,
        description: string,
        digitalNomadFriendly: boolean | null,
        elite: boolean | null,
        endSalaryRangeThousands: number | null,
        experience: ExperienceLevel,
        featured: boolean | null,
        featuredRank: number | null,
        flexibleHours: boolean | null,
        id: string,
        jobLogo: string | null,
        jobTitle: string,
        officeFrequency:  {
          __typename: "OfficeFrequency",
          daysPerMonth: number | null,
          daysPerWeek: number | null,
        } | null,
        officeLocations:  Array< {
          __typename: "CityLocation",
          formatted_address: string,
        } | null > | null,
        paymentHistory:  Array< {
          __typename: "PaymentRecord",
          stripeId: string,
          productId: string,
          paymentPlan: PaymentPlan,
          dateCreated: string,
          dateEnded: string | null,
        } | null > | null,
        paymentPlan: PaymentPlan | null,
        remoteFirst: boolean | null,
        remotePolicy: JobPolicy | null,
        roleType: WorkType,
        scraped: boolean | null,
        scrapedSource: string | null,
        scrapedUrl: string | null,
        startSalaryRangeThousands: number | null,
        status: JobStatus | null,
        stripeId: string | null,
        tags: Array< JobTag | null > | null,
        timezonePolicy: TimezonePolicy | null,
        timezoneRanges:  Array< {
          __typename: "TimezoneRange",
          start: number | null,
          end: number | null,
        } | null > | null,
        wageIsHourly: boolean | null,
        willSponsor: boolean | null,
        workFromAnywhere: boolean | null,
      } | null,
      applicant:  {
        __typename: "JobSeeker",
        id: string,
        userId: string | null,
        firstName: string | null,
        lastName: string | null,
        city:  {
          __typename: "CityLocation",
          formatted_address: string,
        } | null,
        newGradOrStudent: boolean | null,
        linkedin: string | null,
        website: string | null,
        currentCompany: string | null,
        currentTitle: string | null,
        fullTime: boolean | null,
        partTime: boolean | null,
        contractor: boolean | null,
        fullRemote: boolean | null,
        hybridRemote: boolean | null,
        remoteOptional: boolean | null,
        desiredRole: string | null,
        salaryRequirement:  {
          __typename: "Salary",
          currencyCode: string | null,
          value: number | null,
        } | null,
        authorization:  {
          __typename: "WorkAuthorization",
          usAuthorized: boolean | null,
          requireSponsorshipUS: boolean | null,
        } | null,
        recommendedJobsEmail: boolean | null,
        newsletterEmail: boolean | null,
        notificationSettings:  {
          __typename: "NotificationSettings",
          reviewsProfile: NotificationSetting | null,
        } | null,
        visibleToEmployers: boolean | null,
        emailAddress: string | null,
        phone: string | null,
        phoneVerified: boolean | null,
        profilePic: string | null,
        experienceLevel: ExperienceLevel | null,
        workHistory:  Array< {
          __typename: "WorkHistory",
          company: string,
          title: string,
          startDate: string,
          endDate: string | null,
          currentJob: boolean,
          description: string | null,
        } | null > | null,
        educationHistory:  Array< {
          __typename: "EducationHistory",
          institution: string,
          certification: string,
          concentration: string | null,
          dateStarted: string,
          dateCompleted: string | null,
          inProgress: boolean | null,
          description: string | null,
        } | null > | null,
        applications:  Array< {
          __typename: "Application",
          id: string,
          jobId: string,
          jobSeekerId: string,
          applicationStatus: ApplicationStatus | null,
          coverLetter: string | null,
          proof: string | null,
          isAuto: boolean | null,
          formScreenshot: string | null,
          confirmationScreenshot: string | null,
          generatedResumeUrl: string | null,
          dateApplied: string | null,
          dateAppliedIndex: string | null,
          dateUpdated: string | null,
        } | null > | null,
        resume:  {
          __typename: "Resume",
          id: string,
          name: string,
          fileType: string,
          size: string,
          url: string,
          resumeJSON: string | null,
          jobSeekerId: string | null,
          dateUploaded: string,
          dateCreated: string,
          deleted: boolean | null,
        } | null,
        autoResumes:  Array< {
          __typename: "Resume",
          id: string,
          name: string,
          fileType: string,
          size: string,
          url: string,
          resumeJSON: string | null,
          jobSeekerId: string | null,
          dateUploaded: string,
          dateCreated: string,
          deleted: boolean | null,
        } | null > | null,
        preferencesComplete: boolean | null,
        profileComplete: boolean | null,
        autoApply:  Array< {
          __typename: "AutoApply",
          id: string | null,
          jobSeekerId: string | null,
          subId: string | null,
          userId: string | null,
          autoGenerateCoverLetter: boolean | null,
          autoGenerateCoverLetterTone: string | null,
          autoGenerateCoverLetterGreeting: string | null,
          autoGenerateCoverLetterSignOff: string | null,
          autoGenerateCoverLetterInstructions: string | null,
          openToRelocation: boolean | null,
          languagesSpoken: Array< string | null > | null,
          age: number | null,
          genderIdentity: string | null,
          blockedCompanyList: Array< string | null > | null,
          resumeText: string | null,
          coverLetter: string | null,
          aiGenerateCoverLetter: boolean | null,
          coverLetterTone: string | null,
          draft: boolean | null,
          email: string | null,
          isActive: string | null,
          firstName: string | null,
          lastName: string | null,
          remote: boolean | null,
          hybrid: boolean | null,
          onsite: boolean | null,
          jobTitles: Array< string | null > | null,
          negativeJobTitles: Array< string | null > | null,
          industries: Array< string | null > | null,
          experienceLevels: Array< ExperienceLevel | null > | null,
          excludeCompanyNames: Array< string | null > | null,
          expiresAt: string | null,
          subscribedOn: string | null,
          plan: AutoApplySub | null,
          applicationCount: number | null,
          paymentFailed: boolean | null,
          country: string | null,
          region: string | null,
          area: string | null,
          customPreference: Array< string | null > | null,
          appliedUrls: Array< string | null > | null,
          salaryMin: number | null,
          salaryMax: number | null,
          salaryRange: string | null,
          searchTags: Array< string | null > | null,
          prompt: string | null,
          phone: string | null,
          address: string | null,
          currentCompany: string | null,
          linkedinProfile: string | null,
          githubProfile: string | null,
          website: string | null,
          gender: string | null,
          pronouns: string | null,
          hispanic: boolean | null,
          race: string | null,
          paused: boolean | null,
          disabled: boolean | null,
          veteran: boolean | null,
          secretClearance: boolean | null,
          appCountToday: number | null,
          appCountDateUpdated: string | null,
          maxPerDay: number | null,
          maxPerCo: number | null,
          hourToRun: number | null,
          minuteToRun: number | null,
          resumeUrl: string | null,
          resumeName: string | null,
          trial: boolean | null,
          trialExpired: boolean | null,
          gsiConstant: string | null,
          dateCreated: string | null,
          cancelled: boolean | null,
          searchCustomInstructions: string | null,
        } | null > | null,
        dateCreated: string | null,
        dateModified: string | null,
        deleted: boolean | null,
      } | null,
      proof: string | null,
      isAuto: boolean | null,
      formScreenshot: string | null,
      confirmationScreenshot: string | null,
      generatedResumeUrl: string | null,
      applicationAnswers:  {
        __typename: "ApplicationAnswers",
        id: string,
        applicationId: string,
        jobSeekerId: string,
        jobId: string,
        responses:  Array< {
          __typename: "ApplicationAnswer",
          id: string,
          question: string | null,
          answer: string | null,
          type: ApplicationQuestionType | null,
        } | null > | null,
        dateCreated: string | null,
        dateModified: string | null,
      } | null,
      resumeS3Params:  {
        __typename: "ResumeS3Params",
        bucket: string | null,
        key: string | null,
      } | null,
      dateApplied: string | null,
      dateAppliedIndex: string | null,
      dateUpdated: string | null,
    } | null > | null,
    applicationQuestions:  {
      __typename: "ApplicationQuestions",
      id: string,
      jobId: string,
      questions:  Array< {
        __typename: "ApplicationQuestion",
        question: string,
        type: ApplicationQuestionType,
        selector: string,
        options: Array< string | null > | null,
      } | null > | null,
    } | null,
    companyId: string,
    communications:  {
      __typename: "CommunicationInfo",
      emails: Array< string | null > | null,
      phone: string | null,
    } | null,
    companyProfile:  {
      __typename: "EmployerProfile",
      industries: Array< string | null > | null,
      remotePolicy: Policy | null,
      name: string | null,
      bio: string | null,
      hasHeadquarters: boolean | null,
      hqAddress:  {
        __typename: "CityLocation",
        formatted_address: string,
        coordinate:  {
          __typename: "Location",
          lat: number,
          lon: number,
        },
      } | null,
      emailAddress: string | null,
      phoneNumber: string | null,
      image: string | null,
    } | null,
    companyWebsite: string | null,
    companyName: string,
    dateCreated: string | null,
    dateModified: string | null,
    datePosted: string | null,
    deleted: boolean | null,
    department: string,
    description: string,
    digitalNomadFriendly: boolean | null,
    elite: boolean | null,
    endSalaryRangeThousands: number | null,
    experience: ExperienceLevel,
    featured: boolean | null,
    featuredRank: number | null,
    flexibleHours: boolean | null,
    id: string,
    jobLogo: string | null,
    jobTitle: string,
    officeFrequency:  {
      __typename: "OfficeFrequency",
      daysPerMonth: number | null,
      daysPerWeek: number | null,
    } | null,
    officeLocations:  Array< {
      __typename: "CityLocation",
      formatted_address: string,
      coordinate:  {
        __typename: "Location",
        lat: number,
        lon: number,
      },
    } | null > | null,
    paymentHistory:  Array< {
      __typename: "PaymentRecord",
      stripeId: string,
      productId: string,
      paymentPlan: PaymentPlan,
      dateCreated: string,
      dateEnded: string | null,
    } | null > | null,
    paymentPlan: PaymentPlan | null,
    remoteFirst: boolean | null,
    remotePolicy: JobPolicy | null,
    roleType: WorkType,
    scraped: boolean | null,
    scrapedSource: string | null,
    scrapedUrl: string | null,
    startSalaryRangeThousands: number | null,
    status: JobStatus | null,
    stripeId: string | null,
    tags: Array< JobTag | null > | null,
    timezonePolicy: TimezonePolicy | null,
    timezoneRanges:  Array< {
      __typename: "TimezoneRange",
      start: number | null,
      end: number | null,
    } | null > | null,
    wageIsHourly: boolean | null,
    willSponsor: boolean | null,
    workFromAnywhere: boolean | null,
  } | null > | null,
};

export type SearchJobsByCompanyNameAndJobTitleQueryVariables = {
  input?: FeaturedSearchInput | null,
};

export type SearchJobsByCompanyNameAndJobTitleQuery = {
  searchJobsByCompanyNameAndJobTitle:  Array< {
    __typename: "Job",
    aboutUs: string,
    applications:  Array< {
      __typename: "Application",
      id: string,
      jobId: string,
      jobSeekerId: string,
      applicationStatus: ApplicationStatus | null,
      coverLetter: string | null,
      job:  {
        __typename: "Job",
        aboutUs: string,
        applications:  Array< {
          __typename: "Application",
          id: string,
          jobId: string,
          jobSeekerId: string,
          applicationStatus: ApplicationStatus | null,
          coverLetter: string | null,
          proof: string | null,
          isAuto: boolean | null,
          formScreenshot: string | null,
          confirmationScreenshot: string | null,
          generatedResumeUrl: string | null,
          dateApplied: string | null,
          dateAppliedIndex: string | null,
          dateUpdated: string | null,
        } | null > | null,
        applicationQuestions:  {
          __typename: "ApplicationQuestions",
          id: string,
          jobId: string,
        } | null,
        companyId: string,
        communications:  {
          __typename: "CommunicationInfo",
          emails: Array< string | null > | null,
          phone: string | null,
        } | null,
        companyProfile:  {
          __typename: "EmployerProfile",
          industries: Array< string | null > | null,
          remotePolicy: Policy | null,
          name: string | null,
          bio: string | null,
          hasHeadquarters: boolean | null,
          emailAddress: string | null,
          phoneNumber: string | null,
          image: string | null,
        } | null,
        companyWebsite: string | null,
        companyName: string,
        dateCreated: string | null,
        dateModified: string | null,
        datePosted: string | null,
        deleted: boolean | null,
        department: string,
        description: string,
        digitalNomadFriendly: boolean | null,
        elite: boolean | null,
        endSalaryRangeThousands: number | null,
        experience: ExperienceLevel,
        featured: boolean | null,
        featuredRank: number | null,
        flexibleHours: boolean | null,
        id: string,
        jobLogo: string | null,
        jobTitle: string,
        officeFrequency:  {
          __typename: "OfficeFrequency",
          daysPerMonth: number | null,
          daysPerWeek: number | null,
        } | null,
        officeLocations:  Array< {
          __typename: "CityLocation",
          formatted_address: string,
        } | null > | null,
        paymentHistory:  Array< {
          __typename: "PaymentRecord",
          stripeId: string,
          productId: string,
          paymentPlan: PaymentPlan,
          dateCreated: string,
          dateEnded: string | null,
        } | null > | null,
        paymentPlan: PaymentPlan | null,
        remoteFirst: boolean | null,
        remotePolicy: JobPolicy | null,
        roleType: WorkType,
        scraped: boolean | null,
        scrapedSource: string | null,
        scrapedUrl: string | null,
        startSalaryRangeThousands: number | null,
        status: JobStatus | null,
        stripeId: string | null,
        tags: Array< JobTag | null > | null,
        timezonePolicy: TimezonePolicy | null,
        timezoneRanges:  Array< {
          __typename: "TimezoneRange",
          start: number | null,
          end: number | null,
        } | null > | null,
        wageIsHourly: boolean | null,
        willSponsor: boolean | null,
        workFromAnywhere: boolean | null,
      } | null,
      applicant:  {
        __typename: "JobSeeker",
        id: string,
        userId: string | null,
        firstName: string | null,
        lastName: string | null,
        city:  {
          __typename: "CityLocation",
          formatted_address: string,
        } | null,
        newGradOrStudent: boolean | null,
        linkedin: string | null,
        website: string | null,
        currentCompany: string | null,
        currentTitle: string | null,
        fullTime: boolean | null,
        partTime: boolean | null,
        contractor: boolean | null,
        fullRemote: boolean | null,
        hybridRemote: boolean | null,
        remoteOptional: boolean | null,
        desiredRole: string | null,
        salaryRequirement:  {
          __typename: "Salary",
          currencyCode: string | null,
          value: number | null,
        } | null,
        authorization:  {
          __typename: "WorkAuthorization",
          usAuthorized: boolean | null,
          requireSponsorshipUS: boolean | null,
        } | null,
        recommendedJobsEmail: boolean | null,
        newsletterEmail: boolean | null,
        notificationSettings:  {
          __typename: "NotificationSettings",
          reviewsProfile: NotificationSetting | null,
        } | null,
        visibleToEmployers: boolean | null,
        emailAddress: string | null,
        phone: string | null,
        phoneVerified: boolean | null,
        profilePic: string | null,
        experienceLevel: ExperienceLevel | null,
        workHistory:  Array< {
          __typename: "WorkHistory",
          company: string,
          title: string,
          startDate: string,
          endDate: string | null,
          currentJob: boolean,
          description: string | null,
        } | null > | null,
        educationHistory:  Array< {
          __typename: "EducationHistory",
          institution: string,
          certification: string,
          concentration: string | null,
          dateStarted: string,
          dateCompleted: string | null,
          inProgress: boolean | null,
          description: string | null,
        } | null > | null,
        applications:  Array< {
          __typename: "Application",
          id: string,
          jobId: string,
          jobSeekerId: string,
          applicationStatus: ApplicationStatus | null,
          coverLetter: string | null,
          proof: string | null,
          isAuto: boolean | null,
          formScreenshot: string | null,
          confirmationScreenshot: string | null,
          generatedResumeUrl: string | null,
          dateApplied: string | null,
          dateAppliedIndex: string | null,
          dateUpdated: string | null,
        } | null > | null,
        resume:  {
          __typename: "Resume",
          id: string,
          name: string,
          fileType: string,
          size: string,
          url: string,
          resumeJSON: string | null,
          jobSeekerId: string | null,
          dateUploaded: string,
          dateCreated: string,
          deleted: boolean | null,
        } | null,
        autoResumes:  Array< {
          __typename: "Resume",
          id: string,
          name: string,
          fileType: string,
          size: string,
          url: string,
          resumeJSON: string | null,
          jobSeekerId: string | null,
          dateUploaded: string,
          dateCreated: string,
          deleted: boolean | null,
        } | null > | null,
        preferencesComplete: boolean | null,
        profileComplete: boolean | null,
        autoApply:  Array< {
          __typename: "AutoApply",
          id: string | null,
          jobSeekerId: string | null,
          subId: string | null,
          userId: string | null,
          autoGenerateCoverLetter: boolean | null,
          autoGenerateCoverLetterTone: string | null,
          autoGenerateCoverLetterGreeting: string | null,
          autoGenerateCoverLetterSignOff: string | null,
          autoGenerateCoverLetterInstructions: string | null,
          openToRelocation: boolean | null,
          languagesSpoken: Array< string | null > | null,
          age: number | null,
          genderIdentity: string | null,
          blockedCompanyList: Array< string | null > | null,
          resumeText: string | null,
          coverLetter: string | null,
          aiGenerateCoverLetter: boolean | null,
          coverLetterTone: string | null,
          draft: boolean | null,
          email: string | null,
          isActive: string | null,
          firstName: string | null,
          lastName: string | null,
          remote: boolean | null,
          hybrid: boolean | null,
          onsite: boolean | null,
          jobTitles: Array< string | null > | null,
          negativeJobTitles: Array< string | null > | null,
          industries: Array< string | null > | null,
          experienceLevels: Array< ExperienceLevel | null > | null,
          excludeCompanyNames: Array< string | null > | null,
          expiresAt: string | null,
          subscribedOn: string | null,
          plan: AutoApplySub | null,
          applicationCount: number | null,
          paymentFailed: boolean | null,
          country: string | null,
          region: string | null,
          area: string | null,
          customPreference: Array< string | null > | null,
          appliedUrls: Array< string | null > | null,
          salaryMin: number | null,
          salaryMax: number | null,
          salaryRange: string | null,
          searchTags: Array< string | null > | null,
          prompt: string | null,
          phone: string | null,
          address: string | null,
          currentCompany: string | null,
          linkedinProfile: string | null,
          githubProfile: string | null,
          website: string | null,
          gender: string | null,
          pronouns: string | null,
          hispanic: boolean | null,
          race: string | null,
          paused: boolean | null,
          disabled: boolean | null,
          veteran: boolean | null,
          secretClearance: boolean | null,
          appCountToday: number | null,
          appCountDateUpdated: string | null,
          maxPerDay: number | null,
          maxPerCo: number | null,
          hourToRun: number | null,
          minuteToRun: number | null,
          resumeUrl: string | null,
          resumeName: string | null,
          trial: boolean | null,
          trialExpired: boolean | null,
          gsiConstant: string | null,
          dateCreated: string | null,
          cancelled: boolean | null,
          searchCustomInstructions: string | null,
        } | null > | null,
        dateCreated: string | null,
        dateModified: string | null,
        deleted: boolean | null,
      } | null,
      proof: string | null,
      isAuto: boolean | null,
      formScreenshot: string | null,
      confirmationScreenshot: string | null,
      generatedResumeUrl: string | null,
      applicationAnswers:  {
        __typename: "ApplicationAnswers",
        id: string,
        applicationId: string,
        jobSeekerId: string,
        jobId: string,
        responses:  Array< {
          __typename: "ApplicationAnswer",
          id: string,
          question: string | null,
          answer: string | null,
          type: ApplicationQuestionType | null,
        } | null > | null,
        dateCreated: string | null,
        dateModified: string | null,
      } | null,
      resumeS3Params:  {
        __typename: "ResumeS3Params",
        bucket: string | null,
        key: string | null,
      } | null,
      dateApplied: string | null,
      dateAppliedIndex: string | null,
      dateUpdated: string | null,
    } | null > | null,
    applicationQuestions:  {
      __typename: "ApplicationQuestions",
      id: string,
      jobId: string,
      questions:  Array< {
        __typename: "ApplicationQuestion",
        question: string,
        type: ApplicationQuestionType,
        selector: string,
        options: Array< string | null > | null,
      } | null > | null,
    } | null,
    companyId: string,
    communications:  {
      __typename: "CommunicationInfo",
      emails: Array< string | null > | null,
      phone: string | null,
    } | null,
    companyProfile:  {
      __typename: "EmployerProfile",
      industries: Array< string | null > | null,
      remotePolicy: Policy | null,
      name: string | null,
      bio: string | null,
      hasHeadquarters: boolean | null,
      hqAddress:  {
        __typename: "CityLocation",
        formatted_address: string,
        coordinate:  {
          __typename: "Location",
          lat: number,
          lon: number,
        },
      } | null,
      emailAddress: string | null,
      phoneNumber: string | null,
      image: string | null,
    } | null,
    companyWebsite: string | null,
    companyName: string,
    dateCreated: string | null,
    dateModified: string | null,
    datePosted: string | null,
    deleted: boolean | null,
    department: string,
    description: string,
    digitalNomadFriendly: boolean | null,
    elite: boolean | null,
    endSalaryRangeThousands: number | null,
    experience: ExperienceLevel,
    featured: boolean | null,
    featuredRank: number | null,
    flexibleHours: boolean | null,
    id: string,
    jobLogo: string | null,
    jobTitle: string,
    officeFrequency:  {
      __typename: "OfficeFrequency",
      daysPerMonth: number | null,
      daysPerWeek: number | null,
    } | null,
    officeLocations:  Array< {
      __typename: "CityLocation",
      formatted_address: string,
      coordinate:  {
        __typename: "Location",
        lat: number,
        lon: number,
      },
    } | null > | null,
    paymentHistory:  Array< {
      __typename: "PaymentRecord",
      stripeId: string,
      productId: string,
      paymentPlan: PaymentPlan,
      dateCreated: string,
      dateEnded: string | null,
    } | null > | null,
    paymentPlan: PaymentPlan | null,
    remoteFirst: boolean | null,
    remotePolicy: JobPolicy | null,
    roleType: WorkType,
    scraped: boolean | null,
    scrapedSource: string | null,
    scrapedUrl: string | null,
    startSalaryRangeThousands: number | null,
    status: JobStatus | null,
    stripeId: string | null,
    tags: Array< JobTag | null > | null,
    timezonePolicy: TimezonePolicy | null,
    timezoneRanges:  Array< {
      __typename: "TimezoneRange",
      start: number | null,
      end: number | null,
    } | null > | null,
    wageIsHourly: boolean | null,
    willSponsor: boolean | null,
    workFromAnywhere: boolean | null,
  } | null > | null,
};

export type SearchJobsByCompanyIdQueryVariables = {
  input?: JobsByCompanySearch | null,
};

export type SearchJobsByCompanyIdQuery = {
  searchJobsByCompanyId:  Array< {
    __typename: "Job",
    aboutUs: string,
    applications:  Array< {
      __typename: "Application",
      id: string,
      jobId: string,
      jobSeekerId: string,
      applicationStatus: ApplicationStatus | null,
      coverLetter: string | null,
      job:  {
        __typename: "Job",
        aboutUs: string,
        applications:  Array< {
          __typename: "Application",
          id: string,
          jobId: string,
          jobSeekerId: string,
          applicationStatus: ApplicationStatus | null,
          coverLetter: string | null,
          proof: string | null,
          isAuto: boolean | null,
          formScreenshot: string | null,
          confirmationScreenshot: string | null,
          generatedResumeUrl: string | null,
          dateApplied: string | null,
          dateAppliedIndex: string | null,
          dateUpdated: string | null,
        } | null > | null,
        applicationQuestions:  {
          __typename: "ApplicationQuestions",
          id: string,
          jobId: string,
        } | null,
        companyId: string,
        communications:  {
          __typename: "CommunicationInfo",
          emails: Array< string | null > | null,
          phone: string | null,
        } | null,
        companyProfile:  {
          __typename: "EmployerProfile",
          industries: Array< string | null > | null,
          remotePolicy: Policy | null,
          name: string | null,
          bio: string | null,
          hasHeadquarters: boolean | null,
          emailAddress: string | null,
          phoneNumber: string | null,
          image: string | null,
        } | null,
        companyWebsite: string | null,
        companyName: string,
        dateCreated: string | null,
        dateModified: string | null,
        datePosted: string | null,
        deleted: boolean | null,
        department: string,
        description: string,
        digitalNomadFriendly: boolean | null,
        elite: boolean | null,
        endSalaryRangeThousands: number | null,
        experience: ExperienceLevel,
        featured: boolean | null,
        featuredRank: number | null,
        flexibleHours: boolean | null,
        id: string,
        jobLogo: string | null,
        jobTitle: string,
        officeFrequency:  {
          __typename: "OfficeFrequency",
          daysPerMonth: number | null,
          daysPerWeek: number | null,
        } | null,
        officeLocations:  Array< {
          __typename: "CityLocation",
          formatted_address: string,
        } | null > | null,
        paymentHistory:  Array< {
          __typename: "PaymentRecord",
          stripeId: string,
          productId: string,
          paymentPlan: PaymentPlan,
          dateCreated: string,
          dateEnded: string | null,
        } | null > | null,
        paymentPlan: PaymentPlan | null,
        remoteFirst: boolean | null,
        remotePolicy: JobPolicy | null,
        roleType: WorkType,
        scraped: boolean | null,
        scrapedSource: string | null,
        scrapedUrl: string | null,
        startSalaryRangeThousands: number | null,
        status: JobStatus | null,
        stripeId: string | null,
        tags: Array< JobTag | null > | null,
        timezonePolicy: TimezonePolicy | null,
        timezoneRanges:  Array< {
          __typename: "TimezoneRange",
          start: number | null,
          end: number | null,
        } | null > | null,
        wageIsHourly: boolean | null,
        willSponsor: boolean | null,
        workFromAnywhere: boolean | null,
      } | null,
      applicant:  {
        __typename: "JobSeeker",
        id: string,
        userId: string | null,
        firstName: string | null,
        lastName: string | null,
        city:  {
          __typename: "CityLocation",
          formatted_address: string,
        } | null,
        newGradOrStudent: boolean | null,
        linkedin: string | null,
        website: string | null,
        currentCompany: string | null,
        currentTitle: string | null,
        fullTime: boolean | null,
        partTime: boolean | null,
        contractor: boolean | null,
        fullRemote: boolean | null,
        hybridRemote: boolean | null,
        remoteOptional: boolean | null,
        desiredRole: string | null,
        salaryRequirement:  {
          __typename: "Salary",
          currencyCode: string | null,
          value: number | null,
        } | null,
        authorization:  {
          __typename: "WorkAuthorization",
          usAuthorized: boolean | null,
          requireSponsorshipUS: boolean | null,
        } | null,
        recommendedJobsEmail: boolean | null,
        newsletterEmail: boolean | null,
        notificationSettings:  {
          __typename: "NotificationSettings",
          reviewsProfile: NotificationSetting | null,
        } | null,
        visibleToEmployers: boolean | null,
        emailAddress: string | null,
        phone: string | null,
        phoneVerified: boolean | null,
        profilePic: string | null,
        experienceLevel: ExperienceLevel | null,
        workHistory:  Array< {
          __typename: "WorkHistory",
          company: string,
          title: string,
          startDate: string,
          endDate: string | null,
          currentJob: boolean,
          description: string | null,
        } | null > | null,
        educationHistory:  Array< {
          __typename: "EducationHistory",
          institution: string,
          certification: string,
          concentration: string | null,
          dateStarted: string,
          dateCompleted: string | null,
          inProgress: boolean | null,
          description: string | null,
        } | null > | null,
        applications:  Array< {
          __typename: "Application",
          id: string,
          jobId: string,
          jobSeekerId: string,
          applicationStatus: ApplicationStatus | null,
          coverLetter: string | null,
          proof: string | null,
          isAuto: boolean | null,
          formScreenshot: string | null,
          confirmationScreenshot: string | null,
          generatedResumeUrl: string | null,
          dateApplied: string | null,
          dateAppliedIndex: string | null,
          dateUpdated: string | null,
        } | null > | null,
        resume:  {
          __typename: "Resume",
          id: string,
          name: string,
          fileType: string,
          size: string,
          url: string,
          resumeJSON: string | null,
          jobSeekerId: string | null,
          dateUploaded: string,
          dateCreated: string,
          deleted: boolean | null,
        } | null,
        autoResumes:  Array< {
          __typename: "Resume",
          id: string,
          name: string,
          fileType: string,
          size: string,
          url: string,
          resumeJSON: string | null,
          jobSeekerId: string | null,
          dateUploaded: string,
          dateCreated: string,
          deleted: boolean | null,
        } | null > | null,
        preferencesComplete: boolean | null,
        profileComplete: boolean | null,
        autoApply:  Array< {
          __typename: "AutoApply",
          id: string | null,
          jobSeekerId: string | null,
          subId: string | null,
          userId: string | null,
          autoGenerateCoverLetter: boolean | null,
          autoGenerateCoverLetterTone: string | null,
          autoGenerateCoverLetterGreeting: string | null,
          autoGenerateCoverLetterSignOff: string | null,
          autoGenerateCoverLetterInstructions: string | null,
          openToRelocation: boolean | null,
          languagesSpoken: Array< string | null > | null,
          age: number | null,
          genderIdentity: string | null,
          blockedCompanyList: Array< string | null > | null,
          resumeText: string | null,
          coverLetter: string | null,
          aiGenerateCoverLetter: boolean | null,
          coverLetterTone: string | null,
          draft: boolean | null,
          email: string | null,
          isActive: string | null,
          firstName: string | null,
          lastName: string | null,
          remote: boolean | null,
          hybrid: boolean | null,
          onsite: boolean | null,
          jobTitles: Array< string | null > | null,
          negativeJobTitles: Array< string | null > | null,
          industries: Array< string | null > | null,
          experienceLevels: Array< ExperienceLevel | null > | null,
          excludeCompanyNames: Array< string | null > | null,
          expiresAt: string | null,
          subscribedOn: string | null,
          plan: AutoApplySub | null,
          applicationCount: number | null,
          paymentFailed: boolean | null,
          country: string | null,
          region: string | null,
          area: string | null,
          customPreference: Array< string | null > | null,
          appliedUrls: Array< string | null > | null,
          salaryMin: number | null,
          salaryMax: number | null,
          salaryRange: string | null,
          searchTags: Array< string | null > | null,
          prompt: string | null,
          phone: string | null,
          address: string | null,
          currentCompany: string | null,
          linkedinProfile: string | null,
          githubProfile: string | null,
          website: string | null,
          gender: string | null,
          pronouns: string | null,
          hispanic: boolean | null,
          race: string | null,
          paused: boolean | null,
          disabled: boolean | null,
          veteran: boolean | null,
          secretClearance: boolean | null,
          appCountToday: number | null,
          appCountDateUpdated: string | null,
          maxPerDay: number | null,
          maxPerCo: number | null,
          hourToRun: number | null,
          minuteToRun: number | null,
          resumeUrl: string | null,
          resumeName: string | null,
          trial: boolean | null,
          trialExpired: boolean | null,
          gsiConstant: string | null,
          dateCreated: string | null,
          cancelled: boolean | null,
          searchCustomInstructions: string | null,
        } | null > | null,
        dateCreated: string | null,
        dateModified: string | null,
        deleted: boolean | null,
      } | null,
      proof: string | null,
      isAuto: boolean | null,
      formScreenshot: string | null,
      confirmationScreenshot: string | null,
      generatedResumeUrl: string | null,
      applicationAnswers:  {
        __typename: "ApplicationAnswers",
        id: string,
        applicationId: string,
        jobSeekerId: string,
        jobId: string,
        responses:  Array< {
          __typename: "ApplicationAnswer",
          id: string,
          question: string | null,
          answer: string | null,
          type: ApplicationQuestionType | null,
        } | null > | null,
        dateCreated: string | null,
        dateModified: string | null,
      } | null,
      resumeS3Params:  {
        __typename: "ResumeS3Params",
        bucket: string | null,
        key: string | null,
      } | null,
      dateApplied: string | null,
      dateAppliedIndex: string | null,
      dateUpdated: string | null,
    } | null > | null,
    applicationQuestions:  {
      __typename: "ApplicationQuestions",
      id: string,
      jobId: string,
      questions:  Array< {
        __typename: "ApplicationQuestion",
        question: string,
        type: ApplicationQuestionType,
        selector: string,
        options: Array< string | null > | null,
      } | null > | null,
    } | null,
    companyId: string,
    communications:  {
      __typename: "CommunicationInfo",
      emails: Array< string | null > | null,
      phone: string | null,
    } | null,
    companyProfile:  {
      __typename: "EmployerProfile",
      industries: Array< string | null > | null,
      remotePolicy: Policy | null,
      name: string | null,
      bio: string | null,
      hasHeadquarters: boolean | null,
      hqAddress:  {
        __typename: "CityLocation",
        formatted_address: string,
        coordinate:  {
          __typename: "Location",
          lat: number,
          lon: number,
        },
      } | null,
      emailAddress: string | null,
      phoneNumber: string | null,
      image: string | null,
    } | null,
    companyWebsite: string | null,
    companyName: string,
    dateCreated: string | null,
    dateModified: string | null,
    datePosted: string | null,
    deleted: boolean | null,
    department: string,
    description: string,
    digitalNomadFriendly: boolean | null,
    elite: boolean | null,
    endSalaryRangeThousands: number | null,
    experience: ExperienceLevel,
    featured: boolean | null,
    featuredRank: number | null,
    flexibleHours: boolean | null,
    id: string,
    jobLogo: string | null,
    jobTitle: string,
    officeFrequency:  {
      __typename: "OfficeFrequency",
      daysPerMonth: number | null,
      daysPerWeek: number | null,
    } | null,
    officeLocations:  Array< {
      __typename: "CityLocation",
      formatted_address: string,
      coordinate:  {
        __typename: "Location",
        lat: number,
        lon: number,
      },
    } | null > | null,
    paymentHistory:  Array< {
      __typename: "PaymentRecord",
      stripeId: string,
      productId: string,
      paymentPlan: PaymentPlan,
      dateCreated: string,
      dateEnded: string | null,
    } | null > | null,
    paymentPlan: PaymentPlan | null,
    remoteFirst: boolean | null,
    remotePolicy: JobPolicy | null,
    roleType: WorkType,
    scraped: boolean | null,
    scrapedSource: string | null,
    scrapedUrl: string | null,
    startSalaryRangeThousands: number | null,
    status: JobStatus | null,
    stripeId: string | null,
    tags: Array< JobTag | null > | null,
    timezonePolicy: TimezonePolicy | null,
    timezoneRanges:  Array< {
      __typename: "TimezoneRange",
      start: number | null,
      end: number | null,
    } | null > | null,
    wageIsHourly: boolean | null,
    willSponsor: boolean | null,
    workFromAnywhere: boolean | null,
  } | null > | null,
};

export type FindJobsQueryVariables = {
  text?: string | null,
};

export type FindJobsQuery = {
  findJobs:  Array< {
    __typename: "Job",
    aboutUs: string,
    applications:  Array< {
      __typename: "Application",
      id: string,
      jobId: string,
      jobSeekerId: string,
      applicationStatus: ApplicationStatus | null,
      coverLetter: string | null,
      job:  {
        __typename: "Job",
        aboutUs: string,
        applications:  Array< {
          __typename: "Application",
          id: string,
          jobId: string,
          jobSeekerId: string,
          applicationStatus: ApplicationStatus | null,
          coverLetter: string | null,
          proof: string | null,
          isAuto: boolean | null,
          formScreenshot: string | null,
          confirmationScreenshot: string | null,
          generatedResumeUrl: string | null,
          dateApplied: string | null,
          dateAppliedIndex: string | null,
          dateUpdated: string | null,
        } | null > | null,
        applicationQuestions:  {
          __typename: "ApplicationQuestions",
          id: string,
          jobId: string,
        } | null,
        companyId: string,
        communications:  {
          __typename: "CommunicationInfo",
          emails: Array< string | null > | null,
          phone: string | null,
        } | null,
        companyProfile:  {
          __typename: "EmployerProfile",
          industries: Array< string | null > | null,
          remotePolicy: Policy | null,
          name: string | null,
          bio: string | null,
          hasHeadquarters: boolean | null,
          emailAddress: string | null,
          phoneNumber: string | null,
          image: string | null,
        } | null,
        companyWebsite: string | null,
        companyName: string,
        dateCreated: string | null,
        dateModified: string | null,
        datePosted: string | null,
        deleted: boolean | null,
        department: string,
        description: string,
        digitalNomadFriendly: boolean | null,
        elite: boolean | null,
        endSalaryRangeThousands: number | null,
        experience: ExperienceLevel,
        featured: boolean | null,
        featuredRank: number | null,
        flexibleHours: boolean | null,
        id: string,
        jobLogo: string | null,
        jobTitle: string,
        officeFrequency:  {
          __typename: "OfficeFrequency",
          daysPerMonth: number | null,
          daysPerWeek: number | null,
        } | null,
        officeLocations:  Array< {
          __typename: "CityLocation",
          formatted_address: string,
        } | null > | null,
        paymentHistory:  Array< {
          __typename: "PaymentRecord",
          stripeId: string,
          productId: string,
          paymentPlan: PaymentPlan,
          dateCreated: string,
          dateEnded: string | null,
        } | null > | null,
        paymentPlan: PaymentPlan | null,
        remoteFirst: boolean | null,
        remotePolicy: JobPolicy | null,
        roleType: WorkType,
        scraped: boolean | null,
        scrapedSource: string | null,
        scrapedUrl: string | null,
        startSalaryRangeThousands: number | null,
        status: JobStatus | null,
        stripeId: string | null,
        tags: Array< JobTag | null > | null,
        timezonePolicy: TimezonePolicy | null,
        timezoneRanges:  Array< {
          __typename: "TimezoneRange",
          start: number | null,
          end: number | null,
        } | null > | null,
        wageIsHourly: boolean | null,
        willSponsor: boolean | null,
        workFromAnywhere: boolean | null,
      } | null,
      applicant:  {
        __typename: "JobSeeker",
        id: string,
        userId: string | null,
        firstName: string | null,
        lastName: string | null,
        city:  {
          __typename: "CityLocation",
          formatted_address: string,
        } | null,
        newGradOrStudent: boolean | null,
        linkedin: string | null,
        website: string | null,
        currentCompany: string | null,
        currentTitle: string | null,
        fullTime: boolean | null,
        partTime: boolean | null,
        contractor: boolean | null,
        fullRemote: boolean | null,
        hybridRemote: boolean | null,
        remoteOptional: boolean | null,
        desiredRole: string | null,
        salaryRequirement:  {
          __typename: "Salary",
          currencyCode: string | null,
          value: number | null,
        } | null,
        authorization:  {
          __typename: "WorkAuthorization",
          usAuthorized: boolean | null,
          requireSponsorshipUS: boolean | null,
        } | null,
        recommendedJobsEmail: boolean | null,
        newsletterEmail: boolean | null,
        notificationSettings:  {
          __typename: "NotificationSettings",
          reviewsProfile: NotificationSetting | null,
        } | null,
        visibleToEmployers: boolean | null,
        emailAddress: string | null,
        phone: string | null,
        phoneVerified: boolean | null,
        profilePic: string | null,
        experienceLevel: ExperienceLevel | null,
        workHistory:  Array< {
          __typename: "WorkHistory",
          company: string,
          title: string,
          startDate: string,
          endDate: string | null,
          currentJob: boolean,
          description: string | null,
        } | null > | null,
        educationHistory:  Array< {
          __typename: "EducationHistory",
          institution: string,
          certification: string,
          concentration: string | null,
          dateStarted: string,
          dateCompleted: string | null,
          inProgress: boolean | null,
          description: string | null,
        } | null > | null,
        applications:  Array< {
          __typename: "Application",
          id: string,
          jobId: string,
          jobSeekerId: string,
          applicationStatus: ApplicationStatus | null,
          coverLetter: string | null,
          proof: string | null,
          isAuto: boolean | null,
          formScreenshot: string | null,
          confirmationScreenshot: string | null,
          generatedResumeUrl: string | null,
          dateApplied: string | null,
          dateAppliedIndex: string | null,
          dateUpdated: string | null,
        } | null > | null,
        resume:  {
          __typename: "Resume",
          id: string,
          name: string,
          fileType: string,
          size: string,
          url: string,
          resumeJSON: string | null,
          jobSeekerId: string | null,
          dateUploaded: string,
          dateCreated: string,
          deleted: boolean | null,
        } | null,
        autoResumes:  Array< {
          __typename: "Resume",
          id: string,
          name: string,
          fileType: string,
          size: string,
          url: string,
          resumeJSON: string | null,
          jobSeekerId: string | null,
          dateUploaded: string,
          dateCreated: string,
          deleted: boolean | null,
        } | null > | null,
        preferencesComplete: boolean | null,
        profileComplete: boolean | null,
        autoApply:  Array< {
          __typename: "AutoApply",
          id: string | null,
          jobSeekerId: string | null,
          subId: string | null,
          userId: string | null,
          autoGenerateCoverLetter: boolean | null,
          autoGenerateCoverLetterTone: string | null,
          autoGenerateCoverLetterGreeting: string | null,
          autoGenerateCoverLetterSignOff: string | null,
          autoGenerateCoverLetterInstructions: string | null,
          openToRelocation: boolean | null,
          languagesSpoken: Array< string | null > | null,
          age: number | null,
          genderIdentity: string | null,
          blockedCompanyList: Array< string | null > | null,
          resumeText: string | null,
          coverLetter: string | null,
          aiGenerateCoverLetter: boolean | null,
          coverLetterTone: string | null,
          draft: boolean | null,
          email: string | null,
          isActive: string | null,
          firstName: string | null,
          lastName: string | null,
          remote: boolean | null,
          hybrid: boolean | null,
          onsite: boolean | null,
          jobTitles: Array< string | null > | null,
          negativeJobTitles: Array< string | null > | null,
          industries: Array< string | null > | null,
          experienceLevels: Array< ExperienceLevel | null > | null,
          excludeCompanyNames: Array< string | null > | null,
          expiresAt: string | null,
          subscribedOn: string | null,
          plan: AutoApplySub | null,
          applicationCount: number | null,
          paymentFailed: boolean | null,
          country: string | null,
          region: string | null,
          area: string | null,
          customPreference: Array< string | null > | null,
          appliedUrls: Array< string | null > | null,
          salaryMin: number | null,
          salaryMax: number | null,
          salaryRange: string | null,
          searchTags: Array< string | null > | null,
          prompt: string | null,
          phone: string | null,
          address: string | null,
          currentCompany: string | null,
          linkedinProfile: string | null,
          githubProfile: string | null,
          website: string | null,
          gender: string | null,
          pronouns: string | null,
          hispanic: boolean | null,
          race: string | null,
          paused: boolean | null,
          disabled: boolean | null,
          veteran: boolean | null,
          secretClearance: boolean | null,
          appCountToday: number | null,
          appCountDateUpdated: string | null,
          maxPerDay: number | null,
          maxPerCo: number | null,
          hourToRun: number | null,
          minuteToRun: number | null,
          resumeUrl: string | null,
          resumeName: string | null,
          trial: boolean | null,
          trialExpired: boolean | null,
          gsiConstant: string | null,
          dateCreated: string | null,
          cancelled: boolean | null,
          searchCustomInstructions: string | null,
        } | null > | null,
        dateCreated: string | null,
        dateModified: string | null,
        deleted: boolean | null,
      } | null,
      proof: string | null,
      isAuto: boolean | null,
      formScreenshot: string | null,
      confirmationScreenshot: string | null,
      generatedResumeUrl: string | null,
      applicationAnswers:  {
        __typename: "ApplicationAnswers",
        id: string,
        applicationId: string,
        jobSeekerId: string,
        jobId: string,
        responses:  Array< {
          __typename: "ApplicationAnswer",
          id: string,
          question: string | null,
          answer: string | null,
          type: ApplicationQuestionType | null,
        } | null > | null,
        dateCreated: string | null,
        dateModified: string | null,
      } | null,
      resumeS3Params:  {
        __typename: "ResumeS3Params",
        bucket: string | null,
        key: string | null,
      } | null,
      dateApplied: string | null,
      dateAppliedIndex: string | null,
      dateUpdated: string | null,
    } | null > | null,
    applicationQuestions:  {
      __typename: "ApplicationQuestions",
      id: string,
      jobId: string,
      questions:  Array< {
        __typename: "ApplicationQuestion",
        question: string,
        type: ApplicationQuestionType,
        selector: string,
        options: Array< string | null > | null,
      } | null > | null,
    } | null,
    companyId: string,
    communications:  {
      __typename: "CommunicationInfo",
      emails: Array< string | null > | null,
      phone: string | null,
    } | null,
    companyProfile:  {
      __typename: "EmployerProfile",
      industries: Array< string | null > | null,
      remotePolicy: Policy | null,
      name: string | null,
      bio: string | null,
      hasHeadquarters: boolean | null,
      hqAddress:  {
        __typename: "CityLocation",
        formatted_address: string,
        coordinate:  {
          __typename: "Location",
          lat: number,
          lon: number,
        },
      } | null,
      emailAddress: string | null,
      phoneNumber: string | null,
      image: string | null,
    } | null,
    companyWebsite: string | null,
    companyName: string,
    dateCreated: string | null,
    dateModified: string | null,
    datePosted: string | null,
    deleted: boolean | null,
    department: string,
    description: string,
    digitalNomadFriendly: boolean | null,
    elite: boolean | null,
    endSalaryRangeThousands: number | null,
    experience: ExperienceLevel,
    featured: boolean | null,
    featuredRank: number | null,
    flexibleHours: boolean | null,
    id: string,
    jobLogo: string | null,
    jobTitle: string,
    officeFrequency:  {
      __typename: "OfficeFrequency",
      daysPerMonth: number | null,
      daysPerWeek: number | null,
    } | null,
    officeLocations:  Array< {
      __typename: "CityLocation",
      formatted_address: string,
      coordinate:  {
        __typename: "Location",
        lat: number,
        lon: number,
      },
    } | null > | null,
    paymentHistory:  Array< {
      __typename: "PaymentRecord",
      stripeId: string,
      productId: string,
      paymentPlan: PaymentPlan,
      dateCreated: string,
      dateEnded: string | null,
    } | null > | null,
    paymentPlan: PaymentPlan | null,
    remoteFirst: boolean | null,
    remotePolicy: JobPolicy | null,
    roleType: WorkType,
    scraped: boolean | null,
    scrapedSource: string | null,
    scrapedUrl: string | null,
    startSalaryRangeThousands: number | null,
    status: JobStatus | null,
    stripeId: string | null,
    tags: Array< JobTag | null > | null,
    timezonePolicy: TimezonePolicy | null,
    timezoneRanges:  Array< {
      __typename: "TimezoneRange",
      start: number | null,
      end: number | null,
    } | null > | null,
    wageIsHourly: boolean | null,
    willSponsor: boolean | null,
    workFromAnywhere: boolean | null,
  } | null > | null,
};

export type GetApplicationsForJobSeekerIdByStatusQueryVariables = {
  jobSeekerId?: string | null,
  status?: ApplicationStatus | null,
  first?: number | null,
  after?: ApplicationCursorInput | null,
  last?: number | null,
  before?: ApplicationCursorInput | null,
};

export type GetApplicationsForJobSeekerIdByStatusQuery = {
  getApplicationsForJobSeekerIdByStatus:  {
    __typename: "ApplicationConnection",
    edges:  Array< {
      __typename: "ApplicationEdge",
      node:  {
        __typename: "Application",
        id: string,
        jobId: string,
        jobSeekerId: string,
        applicationStatus: ApplicationStatus | null,
        coverLetter: string | null,
        job:  {
          __typename: "Job",
          aboutUs: string,
          companyId: string,
          companyWebsite: string | null,
          companyName: string,
          dateCreated: string | null,
          dateModified: string | null,
          datePosted: string | null,
          deleted: boolean | null,
          department: string,
          description: string,
          digitalNomadFriendly: boolean | null,
          elite: boolean | null,
          endSalaryRangeThousands: number | null,
          experience: ExperienceLevel,
          featured: boolean | null,
          featuredRank: number | null,
          flexibleHours: boolean | null,
          id: string,
          jobLogo: string | null,
          jobTitle: string,
          paymentPlan: PaymentPlan | null,
          remoteFirst: boolean | null,
          remotePolicy: JobPolicy | null,
          roleType: WorkType,
          scraped: boolean | null,
          scrapedSource: string | null,
          scrapedUrl: string | null,
          startSalaryRangeThousands: number | null,
          status: JobStatus | null,
          stripeId: string | null,
          tags: Array< JobTag | null > | null,
          timezonePolicy: TimezonePolicy | null,
          wageIsHourly: boolean | null,
          willSponsor: boolean | null,
          workFromAnywhere: boolean | null,
        } | null,
        applicant:  {
          __typename: "JobSeeker",
          id: string,
          userId: string | null,
          firstName: string | null,
          lastName: string | null,
          newGradOrStudent: boolean | null,
          linkedin: string | null,
          website: string | null,
          currentCompany: string | null,
          currentTitle: string | null,
          fullTime: boolean | null,
          partTime: boolean | null,
          contractor: boolean | null,
          fullRemote: boolean | null,
          hybridRemote: boolean | null,
          remoteOptional: boolean | null,
          desiredRole: string | null,
          recommendedJobsEmail: boolean | null,
          newsletterEmail: boolean | null,
          visibleToEmployers: boolean | null,
          emailAddress: string | null,
          phone: string | null,
          phoneVerified: boolean | null,
          profilePic: string | null,
          experienceLevel: ExperienceLevel | null,
          preferencesComplete: boolean | null,
          profileComplete: boolean | null,
          dateCreated: string | null,
          dateModified: string | null,
          deleted: boolean | null,
        } | null,
        proof: string | null,
        isAuto: boolean | null,
        formScreenshot: string | null,
        confirmationScreenshot: string | null,
        generatedResumeUrl: string | null,
        applicationAnswers:  {
          __typename: "ApplicationAnswers",
          id: string,
          applicationId: string,
          jobSeekerId: string,
          jobId: string,
          dateCreated: string | null,
          dateModified: string | null,
        } | null,
        resumeS3Params:  {
          __typename: "ResumeS3Params",
          bucket: string | null,
          key: string | null,
        } | null,
        dateApplied: string | null,
        dateAppliedIndex: string | null,
        dateUpdated: string | null,
      },
      cursor:  {
        __typename: "ApplicationCursor",
        id: string,
        jobSeekerId: string,
        dateApplied: string | null,
      },
    } >,
    pageInfo:  {
      __typename: "ApplicationPageInfo",
      startCursor:  {
        __typename: "ApplicationCursor",
        id: string,
        jobSeekerId: string,
        dateApplied: string | null,
      } | null,
      endCursor:  {
        __typename: "ApplicationCursor",
        id: string,
        jobSeekerId: string,
        dateApplied: string | null,
      } | null,
      hasNextPage: boolean,
      hasPreviousPage: boolean,
    },
  },
};

export type GetApplicationsForJobIdByStatusQueryVariables = {
  jobId?: string | null,
  status?: ApplicationStatus | null,
  first?: number | null,
  after?: ApplicationJobIdCursorInput | null,
  last?: number | null,
  before?: ApplicationJobIdCursorInput | null,
};

export type GetApplicationsForJobIdByStatusQuery = {
  getApplicationsForJobIdByStatus:  {
    __typename: "ApplicationJobIdConnection",
    edges:  Array< {
      __typename: "ApplicationJobIdEdge",
      node:  {
        __typename: "Application",
        id: string,
        jobId: string,
        jobSeekerId: string,
        applicationStatus: ApplicationStatus | null,
        coverLetter: string | null,
        job:  {
          __typename: "Job",
          aboutUs: string,
          companyId: string,
          companyWebsite: string | null,
          companyName: string,
          dateCreated: string | null,
          dateModified: string | null,
          datePosted: string | null,
          deleted: boolean | null,
          department: string,
          description: string,
          digitalNomadFriendly: boolean | null,
          elite: boolean | null,
          endSalaryRangeThousands: number | null,
          experience: ExperienceLevel,
          featured: boolean | null,
          featuredRank: number | null,
          flexibleHours: boolean | null,
          id: string,
          jobLogo: string | null,
          jobTitle: string,
          paymentPlan: PaymentPlan | null,
          remoteFirst: boolean | null,
          remotePolicy: JobPolicy | null,
          roleType: WorkType,
          scraped: boolean | null,
          scrapedSource: string | null,
          scrapedUrl: string | null,
          startSalaryRangeThousands: number | null,
          status: JobStatus | null,
          stripeId: string | null,
          tags: Array< JobTag | null > | null,
          timezonePolicy: TimezonePolicy | null,
          wageIsHourly: boolean | null,
          willSponsor: boolean | null,
          workFromAnywhere: boolean | null,
        } | null,
        applicant:  {
          __typename: "JobSeeker",
          id: string,
          userId: string | null,
          firstName: string | null,
          lastName: string | null,
          newGradOrStudent: boolean | null,
          linkedin: string | null,
          website: string | null,
          currentCompany: string | null,
          currentTitle: string | null,
          fullTime: boolean | null,
          partTime: boolean | null,
          contractor: boolean | null,
          fullRemote: boolean | null,
          hybridRemote: boolean | null,
          remoteOptional: boolean | null,
          desiredRole: string | null,
          recommendedJobsEmail: boolean | null,
          newsletterEmail: boolean | null,
          visibleToEmployers: boolean | null,
          emailAddress: string | null,
          phone: string | null,
          phoneVerified: boolean | null,
          profilePic: string | null,
          experienceLevel: ExperienceLevel | null,
          preferencesComplete: boolean | null,
          profileComplete: boolean | null,
          dateCreated: string | null,
          dateModified: string | null,
          deleted: boolean | null,
        } | null,
        proof: string | null,
        isAuto: boolean | null,
        formScreenshot: string | null,
        confirmationScreenshot: string | null,
        generatedResumeUrl: string | null,
        applicationAnswers:  {
          __typename: "ApplicationAnswers",
          id: string,
          applicationId: string,
          jobSeekerId: string,
          jobId: string,
          dateCreated: string | null,
          dateModified: string | null,
        } | null,
        resumeS3Params:  {
          __typename: "ResumeS3Params",
          bucket: string | null,
          key: string | null,
        } | null,
        dateApplied: string | null,
        dateAppliedIndex: string | null,
        dateUpdated: string | null,
      },
      cursor:  {
        __typename: "ApplicationJobIdCursor",
        id: string,
        jobId: string,
      },
    } >,
    pageInfo:  {
      __typename: "ApplicationJobIdPageInfo",
      startCursor:  {
        __typename: "ApplicationJobIdCursor",
        id: string,
        jobId: string,
      } | null,
      endCursor:  {
        __typename: "ApplicationJobIdCursor",
        id: string,
        jobId: string,
      } | null,
      hasNextPage: boolean,
      hasPreviousPage: boolean,
    },
  },
};

export type GetNotificationsByUserIdQueryVariables = {
  userId?: string | null,
  first?: number | null,
  after?: NotificationCursorInput | null,
  last?: number | null,
  before?: NotificationCursorInput | null,
};

export type GetNotificationsByUserIdQuery = {
  getNotificationsByUserId:  {
    __typename: "NotificationConnection",
    edges:  Array< {
      __typename: "NotificationEdge",
      node:  {
        __typename: "Notification",
        id: string,
        notificationType: NotificationType | null,
        message: string | null,
        textMessage: string | null,
        userId: string,
        url: string | null,
        read: boolean | null,
        dateCreated: string | null,
        dateRead: string | null,
      },
      cursor:  {
        __typename: "NotificationCursor",
        id: string,
        userId: string,
        dateCreated: string | null,
      },
    } >,
    pageInfo:  {
      __typename: "PageInfo",
      startCursor:  {
        __typename: "NotificationCursor",
        id: string,
        userId: string,
        dateCreated: string | null,
      } | null,
      endCursor:  {
        __typename: "NotificationCursor",
        id: string,
        userId: string,
        dateCreated: string | null,
      } | null,
      hasNextPage: boolean,
      hasPreviousPage: boolean,
    },
  },
};

export type GetApplicationCountsForJobSeekerIdQueryVariables = {
  jobSeekerId?: string | null,
};

export type GetApplicationCountsForJobSeekerIdQuery = {
  getApplicationCountsForJobSeekerId:  {
    __typename: "ApplicationCountResponse",
    pendingCount: number | null,
    acceptedCount: number | null,
    declinedCount: number | null,
    reviewCount: number | null,
    failedCount: number | null,
    jobId: string | null,
  } | null,
};

export type GetApplicationCountsForJobIdQueryVariables = {
  jobId?: string | null,
};

export type GetApplicationCountsForJobIdQuery = {
  getApplicationCountsForJobId:  {
    __typename: "ApplicationCountResponse",
    pendingCount: number | null,
    acceptedCount: number | null,
    declinedCount: number | null,
    reviewCount: number | null,
    failedCount: number | null,
    jobId: string | null,
  } | null,
};

export type GetCompanyProfileByCompanyIdQueryVariables = {
  companyId?: string | null,
};

export type GetCompanyProfileByCompanyIdQuery = {
  getCompanyProfileByCompanyId:  {
    __typename: "EmployerProfile",
    industries: Array< string | null > | null,
    remotePolicy: Policy | null,
    name: string | null,
    bio: string | null,
    hasHeadquarters: boolean | null,
    hqAddress:  {
      __typename: "CityLocation",
      formatted_address: string,
      coordinate:  {
        __typename: "Location",
        lat: number,
        lon: number,
      },
    } | null,
    emailAddress: string | null,
    phoneNumber: string | null,
    image: string | null,
  } | null,
};

export type GetFeaturedJobsQueryVariables = {
  first?: number | null,
  after?: JobCursorInput | null,
  last?: number | null,
  before?: JobCursorInput | null,
  includePaused?: boolean | null,
  department?: string | null,
  tag?: JobTag | null,
};

export type GetFeaturedJobsQuery = {
  getFeaturedJobs:  {
    __typename: "LiveJobConnection",
    edges:  Array< {
      __typename: "LiveJobEdge",
      node:  {
        __typename: "Job",
        aboutUs: string,
        applications:  Array< {
          __typename: "Application",
          id: string,
          jobId: string,
          jobSeekerId: string,
          applicationStatus: ApplicationStatus | null,
          coverLetter: string | null,
          proof: string | null,
          isAuto: boolean | null,
          formScreenshot: string | null,
          confirmationScreenshot: string | null,
          generatedResumeUrl: string | null,
          dateApplied: string | null,
          dateAppliedIndex: string | null,
          dateUpdated: string | null,
        } | null > | null,
        applicationQuestions:  {
          __typename: "ApplicationQuestions",
          id: string,
          jobId: string,
        } | null,
        companyId: string,
        communications:  {
          __typename: "CommunicationInfo",
          emails: Array< string | null > | null,
          phone: string | null,
        } | null,
        companyProfile:  {
          __typename: "EmployerProfile",
          industries: Array< string | null > | null,
          remotePolicy: Policy | null,
          name: string | null,
          bio: string | null,
          hasHeadquarters: boolean | null,
          emailAddress: string | null,
          phoneNumber: string | null,
          image: string | null,
        } | null,
        companyWebsite: string | null,
        companyName: string,
        dateCreated: string | null,
        dateModified: string | null,
        datePosted: string | null,
        deleted: boolean | null,
        department: string,
        description: string,
        digitalNomadFriendly: boolean | null,
        elite: boolean | null,
        endSalaryRangeThousands: number | null,
        experience: ExperienceLevel,
        featured: boolean | null,
        featuredRank: number | null,
        flexibleHours: boolean | null,
        id: string,
        jobLogo: string | null,
        jobTitle: string,
        officeFrequency:  {
          __typename: "OfficeFrequency",
          daysPerMonth: number | null,
          daysPerWeek: number | null,
        } | null,
        officeLocations:  Array< {
          __typename: "CityLocation",
          formatted_address: string,
        } | null > | null,
        paymentHistory:  Array< {
          __typename: "PaymentRecord",
          stripeId: string,
          productId: string,
          paymentPlan: PaymentPlan,
          dateCreated: string,
          dateEnded: string | null,
        } | null > | null,
        paymentPlan: PaymentPlan | null,
        remoteFirst: boolean | null,
        remotePolicy: JobPolicy | null,
        roleType: WorkType,
        scraped: boolean | null,
        scrapedSource: string | null,
        scrapedUrl: string | null,
        startSalaryRangeThousands: number | null,
        status: JobStatus | null,
        stripeId: string | null,
        tags: Array< JobTag | null > | null,
        timezonePolicy: TimezonePolicy | null,
        timezoneRanges:  Array< {
          __typename: "TimezoneRange",
          start: number | null,
          end: number | null,
        } | null > | null,
        wageIsHourly: boolean | null,
        willSponsor: boolean | null,
        workFromAnywhere: boolean | null,
      },
      cursor:  {
        __typename: "JobCursor",
        id: string,
        companyId: string | null,
      },
    } >,
    pageInfo:  {
      __typename: "LiveJobPageInfo",
      startCursor:  {
        __typename: "JobCursor",
        id: string,
        companyId: string | null,
      } | null,
      endCursor:  {
        __typename: "JobCursor",
        id: string,
        companyId: string | null,
      } | null,
      hasNextPage: boolean,
      hasPreviousPage: boolean,
    },
  },
};

export type GetLiveJobCountQuery = {
  getLiveJobCount: number | null,
};

export type GetFeaturedJobCountQuery = {
  getFeaturedJobCount: number | null,
};

export type GetCompanyCountQuery = {
  getCompanyCount: number | null,
};

export type GetCompaniesQueryVariables = {
  searchText?: string | null,
  first?: number | null,
  after?: CompanyCursorInput | null,
  last?: number | null,
  before?: CompanyCursorInput | null,
};

export type GetCompaniesQuery = {
  getCompanies:  {
    __typename: "CompanyConnection",
    edges:  Array< {
      __typename: "CompanyEdge",
      node:  {
        __typename: "Company",
        id: string,
        dateCreated: string,
        dateModified: string,
        ownerId: string,
        ownerEmail: string,
        profile:  {
          __typename: "EmployerProfile",
          industries: Array< string | null > | null,
          remotePolicy: Policy | null,
          name: string | null,
          bio: string | null,
          hasHeadquarters: boolean | null,
          emailAddress: string | null,
          phoneNumber: string | null,
          image: string | null,
        } | null,
        publicProfile:  {
          __typename: "CompanyProfile",
          id: string,
          builtId: string | null,
          companyAlias: string | null,
          readableName: string | null,
          description: string,
          headCount: string | null,
          website: string | null,
          careerPage: string | null,
          stage: Stage | null,
          isPublic: boolean | null,
          headquarters: string | null,
          valueMillions: number | null,
          isUnicorn: boolean | null,
          isRemoteFirst: boolean | null,
          isHybrid: boolean | null,
          isMixed: boolean | null,
          workFromAnywhere: boolean | null,
          hasFlexibleHours: boolean | null,
          isMissionDriven: boolean | null,
          linkedinUrl: string | null,
          crunchbaseUrl: string | null,
          glassdoorUrl: string | null,
        } | null,
        jobPostings:  Array< {
          __typename: "Job",
          aboutUs: string,
          companyId: string,
          companyWebsite: string | null,
          companyName: string,
          dateCreated: string | null,
          dateModified: string | null,
          datePosted: string | null,
          deleted: boolean | null,
          department: string,
          description: string,
          digitalNomadFriendly: boolean | null,
          elite: boolean | null,
          endSalaryRangeThousands: number | null,
          experience: ExperienceLevel,
          featured: boolean | null,
          featuredRank: number | null,
          flexibleHours: boolean | null,
          id: string,
          jobLogo: string | null,
          jobTitle: string,
          paymentPlan: PaymentPlan | null,
          remoteFirst: boolean | null,
          remotePolicy: JobPolicy | null,
          roleType: WorkType,
          scraped: boolean | null,
          scrapedSource: string | null,
          scrapedUrl: string | null,
          startSalaryRangeThousands: number | null,
          status: JobStatus | null,
          stripeId: string | null,
          tags: Array< JobTag | null > | null,
          timezonePolicy: TimezonePolicy | null,
          wageIsHourly: boolean | null,
          willSponsor: boolean | null,
          workFromAnywhere: boolean | null,
        } | null > | null,
        signupPromo: string | null,
        website: string | null,
        deleted: boolean | null,
      },
      cursor:  {
        __typename: "CompanyCursor",
        id: string,
        companyName: string | null,
      },
    } >,
    pageInfo:  {
      __typename: "CompanyPageInfo",
      startCursor:  {
        __typename: "CompanyCursor",
        id: string,
        companyName: string | null,
      } | null,
      endCursor:  {
        __typename: "CompanyCursor",
        id: string,
        companyName: string | null,
      } | null,
      hasNextPage: boolean,
      hasPreviousPage: boolean,
    },
  },
};

export type GetLiveJobsQueryVariables = {
  first?: number | null,
  after?: JobCursorInput | null,
  last?: number | null,
  before?: JobCursorInput | null,
};

export type GetLiveJobsQuery = {
  getLiveJobs:  {
    __typename: "LiveJobConnection",
    edges:  Array< {
      __typename: "LiveJobEdge",
      node:  {
        __typename: "Job",
        aboutUs: string,
        applications:  Array< {
          __typename: "Application",
          id: string,
          jobId: string,
          jobSeekerId: string,
          applicationStatus: ApplicationStatus | null,
          coverLetter: string | null,
          proof: string | null,
          isAuto: boolean | null,
          formScreenshot: string | null,
          confirmationScreenshot: string | null,
          generatedResumeUrl: string | null,
          dateApplied: string | null,
          dateAppliedIndex: string | null,
          dateUpdated: string | null,
        } | null > | null,
        applicationQuestions:  {
          __typename: "ApplicationQuestions",
          id: string,
          jobId: string,
        } | null,
        companyId: string,
        communications:  {
          __typename: "CommunicationInfo",
          emails: Array< string | null > | null,
          phone: string | null,
        } | null,
        companyProfile:  {
          __typename: "EmployerProfile",
          industries: Array< string | null > | null,
          remotePolicy: Policy | null,
          name: string | null,
          bio: string | null,
          hasHeadquarters: boolean | null,
          emailAddress: string | null,
          phoneNumber: string | null,
          image: string | null,
        } | null,
        companyWebsite: string | null,
        companyName: string,
        dateCreated: string | null,
        dateModified: string | null,
        datePosted: string | null,
        deleted: boolean | null,
        department: string,
        description: string,
        digitalNomadFriendly: boolean | null,
        elite: boolean | null,
        endSalaryRangeThousands: number | null,
        experience: ExperienceLevel,
        featured: boolean | null,
        featuredRank: number | null,
        flexibleHours: boolean | null,
        id: string,
        jobLogo: string | null,
        jobTitle: string,
        officeFrequency:  {
          __typename: "OfficeFrequency",
          daysPerMonth: number | null,
          daysPerWeek: number | null,
        } | null,
        officeLocations:  Array< {
          __typename: "CityLocation",
          formatted_address: string,
        } | null > | null,
        paymentHistory:  Array< {
          __typename: "PaymentRecord",
          stripeId: string,
          productId: string,
          paymentPlan: PaymentPlan,
          dateCreated: string,
          dateEnded: string | null,
        } | null > | null,
        paymentPlan: PaymentPlan | null,
        remoteFirst: boolean | null,
        remotePolicy: JobPolicy | null,
        roleType: WorkType,
        scraped: boolean | null,
        scrapedSource: string | null,
        scrapedUrl: string | null,
        startSalaryRangeThousands: number | null,
        status: JobStatus | null,
        stripeId: string | null,
        tags: Array< JobTag | null > | null,
        timezonePolicy: TimezonePolicy | null,
        timezoneRanges:  Array< {
          __typename: "TimezoneRange",
          start: number | null,
          end: number | null,
        } | null > | null,
        wageIsHourly: boolean | null,
        willSponsor: boolean | null,
        workFromAnywhere: boolean | null,
      },
      cursor:  {
        __typename: "JobCursor",
        id: string,
        companyId: string | null,
      },
    } >,
    pageInfo:  {
      __typename: "LiveJobPageInfo",
      startCursor:  {
        __typename: "JobCursor",
        id: string,
        companyId: string | null,
      } | null,
      endCursor:  {
        __typename: "JobCursor",
        id: string,
        companyId: string | null,
      } | null,
      hasNextPage: boolean,
      hasPreviousPage: boolean,
    },
  } | null,
};

export type GetAllJobSeekersQueryVariables = {
  first?: number | null,
  after?: JobSeekerCursorInput | null,
  last?: number | null,
  before?: JobSeekerCursorInput | null,
};

export type GetAllJobSeekersQuery = {
  getAllJobSeekers:  {
    __typename: "JobSeekerConnection",
    edges:  Array< {
      __typename: "JobSeekerEdge",
      node:  {
        __typename: "JobSeeker",
        id: string,
        userId: string | null,
        firstName: string | null,
        lastName: string | null,
        city:  {
          __typename: "CityLocation",
          formatted_address: string,
        } | null,
        newGradOrStudent: boolean | null,
        linkedin: string | null,
        website: string | null,
        currentCompany: string | null,
        currentTitle: string | null,
        fullTime: boolean | null,
        partTime: boolean | null,
        contractor: boolean | null,
        fullRemote: boolean | null,
        hybridRemote: boolean | null,
        remoteOptional: boolean | null,
        desiredRole: string | null,
        salaryRequirement:  {
          __typename: "Salary",
          currencyCode: string | null,
          value: number | null,
        } | null,
        authorization:  {
          __typename: "WorkAuthorization",
          usAuthorized: boolean | null,
          requireSponsorshipUS: boolean | null,
        } | null,
        recommendedJobsEmail: boolean | null,
        newsletterEmail: boolean | null,
        notificationSettings:  {
          __typename: "NotificationSettings",
          reviewsProfile: NotificationSetting | null,
        } | null,
        visibleToEmployers: boolean | null,
        emailAddress: string | null,
        phone: string | null,
        phoneVerified: boolean | null,
        profilePic: string | null,
        experienceLevel: ExperienceLevel | null,
        workHistory:  Array< {
          __typename: "WorkHistory",
          company: string,
          title: string,
          startDate: string,
          endDate: string | null,
          currentJob: boolean,
          description: string | null,
        } | null > | null,
        educationHistory:  Array< {
          __typename: "EducationHistory",
          institution: string,
          certification: string,
          concentration: string | null,
          dateStarted: string,
          dateCompleted: string | null,
          inProgress: boolean | null,
          description: string | null,
        } | null > | null,
        applications:  Array< {
          __typename: "Application",
          id: string,
          jobId: string,
          jobSeekerId: string,
          applicationStatus: ApplicationStatus | null,
          coverLetter: string | null,
          proof: string | null,
          isAuto: boolean | null,
          formScreenshot: string | null,
          confirmationScreenshot: string | null,
          generatedResumeUrl: string | null,
          dateApplied: string | null,
          dateAppliedIndex: string | null,
          dateUpdated: string | null,
        } | null > | null,
        resume:  {
          __typename: "Resume",
          id: string,
          name: string,
          fileType: string,
          size: string,
          url: string,
          resumeJSON: string | null,
          jobSeekerId: string | null,
          dateUploaded: string,
          dateCreated: string,
          deleted: boolean | null,
        } | null,
        autoResumes:  Array< {
          __typename: "Resume",
          id: string,
          name: string,
          fileType: string,
          size: string,
          url: string,
          resumeJSON: string | null,
          jobSeekerId: string | null,
          dateUploaded: string,
          dateCreated: string,
          deleted: boolean | null,
        } | null > | null,
        preferencesComplete: boolean | null,
        profileComplete: boolean | null,
        autoApply:  Array< {
          __typename: "AutoApply",
          id: string | null,
          jobSeekerId: string | null,
          subId: string | null,
          userId: string | null,
          autoGenerateCoverLetter: boolean | null,
          autoGenerateCoverLetterTone: string | null,
          autoGenerateCoverLetterGreeting: string | null,
          autoGenerateCoverLetterSignOff: string | null,
          autoGenerateCoverLetterInstructions: string | null,
          openToRelocation: boolean | null,
          languagesSpoken: Array< string | null > | null,
          age: number | null,
          genderIdentity: string | null,
          blockedCompanyList: Array< string | null > | null,
          resumeText: string | null,
          coverLetter: string | null,
          aiGenerateCoverLetter: boolean | null,
          coverLetterTone: string | null,
          draft: boolean | null,
          email: string | null,
          isActive: string | null,
          firstName: string | null,
          lastName: string | null,
          remote: boolean | null,
          hybrid: boolean | null,
          onsite: boolean | null,
          jobTitles: Array< string | null > | null,
          negativeJobTitles: Array< string | null > | null,
          industries: Array< string | null > | null,
          experienceLevels: Array< ExperienceLevel | null > | null,
          excludeCompanyNames: Array< string | null > | null,
          expiresAt: string | null,
          subscribedOn: string | null,
          plan: AutoApplySub | null,
          applicationCount: number | null,
          paymentFailed: boolean | null,
          country: string | null,
          region: string | null,
          area: string | null,
          customPreference: Array< string | null > | null,
          appliedUrls: Array< string | null > | null,
          salaryMin: number | null,
          salaryMax: number | null,
          salaryRange: string | null,
          searchTags: Array< string | null > | null,
          prompt: string | null,
          phone: string | null,
          address: string | null,
          currentCompany: string | null,
          linkedinProfile: string | null,
          githubProfile: string | null,
          website: string | null,
          gender: string | null,
          pronouns: string | null,
          hispanic: boolean | null,
          race: string | null,
          paused: boolean | null,
          disabled: boolean | null,
          veteran: boolean | null,
          secretClearance: boolean | null,
          appCountToday: number | null,
          appCountDateUpdated: string | null,
          maxPerDay: number | null,
          maxPerCo: number | null,
          hourToRun: number | null,
          minuteToRun: number | null,
          resumeUrl: string | null,
          resumeName: string | null,
          trial: boolean | null,
          trialExpired: boolean | null,
          gsiConstant: string | null,
          dateCreated: string | null,
          cancelled: boolean | null,
          searchCustomInstructions: string | null,
        } | null > | null,
        dateCreated: string | null,
        dateModified: string | null,
        deleted: boolean | null,
      },
      cursor:  {
        __typename: "JobSeekerCursor",
        id: string,
        userId: string | null,
      },
    } >,
    pageInfo:  {
      __typename: "JobSeekerPageInfo",
      startCursor:  {
        __typename: "JobSeekerCursor",
        id: string,
        userId: string | null,
      } | null,
      endCursor:  {
        __typename: "JobSeekerCursor",
        id: string,
        userId: string | null,
      } | null,
      hasNextPage: boolean,
      hasPreviousPage: boolean,
    } | null,
  } | null,
};

export type GetAutoApplyUsersQueryVariables = {
  first?: number | null,
  after?: AutoCursorInput | null,
  last?: number | null,
  before?: AutoCursorInput | null,
};

export type GetAutoApplyUsersQuery = {
  getAutoApplyUsers:  {
    __typename: "AutoConnection",
    edges:  Array< {
      __typename: "AutoEdge",
      node:  {
        __typename: "AutoApply",
        id: string | null,
        jobSeekerId: string | null,
        subId: string | null,
        userId: string | null,
        autoGenerateCoverLetter: boolean | null,
        autoGenerateCoverLetterTone: string | null,
        autoGenerateCoverLetterGreeting: string | null,
        autoGenerateCoverLetterSignOff: string | null,
        autoGenerateCoverLetterInstructions: string | null,
        customResumeOptions:  {
          __typename: "ResumeCustomizationOptions",
          shouldCustomize: boolean | null,
          customInstructions: string | null,
        } | null,
        openToRelocation: boolean | null,
        languagesSpoken: Array< string | null > | null,
        age: number | null,
        references:  Array< {
          __typename: "Reference",
          name: string | null,
          email: string | null,
          phone: string | null,
          relationship: string | null,
        } | null > | null,
        genderIdentity: string | null,
        blockedCompanyList: Array< string | null > | null,
        resumeText: string | null,
        coverLetter: string | null,
        aiGenerateCoverLetter: boolean | null,
        coverLetterTone: string | null,
        draft: boolean | null,
        email: string | null,
        isActive: string | null,
        firstName: string | null,
        lastName: string | null,
        remote: boolean | null,
        hybrid: boolean | null,
        onsite: boolean | null,
        jobTitles: Array< string | null > | null,
        negativeJobTitles: Array< string | null > | null,
        industries: Array< string | null > | null,
        education:  {
          __typename: "EducationHistory",
          institution: string,
          certification: string,
          concentration: string | null,
          dateStarted: string,
          dateCompleted: string | null,
          inProgress: boolean | null,
          description: string | null,
        } | null,
        educationHistory:  Array< {
          __typename: "EducationHistory",
          institution: string,
          certification: string,
          concentration: string | null,
          dateStarted: string,
          dateCompleted: string | null,
          inProgress: boolean | null,
          description: string | null,
        } | null > | null,
        experienceLevels: Array< ExperienceLevel | null > | null,
        excludeCompanyNames: Array< string | null > | null,
        expiresAt: string | null,
        subscribedOn: string | null,
        plan: AutoApplySub | null,
        applicationCount: number | null,
        paymentFailed: boolean | null,
        autoLocations:  Array< {
          __typename: "AutoLocation",
          country: string | null,
          region: string | null,
          area: string | null,
        } | null > | null,
        location:  {
          __typename: "CityLocation",
          formatted_address: string,
        } | null,
        country: string | null,
        region: string | null,
        area: string | null,
        customPreference: Array< string | null > | null,
        appliedUrls: Array< string | null > | null,
        salaryMin: number | null,
        salaryMax: number | null,
        salaryRange: string | null,
        searchTags: Array< string | null > | null,
        prompt: string | null,
        phone: string | null,
        address: string | null,
        currentCompany: string | null,
        linkedinProfile: string | null,
        githubProfile: string | null,
        website: string | null,
        gender: string | null,
        pronouns: string | null,
        hispanic: boolean | null,
        race: string | null,
        paused: boolean | null,
        disabled: boolean | null,
        veteran: boolean | null,
        countryAuthorization:  Array< {
          __typename: "CountryAuthorization",
          countryAuthorization: string | null,
          authorizationType: string | null,
          requiresSponsorship: boolean | null,
        } | null > | null,
        secretClearance: boolean | null,
        appCountToday: number | null,
        appCountDateUpdated: string | null,
        maxPerDay: number | null,
        maxPerCo: number | null,
        hourToRun: number | null,
        minuteToRun: number | null,
        resumeUrl: string | null,
        resumeName: string | null,
        trial: boolean | null,
        trialExpired: boolean | null,
        gsiConstant: string | null,
        dateCreated: string | null,
        cancelled: boolean | null,
        searchCustomInstructions: string | null,
      },
      cursor:  {
        __typename: "AutoCursor",
        id: string,
        dateCreated: string | null,
      },
    } >,
    pageInfo:  {
      __typename: "AutoPageInfo",
      startCursor:  {
        __typename: "AutoCursor",
        id: string,
        dateCreated: string | null,
      } | null,
      endCursor:  {
        __typename: "AutoCursor",
        id: string,
        dateCreated: string | null,
      } | null,
      hasNextPage: boolean,
      hasPreviousPage: boolean,
    } | null,
  } | null,
};

export type GetJobSeekerByIdQueryVariables = {
  id?: string | null,
};

export type GetJobSeekerByIdQuery = {
  getJobSeekerById:  {
    __typename: "JobSeeker",
    id: string,
    userId: string | null,
    firstName: string | null,
    lastName: string | null,
    city:  {
      __typename: "CityLocation",
      formatted_address: string,
      coordinate:  {
        __typename: "Location",
        lat: number,
        lon: number,
      },
    } | null,
    newGradOrStudent: boolean | null,
    linkedin: string | null,
    website: string | null,
    currentCompany: string | null,
    currentTitle: string | null,
    fullTime: boolean | null,
    partTime: boolean | null,
    contractor: boolean | null,
    fullRemote: boolean | null,
    hybridRemote: boolean | null,
    remoteOptional: boolean | null,
    desiredRole: string | null,
    salaryRequirement:  {
      __typename: "Salary",
      currencyCode: string | null,
      value: number | null,
    } | null,
    authorization:  {
      __typename: "WorkAuthorization",
      usAuthorized: boolean | null,
      requireSponsorshipUS: boolean | null,
    } | null,
    recommendedJobsEmail: boolean | null,
    newsletterEmail: boolean | null,
    notificationSettings:  {
      __typename: "NotificationSettings",
      reviewsProfile: NotificationSetting | null,
    } | null,
    visibleToEmployers: boolean | null,
    emailAddress: string | null,
    phone: string | null,
    phoneVerified: boolean | null,
    profilePic: string | null,
    experienceLevel: ExperienceLevel | null,
    workHistory:  Array< {
      __typename: "WorkHistory",
      company: string,
      title: string,
      startDate: string,
      endDate: string | null,
      currentJob: boolean,
      description: string | null,
    } | null > | null,
    educationHistory:  Array< {
      __typename: "EducationHistory",
      institution: string,
      certification: string,
      concentration: string | null,
      dateStarted: string,
      dateCompleted: string | null,
      inProgress: boolean | null,
      description: string | null,
    } | null > | null,
    applications:  Array< {
      __typename: "Application",
      id: string,
      jobId: string,
      jobSeekerId: string,
      applicationStatus: ApplicationStatus | null,
      coverLetter: string | null,
      job:  {
        __typename: "Job",
        aboutUs: string,
        applications:  Array< {
          __typename: "Application",
          id: string,
          jobId: string,
          jobSeekerId: string,
          applicationStatus: ApplicationStatus | null,
          coverLetter: string | null,
          proof: string | null,
          isAuto: boolean | null,
          formScreenshot: string | null,
          confirmationScreenshot: string | null,
          generatedResumeUrl: string | null,
          dateApplied: string | null,
          dateAppliedIndex: string | null,
          dateUpdated: string | null,
        } | null > | null,
        applicationQuestions:  {
          __typename: "ApplicationQuestions",
          id: string,
          jobId: string,
        } | null,
        companyId: string,
        communications:  {
          __typename: "CommunicationInfo",
          emails: Array< string | null > | null,
          phone: string | null,
        } | null,
        companyProfile:  {
          __typename: "EmployerProfile",
          industries: Array< string | null > | null,
          remotePolicy: Policy | null,
          name: string | null,
          bio: string | null,
          hasHeadquarters: boolean | null,
          emailAddress: string | null,
          phoneNumber: string | null,
          image: string | null,
        } | null,
        companyWebsite: string | null,
        companyName: string,
        dateCreated: string | null,
        dateModified: string | null,
        datePosted: string | null,
        deleted: boolean | null,
        department: string,
        description: string,
        digitalNomadFriendly: boolean | null,
        elite: boolean | null,
        endSalaryRangeThousands: number | null,
        experience: ExperienceLevel,
        featured: boolean | null,
        featuredRank: number | null,
        flexibleHours: boolean | null,
        id: string,
        jobLogo: string | null,
        jobTitle: string,
        officeFrequency:  {
          __typename: "OfficeFrequency",
          daysPerMonth: number | null,
          daysPerWeek: number | null,
        } | null,
        officeLocations:  Array< {
          __typename: "CityLocation",
          formatted_address: string,
        } | null > | null,
        paymentHistory:  Array< {
          __typename: "PaymentRecord",
          stripeId: string,
          productId: string,
          paymentPlan: PaymentPlan,
          dateCreated: string,
          dateEnded: string | null,
        } | null > | null,
        paymentPlan: PaymentPlan | null,
        remoteFirst: boolean | null,
        remotePolicy: JobPolicy | null,
        roleType: WorkType,
        scraped: boolean | null,
        scrapedSource: string | null,
        scrapedUrl: string | null,
        startSalaryRangeThousands: number | null,
        status: JobStatus | null,
        stripeId: string | null,
        tags: Array< JobTag | null > | null,
        timezonePolicy: TimezonePolicy | null,
        timezoneRanges:  Array< {
          __typename: "TimezoneRange",
          start: number | null,
          end: number | null,
        } | null > | null,
        wageIsHourly: boolean | null,
        willSponsor: boolean | null,
        workFromAnywhere: boolean | null,
      } | null,
      applicant:  {
        __typename: "JobSeeker",
        id: string,
        userId: string | null,
        firstName: string | null,
        lastName: string | null,
        city:  {
          __typename: "CityLocation",
          formatted_address: string,
        } | null,
        newGradOrStudent: boolean | null,
        linkedin: string | null,
        website: string | null,
        currentCompany: string | null,
        currentTitle: string | null,
        fullTime: boolean | null,
        partTime: boolean | null,
        contractor: boolean | null,
        fullRemote: boolean | null,
        hybridRemote: boolean | null,
        remoteOptional: boolean | null,
        desiredRole: string | null,
        salaryRequirement:  {
          __typename: "Salary",
          currencyCode: string | null,
          value: number | null,
        } | null,
        authorization:  {
          __typename: "WorkAuthorization",
          usAuthorized: boolean | null,
          requireSponsorshipUS: boolean | null,
        } | null,
        recommendedJobsEmail: boolean | null,
        newsletterEmail: boolean | null,
        notificationSettings:  {
          __typename: "NotificationSettings",
          reviewsProfile: NotificationSetting | null,
        } | null,
        visibleToEmployers: boolean | null,
        emailAddress: string | null,
        phone: string | null,
        phoneVerified: boolean | null,
        profilePic: string | null,
        experienceLevel: ExperienceLevel | null,
        workHistory:  Array< {
          __typename: "WorkHistory",
          company: string,
          title: string,
          startDate: string,
          endDate: string | null,
          currentJob: boolean,
          description: string | null,
        } | null > | null,
        educationHistory:  Array< {
          __typename: "EducationHistory",
          institution: string,
          certification: string,
          concentration: string | null,
          dateStarted: string,
          dateCompleted: string | null,
          inProgress: boolean | null,
          description: string | null,
        } | null > | null,
        applications:  Array< {
          __typename: "Application",
          id: string,
          jobId: string,
          jobSeekerId: string,
          applicationStatus: ApplicationStatus | null,
          coverLetter: string | null,
          proof: string | null,
          isAuto: boolean | null,
          formScreenshot: string | null,
          confirmationScreenshot: string | null,
          generatedResumeUrl: string | null,
          dateApplied: string | null,
          dateAppliedIndex: string | null,
          dateUpdated: string | null,
        } | null > | null,
        resume:  {
          __typename: "Resume",
          id: string,
          name: string,
          fileType: string,
          size: string,
          url: string,
          resumeJSON: string | null,
          jobSeekerId: string | null,
          dateUploaded: string,
          dateCreated: string,
          deleted: boolean | null,
        } | null,
        autoResumes:  Array< {
          __typename: "Resume",
          id: string,
          name: string,
          fileType: string,
          size: string,
          url: string,
          resumeJSON: string | null,
          jobSeekerId: string | null,
          dateUploaded: string,
          dateCreated: string,
          deleted: boolean | null,
        } | null > | null,
        preferencesComplete: boolean | null,
        profileComplete: boolean | null,
        autoApply:  Array< {
          __typename: "AutoApply",
          id: string | null,
          jobSeekerId: string | null,
          subId: string | null,
          userId: string | null,
          autoGenerateCoverLetter: boolean | null,
          autoGenerateCoverLetterTone: string | null,
          autoGenerateCoverLetterGreeting: string | null,
          autoGenerateCoverLetterSignOff: string | null,
          autoGenerateCoverLetterInstructions: string | null,
          openToRelocation: boolean | null,
          languagesSpoken: Array< string | null > | null,
          age: number | null,
          genderIdentity: string | null,
          blockedCompanyList: Array< string | null > | null,
          resumeText: string | null,
          coverLetter: string | null,
          aiGenerateCoverLetter: boolean | null,
          coverLetterTone: string | null,
          draft: boolean | null,
          email: string | null,
          isActive: string | null,
          firstName: string | null,
          lastName: string | null,
          remote: boolean | null,
          hybrid: boolean | null,
          onsite: boolean | null,
          jobTitles: Array< string | null > | null,
          negativeJobTitles: Array< string | null > | null,
          industries: Array< string | null > | null,
          experienceLevels: Array< ExperienceLevel | null > | null,
          excludeCompanyNames: Array< string | null > | null,
          expiresAt: string | null,
          subscribedOn: string | null,
          plan: AutoApplySub | null,
          applicationCount: number | null,
          paymentFailed: boolean | null,
          country: string | null,
          region: string | null,
          area: string | null,
          customPreference: Array< string | null > | null,
          appliedUrls: Array< string | null > | null,
          salaryMin: number | null,
          salaryMax: number | null,
          salaryRange: string | null,
          searchTags: Array< string | null > | null,
          prompt: string | null,
          phone: string | null,
          address: string | null,
          currentCompany: string | null,
          linkedinProfile: string | null,
          githubProfile: string | null,
          website: string | null,
          gender: string | null,
          pronouns: string | null,
          hispanic: boolean | null,
          race: string | null,
          paused: boolean | null,
          disabled: boolean | null,
          veteran: boolean | null,
          secretClearance: boolean | null,
          appCountToday: number | null,
          appCountDateUpdated: string | null,
          maxPerDay: number | null,
          maxPerCo: number | null,
          hourToRun: number | null,
          minuteToRun: number | null,
          resumeUrl: string | null,
          resumeName: string | null,
          trial: boolean | null,
          trialExpired: boolean | null,
          gsiConstant: string | null,
          dateCreated: string | null,
          cancelled: boolean | null,
          searchCustomInstructions: string | null,
        } | null > | null,
        dateCreated: string | null,
        dateModified: string | null,
        deleted: boolean | null,
      } | null,
      proof: string | null,
      isAuto: boolean | null,
      formScreenshot: string | null,
      confirmationScreenshot: string | null,
      generatedResumeUrl: string | null,
      applicationAnswers:  {
        __typename: "ApplicationAnswers",
        id: string,
        applicationId: string,
        jobSeekerId: string,
        jobId: string,
        responses:  Array< {
          __typename: "ApplicationAnswer",
          id: string,
          question: string | null,
          answer: string | null,
          type: ApplicationQuestionType | null,
        } | null > | null,
        dateCreated: string | null,
        dateModified: string | null,
      } | null,
      resumeS3Params:  {
        __typename: "ResumeS3Params",
        bucket: string | null,
        key: string | null,
      } | null,
      dateApplied: string | null,
      dateAppliedIndex: string | null,
      dateUpdated: string | null,
    } | null > | null,
    resume:  {
      __typename: "Resume",
      id: string,
      name: string,
      fileType: string,
      size: string,
      url: string,
      resumeJSON: string | null,
      jobSeekerId: string | null,
      dateUploaded: string,
      dateCreated: string,
      deleted: boolean | null,
    } | null,
    autoResumes:  Array< {
      __typename: "Resume",
      id: string,
      name: string,
      fileType: string,
      size: string,
      url: string,
      resumeJSON: string | null,
      jobSeekerId: string | null,
      dateUploaded: string,
      dateCreated: string,
      deleted: boolean | null,
    } | null > | null,
    preferencesComplete: boolean | null,
    profileComplete: boolean | null,
    autoApply:  Array< {
      __typename: "AutoApply",
      id: string | null,
      jobSeekerId: string | null,
      subId: string | null,
      userId: string | null,
      autoGenerateCoverLetter: boolean | null,
      autoGenerateCoverLetterTone: string | null,
      autoGenerateCoverLetterGreeting: string | null,
      autoGenerateCoverLetterSignOff: string | null,
      autoGenerateCoverLetterInstructions: string | null,
      customResumeOptions:  {
        __typename: "ResumeCustomizationOptions",
        shouldCustomize: boolean | null,
        customInstructions: string | null,
      } | null,
      openToRelocation: boolean | null,
      languagesSpoken: Array< string | null > | null,
      age: number | null,
      references:  Array< {
        __typename: "Reference",
        name: string | null,
        email: string | null,
        phone: string | null,
        relationship: string | null,
      } | null > | null,
      genderIdentity: string | null,
      blockedCompanyList: Array< string | null > | null,
      resumeText: string | null,
      coverLetter: string | null,
      aiGenerateCoverLetter: boolean | null,
      coverLetterTone: string | null,
      draft: boolean | null,
      email: string | null,
      isActive: string | null,
      firstName: string | null,
      lastName: string | null,
      remote: boolean | null,
      hybrid: boolean | null,
      onsite: boolean | null,
      jobTitles: Array< string | null > | null,
      negativeJobTitles: Array< string | null > | null,
      industries: Array< string | null > | null,
      education:  {
        __typename: "EducationHistory",
        institution: string,
        certification: string,
        concentration: string | null,
        dateStarted: string,
        dateCompleted: string | null,
        inProgress: boolean | null,
        description: string | null,
      } | null,
      educationHistory:  Array< {
        __typename: "EducationHistory",
        institution: string,
        certification: string,
        concentration: string | null,
        dateStarted: string,
        dateCompleted: string | null,
        inProgress: boolean | null,
        description: string | null,
      } | null > | null,
      experienceLevels: Array< ExperienceLevel | null > | null,
      excludeCompanyNames: Array< string | null > | null,
      expiresAt: string | null,
      subscribedOn: string | null,
      plan: AutoApplySub | null,
      applicationCount: number | null,
      paymentFailed: boolean | null,
      autoLocations:  Array< {
        __typename: "AutoLocation",
        location:  {
          __typename: "CityLocation",
          formatted_address: string,
        } | null,
        country: string | null,
        region: string | null,
        area: string | null,
      } | null > | null,
      location:  {
        __typename: "CityLocation",
        formatted_address: string,
        coordinate:  {
          __typename: "Location",
          lat: number,
          lon: number,
        },
      } | null,
      country: string | null,
      region: string | null,
      area: string | null,
      customPreference: Array< string | null > | null,
      appliedUrls: Array< string | null > | null,
      salaryMin: number | null,
      salaryMax: number | null,
      salaryRange: string | null,
      searchTags: Array< string | null > | null,
      prompt: string | null,
      phone: string | null,
      address: string | null,
      currentCompany: string | null,
      linkedinProfile: string | null,
      githubProfile: string | null,
      website: string | null,
      gender: string | null,
      pronouns: string | null,
      hispanic: boolean | null,
      race: string | null,
      paused: boolean | null,
      disabled: boolean | null,
      veteran: boolean | null,
      countryAuthorization:  Array< {
        __typename: "CountryAuthorization",
        countryAuthorization: string | null,
        authorizationType: string | null,
        requiresSponsorship: boolean | null,
      } | null > | null,
      secretClearance: boolean | null,
      appCountToday: number | null,
      appCountDateUpdated: string | null,
      maxPerDay: number | null,
      maxPerCo: number | null,
      hourToRun: number | null,
      minuteToRun: number | null,
      resumeUrl: string | null,
      resumeName: string | null,
      trial: boolean | null,
      trialExpired: boolean | null,
      gsiConstant: string | null,
      dateCreated: string | null,
      cancelled: boolean | null,
      searchCustomInstructions: string | null,
    } | null > | null,
    dateCreated: string | null,
    dateModified: string | null,
    deleted: boolean | null,
  } | null,
};

export type GetAutoApplyUsersByEmailQueryVariables = {
  email?: string | null,
};

export type GetAutoApplyUsersByEmailQuery = {
  getAutoApplyUsersByEmail:  Array< {
    __typename: "AutoApply",
    id: string | null,
    jobSeekerId: string | null,
    subId: string | null,
    userId: string | null,
    autoGenerateCoverLetter: boolean | null,
    autoGenerateCoverLetterTone: string | null,
    autoGenerateCoverLetterGreeting: string | null,
    autoGenerateCoverLetterSignOff: string | null,
    autoGenerateCoverLetterInstructions: string | null,
    customResumeOptions:  {
      __typename: "ResumeCustomizationOptions",
      shouldCustomize: boolean | null,
      customInstructions: string | null,
    } | null,
    openToRelocation: boolean | null,
    languagesSpoken: Array< string | null > | null,
    age: number | null,
    references:  Array< {
      __typename: "Reference",
      name: string | null,
      email: string | null,
      phone: string | null,
      relationship: string | null,
    } | null > | null,
    genderIdentity: string | null,
    blockedCompanyList: Array< string | null > | null,
    resumeText: string | null,
    coverLetter: string | null,
    aiGenerateCoverLetter: boolean | null,
    coverLetterTone: string | null,
    draft: boolean | null,
    email: string | null,
    isActive: string | null,
    firstName: string | null,
    lastName: string | null,
    remote: boolean | null,
    hybrid: boolean | null,
    onsite: boolean | null,
    jobTitles: Array< string | null > | null,
    negativeJobTitles: Array< string | null > | null,
    industries: Array< string | null > | null,
    education:  {
      __typename: "EducationHistory",
      institution: string,
      certification: string,
      concentration: string | null,
      dateStarted: string,
      dateCompleted: string | null,
      inProgress: boolean | null,
      description: string | null,
    } | null,
    educationHistory:  Array< {
      __typename: "EducationHistory",
      institution: string,
      certification: string,
      concentration: string | null,
      dateStarted: string,
      dateCompleted: string | null,
      inProgress: boolean | null,
      description: string | null,
    } | null > | null,
    experienceLevels: Array< ExperienceLevel | null > | null,
    excludeCompanyNames: Array< string | null > | null,
    expiresAt: string | null,
    subscribedOn: string | null,
    plan: AutoApplySub | null,
    applicationCount: number | null,
    paymentFailed: boolean | null,
    autoLocations:  Array< {
      __typename: "AutoLocation",
      location:  {
        __typename: "CityLocation",
        formatted_address: string,
        coordinate:  {
          __typename: "Location",
          lat: number,
          lon: number,
        },
      } | null,
      country: string | null,
      region: string | null,
      area: string | null,
    } | null > | null,
    location:  {
      __typename: "CityLocation",
      formatted_address: string,
      coordinate:  {
        __typename: "Location",
        lat: number,
        lon: number,
      },
    } | null,
    country: string | null,
    region: string | null,
    area: string | null,
    customPreference: Array< string | null > | null,
    appliedUrls: Array< string | null > | null,
    salaryMin: number | null,
    salaryMax: number | null,
    salaryRange: string | null,
    searchTags: Array< string | null > | null,
    prompt: string | null,
    phone: string | null,
    address: string | null,
    currentCompany: string | null,
    linkedinProfile: string | null,
    githubProfile: string | null,
    website: string | null,
    gender: string | null,
    pronouns: string | null,
    hispanic: boolean | null,
    race: string | null,
    paused: boolean | null,
    disabled: boolean | null,
    veteran: boolean | null,
    countryAuthorization:  Array< {
      __typename: "CountryAuthorization",
      countryAuthorization: string | null,
      authorizationType: string | null,
      requiresSponsorship: boolean | null,
    } | null > | null,
    secretClearance: boolean | null,
    appCountToday: number | null,
    appCountDateUpdated: string | null,
    maxPerDay: number | null,
    maxPerCo: number | null,
    hourToRun: number | null,
    minuteToRun: number | null,
    resumeUrl: string | null,
    resumeName: string | null,
    trial: boolean | null,
    trialExpired: boolean | null,
    gsiConstant: string | null,
    dateCreated: string | null,
    cancelled: boolean | null,
    searchCustomInstructions: string | null,
  } | null > | null,
};

export type SearchTestsQuery = {
  searchTests:  Array< {
    __typename: "Test",
    id: string,
    name: string,
  } | null > | null,
};

export type AggregateCompaniesByJobBoardQueryVariables = {
  offset?: number | null,
  jobBoard?: string | null,
};

export type AggregateCompaniesByJobBoardQuery = {
  aggregateCompaniesByJobBoard:  Array< {
    __typename: "Job",
    aboutUs: string,
    applications:  Array< {
      __typename: "Application",
      id: string,
      jobId: string,
      jobSeekerId: string,
      applicationStatus: ApplicationStatus | null,
      coverLetter: string | null,
      job:  {
        __typename: "Job",
        aboutUs: string,
        applications:  Array< {
          __typename: "Application",
          id: string,
          jobId: string,
          jobSeekerId: string,
          applicationStatus: ApplicationStatus | null,
          coverLetter: string | null,
          proof: string | null,
          isAuto: boolean | null,
          formScreenshot: string | null,
          confirmationScreenshot: string | null,
          generatedResumeUrl: string | null,
          dateApplied: string | null,
          dateAppliedIndex: string | null,
          dateUpdated: string | null,
        } | null > | null,
        applicationQuestions:  {
          __typename: "ApplicationQuestions",
          id: string,
          jobId: string,
        } | null,
        companyId: string,
        communications:  {
          __typename: "CommunicationInfo",
          emails: Array< string | null > | null,
          phone: string | null,
        } | null,
        companyProfile:  {
          __typename: "EmployerProfile",
          industries: Array< string | null > | null,
          remotePolicy: Policy | null,
          name: string | null,
          bio: string | null,
          hasHeadquarters: boolean | null,
          emailAddress: string | null,
          phoneNumber: string | null,
          image: string | null,
        } | null,
        companyWebsite: string | null,
        companyName: string,
        dateCreated: string | null,
        dateModified: string | null,
        datePosted: string | null,
        deleted: boolean | null,
        department: string,
        description: string,
        digitalNomadFriendly: boolean | null,
        elite: boolean | null,
        endSalaryRangeThousands: number | null,
        experience: ExperienceLevel,
        featured: boolean | null,
        featuredRank: number | null,
        flexibleHours: boolean | null,
        id: string,
        jobLogo: string | null,
        jobTitle: string,
        officeFrequency:  {
          __typename: "OfficeFrequency",
          daysPerMonth: number | null,
          daysPerWeek: number | null,
        } | null,
        officeLocations:  Array< {
          __typename: "CityLocation",
          formatted_address: string,
        } | null > | null,
        paymentHistory:  Array< {
          __typename: "PaymentRecord",
          stripeId: string,
          productId: string,
          paymentPlan: PaymentPlan,
          dateCreated: string,
          dateEnded: string | null,
        } | null > | null,
        paymentPlan: PaymentPlan | null,
        remoteFirst: boolean | null,
        remotePolicy: JobPolicy | null,
        roleType: WorkType,
        scraped: boolean | null,
        scrapedSource: string | null,
        scrapedUrl: string | null,
        startSalaryRangeThousands: number | null,
        status: JobStatus | null,
        stripeId: string | null,
        tags: Array< JobTag | null > | null,
        timezonePolicy: TimezonePolicy | null,
        timezoneRanges:  Array< {
          __typename: "TimezoneRange",
          start: number | null,
          end: number | null,
        } | null > | null,
        wageIsHourly: boolean | null,
        willSponsor: boolean | null,
        workFromAnywhere: boolean | null,
      } | null,
      applicant:  {
        __typename: "JobSeeker",
        id: string,
        userId: string | null,
        firstName: string | null,
        lastName: string | null,
        city:  {
          __typename: "CityLocation",
          formatted_address: string,
        } | null,
        newGradOrStudent: boolean | null,
        linkedin: string | null,
        website: string | null,
        currentCompany: string | null,
        currentTitle: string | null,
        fullTime: boolean | null,
        partTime: boolean | null,
        contractor: boolean | null,
        fullRemote: boolean | null,
        hybridRemote: boolean | null,
        remoteOptional: boolean | null,
        desiredRole: string | null,
        salaryRequirement:  {
          __typename: "Salary",
          currencyCode: string | null,
          value: number | null,
        } | null,
        authorization:  {
          __typename: "WorkAuthorization",
          usAuthorized: boolean | null,
          requireSponsorshipUS: boolean | null,
        } | null,
        recommendedJobsEmail: boolean | null,
        newsletterEmail: boolean | null,
        notificationSettings:  {
          __typename: "NotificationSettings",
          reviewsProfile: NotificationSetting | null,
        } | null,
        visibleToEmployers: boolean | null,
        emailAddress: string | null,
        phone: string | null,
        phoneVerified: boolean | null,
        profilePic: string | null,
        experienceLevel: ExperienceLevel | null,
        workHistory:  Array< {
          __typename: "WorkHistory",
          company: string,
          title: string,
          startDate: string,
          endDate: string | null,
          currentJob: boolean,
          description: string | null,
        } | null > | null,
        educationHistory:  Array< {
          __typename: "EducationHistory",
          institution: string,
          certification: string,
          concentration: string | null,
          dateStarted: string,
          dateCompleted: string | null,
          inProgress: boolean | null,
          description: string | null,
        } | null > | null,
        applications:  Array< {
          __typename: "Application",
          id: string,
          jobId: string,
          jobSeekerId: string,
          applicationStatus: ApplicationStatus | null,
          coverLetter: string | null,
          proof: string | null,
          isAuto: boolean | null,
          formScreenshot: string | null,
          confirmationScreenshot: string | null,
          generatedResumeUrl: string | null,
          dateApplied: string | null,
          dateAppliedIndex: string | null,
          dateUpdated: string | null,
        } | null > | null,
        resume:  {
          __typename: "Resume",
          id: string,
          name: string,
          fileType: string,
          size: string,
          url: string,
          resumeJSON: string | null,
          jobSeekerId: string | null,
          dateUploaded: string,
          dateCreated: string,
          deleted: boolean | null,
        } | null,
        autoResumes:  Array< {
          __typename: "Resume",
          id: string,
          name: string,
          fileType: string,
          size: string,
          url: string,
          resumeJSON: string | null,
          jobSeekerId: string | null,
          dateUploaded: string,
          dateCreated: string,
          deleted: boolean | null,
        } | null > | null,
        preferencesComplete: boolean | null,
        profileComplete: boolean | null,
        autoApply:  Array< {
          __typename: "AutoApply",
          id: string | null,
          jobSeekerId: string | null,
          subId: string | null,
          userId: string | null,
          autoGenerateCoverLetter: boolean | null,
          autoGenerateCoverLetterTone: string | null,
          autoGenerateCoverLetterGreeting: string | null,
          autoGenerateCoverLetterSignOff: string | null,
          autoGenerateCoverLetterInstructions: string | null,
          openToRelocation: boolean | null,
          languagesSpoken: Array< string | null > | null,
          age: number | null,
          genderIdentity: string | null,
          blockedCompanyList: Array< string | null > | null,
          resumeText: string | null,
          coverLetter: string | null,
          aiGenerateCoverLetter: boolean | null,
          coverLetterTone: string | null,
          draft: boolean | null,
          email: string | null,
          isActive: string | null,
          firstName: string | null,
          lastName: string | null,
          remote: boolean | null,
          hybrid: boolean | null,
          onsite: boolean | null,
          jobTitles: Array< string | null > | null,
          negativeJobTitles: Array< string | null > | null,
          industries: Array< string | null > | null,
          experienceLevels: Array< ExperienceLevel | null > | null,
          excludeCompanyNames: Array< string | null > | null,
          expiresAt: string | null,
          subscribedOn: string | null,
          plan: AutoApplySub | null,
          applicationCount: number | null,
          paymentFailed: boolean | null,
          country: string | null,
          region: string | null,
          area: string | null,
          customPreference: Array< string | null > | null,
          appliedUrls: Array< string | null > | null,
          salaryMin: number | null,
          salaryMax: number | null,
          salaryRange: string | null,
          searchTags: Array< string | null > | null,
          prompt: string | null,
          phone: string | null,
          address: string | null,
          currentCompany: string | null,
          linkedinProfile: string | null,
          githubProfile: string | null,
          website: string | null,
          gender: string | null,
          pronouns: string | null,
          hispanic: boolean | null,
          race: string | null,
          paused: boolean | null,
          disabled: boolean | null,
          veteran: boolean | null,
          secretClearance: boolean | null,
          appCountToday: number | null,
          appCountDateUpdated: string | null,
          maxPerDay: number | null,
          maxPerCo: number | null,
          hourToRun: number | null,
          minuteToRun: number | null,
          resumeUrl: string | null,
          resumeName: string | null,
          trial: boolean | null,
          trialExpired: boolean | null,
          gsiConstant: string | null,
          dateCreated: string | null,
          cancelled: boolean | null,
          searchCustomInstructions: string | null,
        } | null > | null,
        dateCreated: string | null,
        dateModified: string | null,
        deleted: boolean | null,
      } | null,
      proof: string | null,
      isAuto: boolean | null,
      formScreenshot: string | null,
      confirmationScreenshot: string | null,
      generatedResumeUrl: string | null,
      applicationAnswers:  {
        __typename: "ApplicationAnswers",
        id: string,
        applicationId: string,
        jobSeekerId: string,
        jobId: string,
        responses:  Array< {
          __typename: "ApplicationAnswer",
          id: string,
          question: string | null,
          answer: string | null,
          type: ApplicationQuestionType | null,
        } | null > | null,
        dateCreated: string | null,
        dateModified: string | null,
      } | null,
      resumeS3Params:  {
        __typename: "ResumeS3Params",
        bucket: string | null,
        key: string | null,
      } | null,
      dateApplied: string | null,
      dateAppliedIndex: string | null,
      dateUpdated: string | null,
    } | null > | null,
    applicationQuestions:  {
      __typename: "ApplicationQuestions",
      id: string,
      jobId: string,
      questions:  Array< {
        __typename: "ApplicationQuestion",
        question: string,
        type: ApplicationQuestionType,
        selector: string,
        options: Array< string | null > | null,
      } | null > | null,
    } | null,
    companyId: string,
    communications:  {
      __typename: "CommunicationInfo",
      emails: Array< string | null > | null,
      phone: string | null,
    } | null,
    companyProfile:  {
      __typename: "EmployerProfile",
      industries: Array< string | null > | null,
      remotePolicy: Policy | null,
      name: string | null,
      bio: string | null,
      hasHeadquarters: boolean | null,
      hqAddress:  {
        __typename: "CityLocation",
        formatted_address: string,
        coordinate:  {
          __typename: "Location",
          lat: number,
          lon: number,
        },
      } | null,
      emailAddress: string | null,
      phoneNumber: string | null,
      image: string | null,
    } | null,
    companyWebsite: string | null,
    companyName: string,
    dateCreated: string | null,
    dateModified: string | null,
    datePosted: string | null,
    deleted: boolean | null,
    department: string,
    description: string,
    digitalNomadFriendly: boolean | null,
    elite: boolean | null,
    endSalaryRangeThousands: number | null,
    experience: ExperienceLevel,
    featured: boolean | null,
    featuredRank: number | null,
    flexibleHours: boolean | null,
    id: string,
    jobLogo: string | null,
    jobTitle: string,
    officeFrequency:  {
      __typename: "OfficeFrequency",
      daysPerMonth: number | null,
      daysPerWeek: number | null,
    } | null,
    officeLocations:  Array< {
      __typename: "CityLocation",
      formatted_address: string,
      coordinate:  {
        __typename: "Location",
        lat: number,
        lon: number,
      },
    } | null > | null,
    paymentHistory:  Array< {
      __typename: "PaymentRecord",
      stripeId: string,
      productId: string,
      paymentPlan: PaymentPlan,
      dateCreated: string,
      dateEnded: string | null,
    } | null > | null,
    paymentPlan: PaymentPlan | null,
    remoteFirst: boolean | null,
    remotePolicy: JobPolicy | null,
    roleType: WorkType,
    scraped: boolean | null,
    scrapedSource: string | null,
    scrapedUrl: string | null,
    startSalaryRangeThousands: number | null,
    status: JobStatus | null,
    stripeId: string | null,
    tags: Array< JobTag | null > | null,
    timezonePolicy: TimezonePolicy | null,
    timezoneRanges:  Array< {
      __typename: "TimezoneRange",
      start: number | null,
      end: number | null,
    } | null > | null,
    wageIsHourly: boolean | null,
    willSponsor: boolean | null,
    workFromAnywhere: boolean | null,
  } | null > | null,
};
